'use strict';

var web3_js = require('@solana/web3.js');
var anchor = require('@coral-xyz/anchor');
var require$$0$1 = require('buffer');
var require$$0 = require('crypto');
var require$$1 = require('util');

const IDL$3 = {
    version: '1.2.0',
    name: 'light_system_program',
    constants: [
        {
            name: 'SOL_POOL_PDA_SEED',
            type: 'bytes',
            value: '[115, 111, 108, 95, 112, 111, 111, 108, 95, 112, 100, 97]',
        },
    ],
    instructions: [
        {
            name: 'initCpiContextAccount',
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'cpiContextAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'associatedMerkleTree',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: 'invoke',
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: [
                        'Fee payer needs to be mutable to pay rollover and protocol fees.',
                    ],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                    docs: [
                        'This pda is used to invoke the account compression program.',
                    ],
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                    docs: ['Merkle trees.'],
                },
                {
                    name: 'solPoolPda',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                    docs: [
                        'Sol pool pda is used to store the native sol that has been compressed.',
                        "It's only required when compressing or decompressing sol.",
                    ],
                },
                {
                    name: 'decompressionRecipient',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                    docs: [
                        'Only needs to be provided for decompression as a recipient for the',
                        'decompressed sol.',
                        'Compressed sol originate from authority.',
                    ],
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'inputs',
                    type: 'bytes',
                },
            ],
        },
        {
            name: 'invokeCpi',
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: [
                        'Fee payer needs to be mutable to pay rollover and protocol fees.',
                    ],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'invokingProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'solPoolPda',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'decompressionRecipient',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'cpiContextAccount',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
            ],
            args: [
                {
                    name: 'inputs',
                    type: 'bytes',
                },
            ],
        },
        {
            name: 'stubIdlBuild',
            docs: [
                'This function is a stub to allow Anchor to include the input types in',
                'the IDL. It should not be included in production builds nor be called in',
                'practice.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: [
                        'Fee payer needs to be mutable to pay rollover and protocol fees.',
                    ],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                    docs: [
                        'This pda is used to invoke the account compression program.',
                    ],
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                    docs: ['Merkle trees.'],
                },
                {
                    name: 'solPoolPda',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                    docs: [
                        'Sol pool pda is used to store the native sol that has been compressed.',
                        "It's only required when compressing or decompressing sol.",
                    ],
                },
                {
                    name: 'decompressionRecipient',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                    docs: [
                        'Only needs to be provided for decompression as a recipient for the',
                        'decompressed sol.',
                        'Compressed sol originate from authority.',
                    ],
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'inputs1',
                    type: {
                        defined: 'InstructionDataInvoke',
                    },
                },
                {
                    name: 'inputs2',
                    type: {
                        defined: 'InstructionDataInvokeCpi',
                    },
                },
                {
                    name: 'inputs3',
                    type: {
                        defined: 'PublicTransactionEvent',
                    },
                },
            ],
        },
    ],
    accounts: [
        {
            name: 'stateMerkleTreeAccount',
            docs: [
                'Concurrent state Merkle tree used for public compressed transactions.',
            ],
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'metadata',
                        type: {
                            defined: 'MerkleTreeMetadata',
                        },
                    },
                ],
            },
        },
        {
            name: 'cpiContextAccount',
            docs: [
                'Collects instruction data without executing a compressed transaction.',
                'Signer checks are performed on instruction data.',
                'Collected instruction data is combined with the instruction data of the executing cpi,',
                'and executed as a single transaction.',
                'This enables to use input compressed accounts that are owned by multiple programs,',
                'with one zero-knowledge proof.',
            ],
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'feePayer',
                        type: 'publicKey',
                    },
                    {
                        name: 'associatedMerkleTree',
                        type: 'publicKey',
                    },
                    {
                        name: 'context',
                        type: {
                            vec: {
                                defined: 'InstructionDataInvokeCpi',
                            },
                        },
                    },
                ],
            },
        },
    ],
    types: [
        {
            name: 'AccessMetadata',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'owner',
                        docs: ['Owner of the Merkle tree.'],
                        type: 'publicKey',
                    },
                    {
                        name: 'programOwner',
                        docs: [
                            'Program owner of the Merkle tree. This will be used for program owned Merkle trees.',
                        ],
                        type: 'publicKey',
                    },
                    {
                        name: 'forester',
                        docs: [
                            'Optional privileged forester pubkey, can be set for custom Merkle trees',
                            'without a network fee. Merkle trees without network fees are not',
                            'forested by light foresters. The variable is not used in the account',
                            'compression program but the registry program. The registry program',
                            'implements access control to prevent contention during forester. The',
                            'forester pubkey specified in this struct can bypass contention checks.',
                        ],
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'MerkleTreeMetadata',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'accessMetadata',
                        type: {
                            defined: 'AccessMetadata',
                        },
                    },
                    {
                        name: 'rolloverMetadata',
                        type: {
                            defined: 'RolloverMetadata',
                        },
                    },
                    {
                        name: 'associatedQueue',
                        type: 'publicKey',
                    },
                    {
                        name: 'nextMerkleTree',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'RolloverMetadata',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'index',
                        docs: ['Unique index.'],
                        type: 'u64',
                    },
                    {
                        name: 'rolloverFee',
                        docs: [
                            'This fee is used for rent for the next account.',
                            'It accumulates in the account so that once the corresponding Merkle tree account is full it can be rolled over',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'rolloverThreshold',
                        docs: [
                            'The threshold in percentage points when the account should be rolled over (95 corresponds to 95% filled).',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'networkFee',
                        docs: ['Tip for maintaining the account.'],
                        type: 'u64',
                    },
                    {
                        name: 'rolledoverSlot',
                        docs: [
                            'The slot when the account was rolled over, a rolled over account should not be written to.',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'closeThreshold',
                        docs: [
                            'If current slot is greater than rolledover_slot + close_threshold and',
                            "the account is empty it can be closed. No 'close' functionality has been",
                            'implemented yet.',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'additionalBytes',
                        docs: [
                            'Placeholder for bytes of additional accounts which are tied to the',
                            'Merkle trees operation and need to be rolled over as well.',
                        ],
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'InstructionDataInvoke',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'proof',
                        type: {
                            option: {
                                defined: 'CompressedProof',
                            },
                        },
                    },
                    {
                        name: 'inputCompressedAccountsWithMerkleContext',
                        type: {
                            vec: {
                                defined:
                                    'PackedCompressedAccountWithMerkleContext',
                            },
                        },
                    },
                    {
                        name: 'outputCompressedAccounts',
                        type: {
                            vec: {
                                defined:
                                    'OutputCompressedAccountWithPackedContext',
                            },
                        },
                    },
                    {
                        name: 'relayFee',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'newAddressParams',
                        type: {
                            vec: {
                                defined: 'NewAddressParamsPacked',
                            },
                        },
                    },
                    {
                        name: 'compressOrDecompressLamports',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'isCompress',
                        type: 'bool',
                    },
                ],
            },
        },
        {
            name: 'NewAddressParamsPacked',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'seed',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'addressQueueAccountIndex',
                        type: 'u8',
                    },
                    {
                        name: 'addressMerkleTreeAccountIndex',
                        type: 'u8',
                    },
                    {
                        name: 'addressMerkleTreeRootIndex',
                        type: 'u16',
                    },
                ],
            },
        },
        {
            name: 'OutputCompressedAccountWithPackedContext',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'compressedAccount',
                        type: {
                            defined: 'CompressedAccount',
                        },
                    },
                    {
                        name: 'merkleTreeIndex',
                        type: 'u8',
                    },
                ],
            },
        },
        {
            name: 'CompressedProof',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'a',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'b',
                        type: {
                            array: ['u8', 64],
                        },
                    },
                    {
                        name: 'c',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                ],
            },
        },
        {
            name: 'InstructionDataInvokeCpi',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'proof',
                        type: {
                            option: {
                                defined: 'CompressedProof',
                            },
                        },
                    },
                    {
                        name: 'newAddressParams',
                        type: {
                            vec: {
                                defined: 'NewAddressParamsPacked',
                            },
                        },
                    },
                    {
                        name: 'inputCompressedAccountsWithMerkleContext',
                        type: {
                            vec: {
                                defined:
                                    'PackedCompressedAccountWithMerkleContext',
                            },
                        },
                    },
                    {
                        name: 'outputCompressedAccounts',
                        type: {
                            vec: {
                                defined:
                                    'OutputCompressedAccountWithPackedContext',
                            },
                        },
                    },
                    {
                        name: 'relayFee',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'compressOrDecompressLamports',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'isCompress',
                        type: 'bool',
                    },
                    {
                        name: 'cpiContext',
                        type: {
                            option: {
                                defined: 'CompressedCpiContext',
                            },
                        },
                    },
                ],
            },
        },
        {
            name: 'CompressedCpiContext',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'setContext',
                        docs: [
                            'Is set by the program that is invoking the CPI to signal that is should',
                            'set the cpi context.',
                        ],
                        type: 'bool',
                    },
                    {
                        name: 'firstSetContext',
                        docs: [
                            'Is set to wipe the cpi context since someone could have set it before',
                            'with unrelated data.',
                        ],
                        type: 'bool',
                    },
                    {
                        name: 'cpiContextAccountIndex',
                        docs: [
                            'Index of cpi context account in remaining accounts.',
                        ],
                        type: 'u8',
                    },
                ],
            },
        },
        {
            name: 'CompressedAccount',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'owner',
                        type: 'publicKey',
                    },
                    {
                        name: 'lamports',
                        type: 'u64',
                    },
                    {
                        name: 'address',
                        type: {
                            option: {
                                array: ['u8', 32],
                            },
                        },
                    },
                    {
                        name: 'data',
                        type: {
                            option: {
                                defined: 'CompressedAccountData',
                            },
                        },
                    },
                ],
            },
        },
        {
            name: 'CompressedAccountData',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'discriminator',
                        type: {
                            array: ['u8', 8],
                        },
                    },
                    {
                        name: 'data',
                        type: 'bytes',
                    },
                    {
                        name: 'dataHash',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                ],
            },
        },
        {
            name: 'PackedCompressedAccountWithMerkleContext',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'compressedAccount',
                        type: {
                            defined: 'CompressedAccount',
                        },
                    },
                    {
                        name: 'merkleContext',
                        type: {
                            defined: 'PackedMerkleContext',
                        },
                    },
                    {
                        name: 'rootIndex',
                        docs: [
                            'Index of root used in inclusion validity proof.',
                        ],
                        type: 'u16',
                    },
                    {
                        name: 'readOnly',
                        docs: [
                            'Placeholder to mark accounts read-only unimplemented set to false.',
                        ],
                        type: 'bool',
                    },
                ],
            },
        },
        {
            name: 'PackedMerkleContext',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'merkleTreePubkeyIndex',
                        type: 'u8',
                    },
                    {
                        name: 'nullifierQueuePubkeyIndex',
                        type: 'u8',
                    },
                    {
                        name: 'leafIndex',
                        type: 'u32',
                    },
                    {
                        name: 'queueIndex',
                        docs: [
                            'Index of leaf in queue. Placeholder of batched Merkle tree updates',
                            'currently unimplemented.',
                        ],
                        type: {
                            option: {
                                defined: 'QueueIndex',
                            },
                        },
                    },
                ],
            },
        },
        {
            name: 'QueueIndex',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'queueId',
                        docs: ['Id of queue in queue account.'],
                        type: 'u8',
                    },
                    {
                        name: 'index',
                        docs: ['Index of compressed account hash in queue.'],
                        type: 'u16',
                    },
                ],
            },
        },
        {
            name: 'MerkleTreeSequenceNumber',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'pubkey',
                        type: 'publicKey',
                    },
                    {
                        name: 'seq',
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'PublicTransactionEvent',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'inputCompressedAccountHashes',
                        type: {
                            vec: {
                                array: ['u8', 32],
                            },
                        },
                    },
                    {
                        name: 'outputCompressedAccountHashes',
                        type: {
                            vec: {
                                array: ['u8', 32],
                            },
                        },
                    },
                    {
                        name: 'outputCompressedAccounts',
                        type: {
                            vec: {
                                defined:
                                    'OutputCompressedAccountWithPackedContext',
                            },
                        },
                    },
                    {
                        name: 'outputLeafIndices',
                        type: {
                            vec: 'u32',
                        },
                    },
                    {
                        name: 'sequenceNumbers',
                        type: {
                            vec: {
                                defined: 'MerkleTreeSequenceNumber',
                            },
                        },
                    },
                    {
                        name: 'relayFee',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'isCompress',
                        type: 'bool',
                    },
                    {
                        name: 'compressOrDecompressLamports',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'pubkeyArray',
                        type: {
                            vec: 'publicKey',
                        },
                    },
                    {
                        name: 'message',
                        type: {
                            option: 'bytes',
                        },
                    },
                ],
            },
        },
    ],
    errors: [
        {
            code: 6000,
            name: 'SumCheckFailed',
            msg: 'Sum check failed',
        },
        {
            code: 6001,
            name: 'SignerCheckFailed',
            msg: 'Signer check failed',
        },
        {
            code: 6002,
            name: 'CpiSignerCheckFailed',
            msg: 'Cpi signer check failed',
        },
        {
            code: 6003,
            name: 'ComputeInputSumFailed',
            msg: 'Computing input sum failed.',
        },
        {
            code: 6004,
            name: 'ComputeOutputSumFailed',
            msg: 'Computing output sum failed.',
        },
        {
            code: 6005,
            name: 'ComputeRpcSumFailed',
            msg: 'Computing rpc sum failed.',
        },
        {
            code: 6006,
            name: 'InvalidAddress',
            msg: 'InvalidAddress',
        },
        {
            code: 6007,
            name: 'DeriveAddressError',
            msg: 'DeriveAddressError',
        },
        {
            code: 6008,
            name: 'CompressedSolPdaUndefinedForCompressSol',
            msg: 'CompressedSolPdaUndefinedForCompressSol',
        },
        {
            code: 6009,
            name: 'DeCompressLamportsUndefinedForCompressSol',
            msg: 'DeCompressLamportsUndefinedForCompressSol',
        },
        {
            code: 6010,
            name: 'CompressedSolPdaUndefinedForDecompressSol',
            msg: 'CompressedSolPdaUndefinedForDecompressSol',
        },
        {
            code: 6011,
            name: 'DeCompressLamportsUndefinedForDecompressSol',
            msg: 'DeCompressLamportsUndefinedForDecompressSol',
        },
        {
            code: 6012,
            name: 'DecompressRecipientUndefinedForDecompressSol',
            msg: 'DecompressRecipientUndefinedForDecompressSol',
        },
        {
            code: 6013,
            name: 'WriteAccessCheckFailed',
            msg: 'WriteAccessCheckFailed',
        },
        {
            code: 6014,
            name: 'InvokingProgramNotProvided',
            msg: 'InvokingProgramNotProvided',
        },
        {
            code: 6015,
            name: 'InvalidCapacity',
            msg: 'InvalidCapacity',
        },
        {
            code: 6016,
            name: 'InvalidMerkleTreeOwner',
            msg: 'InvalidMerkleTreeOwner',
        },
        {
            code: 6017,
            name: 'ProofIsNone',
            msg: 'ProofIsNone',
        },
        {
            code: 6018,
            name: 'ProofIsSome',
            msg: 'Proof is some but no input compressed accounts or new addresses provided.',
        },
        {
            code: 6019,
            name: 'EmptyInputs',
            msg: 'EmptyInputs',
        },
        {
            code: 6020,
            name: 'CpiContextAccountUndefined',
            msg: 'CpiContextAccountUndefined',
        },
        {
            code: 6021,
            name: 'CpiContextEmpty',
            msg: 'CpiContextEmpty',
        },
        {
            code: 6022,
            name: 'CpiContextMissing',
            msg: 'CpiContextMissing',
        },
        {
            code: 6023,
            name: 'DecompressionRecipientDefined',
            msg: 'DecompressionRecipientDefined',
        },
        {
            code: 6024,
            name: 'SolPoolPdaDefined',
            msg: 'SolPoolPdaDefined',
        },
        {
            code: 6025,
            name: 'AppendStateFailed',
            msg: 'AppendStateFailed',
        },
        {
            code: 6026,
            name: 'InstructionNotCallable',
            msg: 'The instruction is not callable',
        },
        {
            code: 6027,
            name: 'CpiContextFeePayerMismatch',
            msg: 'CpiContextFeePayerMismatch',
        },
        {
            code: 6028,
            name: 'CpiContextAssociatedMerkleTreeMismatch',
            msg: 'CpiContextAssociatedMerkleTreeMismatch',
        },
        {
            code: 6029,
            name: 'NoInputs',
            msg: 'NoInputs',
        },
        {
            code: 6030,
            name: 'InputMerkleTreeIndicesNotInOrder',
            msg: 'Input merkle tree indices are not in ascending order.',
        },
        {
            code: 6031,
            name: 'OutputMerkleTreeIndicesNotInOrder',
            msg: 'Output merkle tree indices are not in ascending order.',
        },
        {
            code: 6032,
            name: 'OutputMerkleTreeNotUnique',
        },
        {
            code: 6033,
            name: 'DataFieldUndefined',
        },
    ],
};

var commonjsGlobal =
    typeof globalThis !== 'undefined'
        ? globalThis
        : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
            ? global
            : typeof self !== 'undefined'
              ? self
              : {};

function getDefaultExportFromCjs(x) {
    return x &&
        x.__esModule &&
        Object.prototype.hasOwnProperty.call(x, 'default')
        ? x['default']
        : x;
}

function commonjsRequire(path) {
    throw new Error(
        'Could not dynamically require "' +
            path +
            '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.',
    );
}

var naclFast = { exports: {} };

(function (module) {
    (function (nacl) {
        // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
        // Public domain.
        //
        // Implementation derived from TweetNaCl version 20140427.
        // See for details: http://tweetnacl.cr.yp.to/

        var gf = function (init) {
            var i,
                r = new Float64Array(16);
            if (init) for (i = 0; i < init.length; i++) r[i] = init[i];
            return r;
        };

        //  Pluggable, initialized in high-level API below.
        var randombytes = function (/* x, n */) {
            throw new Error('no PRNG');
        };

        var _0 = new Uint8Array(16);
        var _9 = new Uint8Array(32);
        _9[0] = 9;

        var gf0 = gf(),
            gf1 = gf([1]),
            _121665 = gf([0xdb41, 1]),
            D = gf([
                0x78a3, 0x1359, 0x4dca, 0x75eb, 0xd8ab, 0x4141, 0x0a4d, 0x0070,
                0xe898, 0x7779, 0x4079, 0x8cc7, 0xfe73, 0x2b6f, 0x6cee, 0x5203,
            ]),
            D2 = gf([
                0xf159, 0x26b2, 0x9b94, 0xebd6, 0xb156, 0x8283, 0x149a, 0x00e0,
                0xd130, 0xeef3, 0x80f2, 0x198e, 0xfce7, 0x56df, 0xd9dc, 0x2406,
            ]),
            X = gf([
                0xd51a, 0x8f25, 0x2d60, 0xc956, 0xa7b2, 0x9525, 0xc760, 0x692c,
                0xdc5c, 0xfdd6, 0xe231, 0xc0a4, 0x53fe, 0xcd6e, 0x36d3, 0x2169,
            ]),
            Y = gf([
                0x6658, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666,
                0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666,
            ]),
            I = gf([
                0xa0b0, 0x4a0e, 0x1b27, 0xc4ee, 0xe478, 0xad2f, 0x1806, 0x2f43,
                0xd7a7, 0x3dfb, 0x0099, 0x2b4d, 0xdf0b, 0x4fc1, 0x2480, 0x2b83,
            ]);

        function ts64(x, i, h, l) {
            x[i] = (h >> 24) & 0xff;
            x[i + 1] = (h >> 16) & 0xff;
            x[i + 2] = (h >> 8) & 0xff;
            x[i + 3] = h & 0xff;
            x[i + 4] = (l >> 24) & 0xff;
            x[i + 5] = (l >> 16) & 0xff;
            x[i + 6] = (l >> 8) & 0xff;
            x[i + 7] = l & 0xff;
        }

        function vn(x, xi, y, yi, n) {
            var i,
                d = 0;
            for (i = 0; i < n; i++) d |= x[xi + i] ^ y[yi + i];
            return (1 & ((d - 1) >>> 8)) - 1;
        }

        function crypto_verify_16(x, xi, y, yi) {
            return vn(x, xi, y, yi, 16);
        }

        function crypto_verify_32(x, xi, y, yi) {
            return vn(x, xi, y, yi, 32);
        }

        function core_salsa20(o, p, k, c) {
            var j0 =
                    (c[0] & 0xff) |
                    ((c[1] & 0xff) << 8) |
                    ((c[2] & 0xff) << 16) |
                    ((c[3] & 0xff) << 24),
                j1 =
                    (k[0] & 0xff) |
                    ((k[1] & 0xff) << 8) |
                    ((k[2] & 0xff) << 16) |
                    ((k[3] & 0xff) << 24),
                j2 =
                    (k[4] & 0xff) |
                    ((k[5] & 0xff) << 8) |
                    ((k[6] & 0xff) << 16) |
                    ((k[7] & 0xff) << 24),
                j3 =
                    (k[8] & 0xff) |
                    ((k[9] & 0xff) << 8) |
                    ((k[10] & 0xff) << 16) |
                    ((k[11] & 0xff) << 24),
                j4 =
                    (k[12] & 0xff) |
                    ((k[13] & 0xff) << 8) |
                    ((k[14] & 0xff) << 16) |
                    ((k[15] & 0xff) << 24),
                j5 =
                    (c[4] & 0xff) |
                    ((c[5] & 0xff) << 8) |
                    ((c[6] & 0xff) << 16) |
                    ((c[7] & 0xff) << 24),
                j6 =
                    (p[0] & 0xff) |
                    ((p[1] & 0xff) << 8) |
                    ((p[2] & 0xff) << 16) |
                    ((p[3] & 0xff) << 24),
                j7 =
                    (p[4] & 0xff) |
                    ((p[5] & 0xff) << 8) |
                    ((p[6] & 0xff) << 16) |
                    ((p[7] & 0xff) << 24),
                j8 =
                    (p[8] & 0xff) |
                    ((p[9] & 0xff) << 8) |
                    ((p[10] & 0xff) << 16) |
                    ((p[11] & 0xff) << 24),
                j9 =
                    (p[12] & 0xff) |
                    ((p[13] & 0xff) << 8) |
                    ((p[14] & 0xff) << 16) |
                    ((p[15] & 0xff) << 24),
                j10 =
                    (c[8] & 0xff) |
                    ((c[9] & 0xff) << 8) |
                    ((c[10] & 0xff) << 16) |
                    ((c[11] & 0xff) << 24),
                j11 =
                    (k[16] & 0xff) |
                    ((k[17] & 0xff) << 8) |
                    ((k[18] & 0xff) << 16) |
                    ((k[19] & 0xff) << 24),
                j12 =
                    (k[20] & 0xff) |
                    ((k[21] & 0xff) << 8) |
                    ((k[22] & 0xff) << 16) |
                    ((k[23] & 0xff) << 24),
                j13 =
                    (k[24] & 0xff) |
                    ((k[25] & 0xff) << 8) |
                    ((k[26] & 0xff) << 16) |
                    ((k[27] & 0xff) << 24),
                j14 =
                    (k[28] & 0xff) |
                    ((k[29] & 0xff) << 8) |
                    ((k[30] & 0xff) << 16) |
                    ((k[31] & 0xff) << 24),
                j15 =
                    (c[12] & 0xff) |
                    ((c[13] & 0xff) << 8) |
                    ((c[14] & 0xff) << 16) |
                    ((c[15] & 0xff) << 24);

            var x0 = j0,
                x1 = j1,
                x2 = j2,
                x3 = j3,
                x4 = j4,
                x5 = j5,
                x6 = j6,
                x7 = j7,
                x8 = j8,
                x9 = j9,
                x10 = j10,
                x11 = j11,
                x12 = j12,
                x13 = j13,
                x14 = j14,
                x15 = j15,
                u;

            for (var i = 0; i < 20; i += 2) {
                u = (x0 + x12) | 0;
                x4 ^= (u << 7) | (u >>> (32 - 7));
                u = (x4 + x0) | 0;
                x8 ^= (u << 9) | (u >>> (32 - 9));
                u = (x8 + x4) | 0;
                x12 ^= (u << 13) | (u >>> (32 - 13));
                u = (x12 + x8) | 0;
                x0 ^= (u << 18) | (u >>> (32 - 18));

                u = (x5 + x1) | 0;
                x9 ^= (u << 7) | (u >>> (32 - 7));
                u = (x9 + x5) | 0;
                x13 ^= (u << 9) | (u >>> (32 - 9));
                u = (x13 + x9) | 0;
                x1 ^= (u << 13) | (u >>> (32 - 13));
                u = (x1 + x13) | 0;
                x5 ^= (u << 18) | (u >>> (32 - 18));

                u = (x10 + x6) | 0;
                x14 ^= (u << 7) | (u >>> (32 - 7));
                u = (x14 + x10) | 0;
                x2 ^= (u << 9) | (u >>> (32 - 9));
                u = (x2 + x14) | 0;
                x6 ^= (u << 13) | (u >>> (32 - 13));
                u = (x6 + x2) | 0;
                x10 ^= (u << 18) | (u >>> (32 - 18));

                u = (x15 + x11) | 0;
                x3 ^= (u << 7) | (u >>> (32 - 7));
                u = (x3 + x15) | 0;
                x7 ^= (u << 9) | (u >>> (32 - 9));
                u = (x7 + x3) | 0;
                x11 ^= (u << 13) | (u >>> (32 - 13));
                u = (x11 + x7) | 0;
                x15 ^= (u << 18) | (u >>> (32 - 18));

                u = (x0 + x3) | 0;
                x1 ^= (u << 7) | (u >>> (32 - 7));
                u = (x1 + x0) | 0;
                x2 ^= (u << 9) | (u >>> (32 - 9));
                u = (x2 + x1) | 0;
                x3 ^= (u << 13) | (u >>> (32 - 13));
                u = (x3 + x2) | 0;
                x0 ^= (u << 18) | (u >>> (32 - 18));

                u = (x5 + x4) | 0;
                x6 ^= (u << 7) | (u >>> (32 - 7));
                u = (x6 + x5) | 0;
                x7 ^= (u << 9) | (u >>> (32 - 9));
                u = (x7 + x6) | 0;
                x4 ^= (u << 13) | (u >>> (32 - 13));
                u = (x4 + x7) | 0;
                x5 ^= (u << 18) | (u >>> (32 - 18));

                u = (x10 + x9) | 0;
                x11 ^= (u << 7) | (u >>> (32 - 7));
                u = (x11 + x10) | 0;
                x8 ^= (u << 9) | (u >>> (32 - 9));
                u = (x8 + x11) | 0;
                x9 ^= (u << 13) | (u >>> (32 - 13));
                u = (x9 + x8) | 0;
                x10 ^= (u << 18) | (u >>> (32 - 18));

                u = (x15 + x14) | 0;
                x12 ^= (u << 7) | (u >>> (32 - 7));
                u = (x12 + x15) | 0;
                x13 ^= (u << 9) | (u >>> (32 - 9));
                u = (x13 + x12) | 0;
                x14 ^= (u << 13) | (u >>> (32 - 13));
                u = (x14 + x13) | 0;
                x15 ^= (u << 18) | (u >>> (32 - 18));
            }
            x0 = (x0 + j0) | 0;
            x1 = (x1 + j1) | 0;
            x2 = (x2 + j2) | 0;
            x3 = (x3 + j3) | 0;
            x4 = (x4 + j4) | 0;
            x5 = (x5 + j5) | 0;
            x6 = (x6 + j6) | 0;
            x7 = (x7 + j7) | 0;
            x8 = (x8 + j8) | 0;
            x9 = (x9 + j9) | 0;
            x10 = (x10 + j10) | 0;
            x11 = (x11 + j11) | 0;
            x12 = (x12 + j12) | 0;
            x13 = (x13 + j13) | 0;
            x14 = (x14 + j14) | 0;
            x15 = (x15 + j15) | 0;

            o[0] = (x0 >>> 0) & 0xff;
            o[1] = (x0 >>> 8) & 0xff;
            o[2] = (x0 >>> 16) & 0xff;
            o[3] = (x0 >>> 24) & 0xff;

            o[4] = (x1 >>> 0) & 0xff;
            o[5] = (x1 >>> 8) & 0xff;
            o[6] = (x1 >>> 16) & 0xff;
            o[7] = (x1 >>> 24) & 0xff;

            o[8] = (x2 >>> 0) & 0xff;
            o[9] = (x2 >>> 8) & 0xff;
            o[10] = (x2 >>> 16) & 0xff;
            o[11] = (x2 >>> 24) & 0xff;

            o[12] = (x3 >>> 0) & 0xff;
            o[13] = (x3 >>> 8) & 0xff;
            o[14] = (x3 >>> 16) & 0xff;
            o[15] = (x3 >>> 24) & 0xff;

            o[16] = (x4 >>> 0) & 0xff;
            o[17] = (x4 >>> 8) & 0xff;
            o[18] = (x4 >>> 16) & 0xff;
            o[19] = (x4 >>> 24) & 0xff;

            o[20] = (x5 >>> 0) & 0xff;
            o[21] = (x5 >>> 8) & 0xff;
            o[22] = (x5 >>> 16) & 0xff;
            o[23] = (x5 >>> 24) & 0xff;

            o[24] = (x6 >>> 0) & 0xff;
            o[25] = (x6 >>> 8) & 0xff;
            o[26] = (x6 >>> 16) & 0xff;
            o[27] = (x6 >>> 24) & 0xff;

            o[28] = (x7 >>> 0) & 0xff;
            o[29] = (x7 >>> 8) & 0xff;
            o[30] = (x7 >>> 16) & 0xff;
            o[31] = (x7 >>> 24) & 0xff;

            o[32] = (x8 >>> 0) & 0xff;
            o[33] = (x8 >>> 8) & 0xff;
            o[34] = (x8 >>> 16) & 0xff;
            o[35] = (x8 >>> 24) & 0xff;

            o[36] = (x9 >>> 0) & 0xff;
            o[37] = (x9 >>> 8) & 0xff;
            o[38] = (x9 >>> 16) & 0xff;
            o[39] = (x9 >>> 24) & 0xff;

            o[40] = (x10 >>> 0) & 0xff;
            o[41] = (x10 >>> 8) & 0xff;
            o[42] = (x10 >>> 16) & 0xff;
            o[43] = (x10 >>> 24) & 0xff;

            o[44] = (x11 >>> 0) & 0xff;
            o[45] = (x11 >>> 8) & 0xff;
            o[46] = (x11 >>> 16) & 0xff;
            o[47] = (x11 >>> 24) & 0xff;

            o[48] = (x12 >>> 0) & 0xff;
            o[49] = (x12 >>> 8) & 0xff;
            o[50] = (x12 >>> 16) & 0xff;
            o[51] = (x12 >>> 24) & 0xff;

            o[52] = (x13 >>> 0) & 0xff;
            o[53] = (x13 >>> 8) & 0xff;
            o[54] = (x13 >>> 16) & 0xff;
            o[55] = (x13 >>> 24) & 0xff;

            o[56] = (x14 >>> 0) & 0xff;
            o[57] = (x14 >>> 8) & 0xff;
            o[58] = (x14 >>> 16) & 0xff;
            o[59] = (x14 >>> 24) & 0xff;

            o[60] = (x15 >>> 0) & 0xff;
            o[61] = (x15 >>> 8) & 0xff;
            o[62] = (x15 >>> 16) & 0xff;
            o[63] = (x15 >>> 24) & 0xff;
        }

        function core_hsalsa20(o, p, k, c) {
            var j0 =
                    (c[0] & 0xff) |
                    ((c[1] & 0xff) << 8) |
                    ((c[2] & 0xff) << 16) |
                    ((c[3] & 0xff) << 24),
                j1 =
                    (k[0] & 0xff) |
                    ((k[1] & 0xff) << 8) |
                    ((k[2] & 0xff) << 16) |
                    ((k[3] & 0xff) << 24),
                j2 =
                    (k[4] & 0xff) |
                    ((k[5] & 0xff) << 8) |
                    ((k[6] & 0xff) << 16) |
                    ((k[7] & 0xff) << 24),
                j3 =
                    (k[8] & 0xff) |
                    ((k[9] & 0xff) << 8) |
                    ((k[10] & 0xff) << 16) |
                    ((k[11] & 0xff) << 24),
                j4 =
                    (k[12] & 0xff) |
                    ((k[13] & 0xff) << 8) |
                    ((k[14] & 0xff) << 16) |
                    ((k[15] & 0xff) << 24),
                j5 =
                    (c[4] & 0xff) |
                    ((c[5] & 0xff) << 8) |
                    ((c[6] & 0xff) << 16) |
                    ((c[7] & 0xff) << 24),
                j6 =
                    (p[0] & 0xff) |
                    ((p[1] & 0xff) << 8) |
                    ((p[2] & 0xff) << 16) |
                    ((p[3] & 0xff) << 24),
                j7 =
                    (p[4] & 0xff) |
                    ((p[5] & 0xff) << 8) |
                    ((p[6] & 0xff) << 16) |
                    ((p[7] & 0xff) << 24),
                j8 =
                    (p[8] & 0xff) |
                    ((p[9] & 0xff) << 8) |
                    ((p[10] & 0xff) << 16) |
                    ((p[11] & 0xff) << 24),
                j9 =
                    (p[12] & 0xff) |
                    ((p[13] & 0xff) << 8) |
                    ((p[14] & 0xff) << 16) |
                    ((p[15] & 0xff) << 24),
                j10 =
                    (c[8] & 0xff) |
                    ((c[9] & 0xff) << 8) |
                    ((c[10] & 0xff) << 16) |
                    ((c[11] & 0xff) << 24),
                j11 =
                    (k[16] & 0xff) |
                    ((k[17] & 0xff) << 8) |
                    ((k[18] & 0xff) << 16) |
                    ((k[19] & 0xff) << 24),
                j12 =
                    (k[20] & 0xff) |
                    ((k[21] & 0xff) << 8) |
                    ((k[22] & 0xff) << 16) |
                    ((k[23] & 0xff) << 24),
                j13 =
                    (k[24] & 0xff) |
                    ((k[25] & 0xff) << 8) |
                    ((k[26] & 0xff) << 16) |
                    ((k[27] & 0xff) << 24),
                j14 =
                    (k[28] & 0xff) |
                    ((k[29] & 0xff) << 8) |
                    ((k[30] & 0xff) << 16) |
                    ((k[31] & 0xff) << 24),
                j15 =
                    (c[12] & 0xff) |
                    ((c[13] & 0xff) << 8) |
                    ((c[14] & 0xff) << 16) |
                    ((c[15] & 0xff) << 24);

            var x0 = j0,
                x1 = j1,
                x2 = j2,
                x3 = j3,
                x4 = j4,
                x5 = j5,
                x6 = j6,
                x7 = j7,
                x8 = j8,
                x9 = j9,
                x10 = j10,
                x11 = j11,
                x12 = j12,
                x13 = j13,
                x14 = j14,
                x15 = j15,
                u;

            for (var i = 0; i < 20; i += 2) {
                u = (x0 + x12) | 0;
                x4 ^= (u << 7) | (u >>> (32 - 7));
                u = (x4 + x0) | 0;
                x8 ^= (u << 9) | (u >>> (32 - 9));
                u = (x8 + x4) | 0;
                x12 ^= (u << 13) | (u >>> (32 - 13));
                u = (x12 + x8) | 0;
                x0 ^= (u << 18) | (u >>> (32 - 18));

                u = (x5 + x1) | 0;
                x9 ^= (u << 7) | (u >>> (32 - 7));
                u = (x9 + x5) | 0;
                x13 ^= (u << 9) | (u >>> (32 - 9));
                u = (x13 + x9) | 0;
                x1 ^= (u << 13) | (u >>> (32 - 13));
                u = (x1 + x13) | 0;
                x5 ^= (u << 18) | (u >>> (32 - 18));

                u = (x10 + x6) | 0;
                x14 ^= (u << 7) | (u >>> (32 - 7));
                u = (x14 + x10) | 0;
                x2 ^= (u << 9) | (u >>> (32 - 9));
                u = (x2 + x14) | 0;
                x6 ^= (u << 13) | (u >>> (32 - 13));
                u = (x6 + x2) | 0;
                x10 ^= (u << 18) | (u >>> (32 - 18));

                u = (x15 + x11) | 0;
                x3 ^= (u << 7) | (u >>> (32 - 7));
                u = (x3 + x15) | 0;
                x7 ^= (u << 9) | (u >>> (32 - 9));
                u = (x7 + x3) | 0;
                x11 ^= (u << 13) | (u >>> (32 - 13));
                u = (x11 + x7) | 0;
                x15 ^= (u << 18) | (u >>> (32 - 18));

                u = (x0 + x3) | 0;
                x1 ^= (u << 7) | (u >>> (32 - 7));
                u = (x1 + x0) | 0;
                x2 ^= (u << 9) | (u >>> (32 - 9));
                u = (x2 + x1) | 0;
                x3 ^= (u << 13) | (u >>> (32 - 13));
                u = (x3 + x2) | 0;
                x0 ^= (u << 18) | (u >>> (32 - 18));

                u = (x5 + x4) | 0;
                x6 ^= (u << 7) | (u >>> (32 - 7));
                u = (x6 + x5) | 0;
                x7 ^= (u << 9) | (u >>> (32 - 9));
                u = (x7 + x6) | 0;
                x4 ^= (u << 13) | (u >>> (32 - 13));
                u = (x4 + x7) | 0;
                x5 ^= (u << 18) | (u >>> (32 - 18));

                u = (x10 + x9) | 0;
                x11 ^= (u << 7) | (u >>> (32 - 7));
                u = (x11 + x10) | 0;
                x8 ^= (u << 9) | (u >>> (32 - 9));
                u = (x8 + x11) | 0;
                x9 ^= (u << 13) | (u >>> (32 - 13));
                u = (x9 + x8) | 0;
                x10 ^= (u << 18) | (u >>> (32 - 18));

                u = (x15 + x14) | 0;
                x12 ^= (u << 7) | (u >>> (32 - 7));
                u = (x12 + x15) | 0;
                x13 ^= (u << 9) | (u >>> (32 - 9));
                u = (x13 + x12) | 0;
                x14 ^= (u << 13) | (u >>> (32 - 13));
                u = (x14 + x13) | 0;
                x15 ^= (u << 18) | (u >>> (32 - 18));
            }

            o[0] = (x0 >>> 0) & 0xff;
            o[1] = (x0 >>> 8) & 0xff;
            o[2] = (x0 >>> 16) & 0xff;
            o[3] = (x0 >>> 24) & 0xff;

            o[4] = (x5 >>> 0) & 0xff;
            o[5] = (x5 >>> 8) & 0xff;
            o[6] = (x5 >>> 16) & 0xff;
            o[7] = (x5 >>> 24) & 0xff;

            o[8] = (x10 >>> 0) & 0xff;
            o[9] = (x10 >>> 8) & 0xff;
            o[10] = (x10 >>> 16) & 0xff;
            o[11] = (x10 >>> 24) & 0xff;

            o[12] = (x15 >>> 0) & 0xff;
            o[13] = (x15 >>> 8) & 0xff;
            o[14] = (x15 >>> 16) & 0xff;
            o[15] = (x15 >>> 24) & 0xff;

            o[16] = (x6 >>> 0) & 0xff;
            o[17] = (x6 >>> 8) & 0xff;
            o[18] = (x6 >>> 16) & 0xff;
            o[19] = (x6 >>> 24) & 0xff;

            o[20] = (x7 >>> 0) & 0xff;
            o[21] = (x7 >>> 8) & 0xff;
            o[22] = (x7 >>> 16) & 0xff;
            o[23] = (x7 >>> 24) & 0xff;

            o[24] = (x8 >>> 0) & 0xff;
            o[25] = (x8 >>> 8) & 0xff;
            o[26] = (x8 >>> 16) & 0xff;
            o[27] = (x8 >>> 24) & 0xff;

            o[28] = (x9 >>> 0) & 0xff;
            o[29] = (x9 >>> 8) & 0xff;
            o[30] = (x9 >>> 16) & 0xff;
            o[31] = (x9 >>> 24) & 0xff;
        }

        function crypto_core_salsa20(out, inp, k, c) {
            core_salsa20(out, inp, k, c);
        }

        function crypto_core_hsalsa20(out, inp, k, c) {
            core_hsalsa20(out, inp, k, c);
        }

        var sigma = new Uint8Array([
            101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32,
            107,
        ]);
        // "expand 32-byte k"

        function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
            var z = new Uint8Array(16),
                x = new Uint8Array(64);
            var u, i;
            for (i = 0; i < 16; i++) z[i] = 0;
            for (i = 0; i < 8; i++) z[i] = n[i];
            while (b >= 64) {
                crypto_core_salsa20(x, z, k, sigma);
                for (i = 0; i < 64; i++) c[cpos + i] = m[mpos + i] ^ x[i];
                u = 1;
                for (i = 8; i < 16; i++) {
                    u = (u + (z[i] & 0xff)) | 0;
                    z[i] = u & 0xff;
                    u >>>= 8;
                }
                b -= 64;
                cpos += 64;
                mpos += 64;
            }
            if (b > 0) {
                crypto_core_salsa20(x, z, k, sigma);
                for (i = 0; i < b; i++) c[cpos + i] = m[mpos + i] ^ x[i];
            }
            return 0;
        }

        function crypto_stream_salsa20(c, cpos, b, n, k) {
            var z = new Uint8Array(16),
                x = new Uint8Array(64);
            var u, i;
            for (i = 0; i < 16; i++) z[i] = 0;
            for (i = 0; i < 8; i++) z[i] = n[i];
            while (b >= 64) {
                crypto_core_salsa20(x, z, k, sigma);
                for (i = 0; i < 64; i++) c[cpos + i] = x[i];
                u = 1;
                for (i = 8; i < 16; i++) {
                    u = (u + (z[i] & 0xff)) | 0;
                    z[i] = u & 0xff;
                    u >>>= 8;
                }
                b -= 64;
                cpos += 64;
            }
            if (b > 0) {
                crypto_core_salsa20(x, z, k, sigma);
                for (i = 0; i < b; i++) c[cpos + i] = x[i];
            }
            return 0;
        }

        function crypto_stream(c, cpos, d, n, k) {
            var s = new Uint8Array(32);
            crypto_core_hsalsa20(s, n, k, sigma);
            var sn = new Uint8Array(8);
            for (var i = 0; i < 8; i++) sn[i] = n[i + 16];
            return crypto_stream_salsa20(c, cpos, d, sn, s);
        }

        function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
            var s = new Uint8Array(32);
            crypto_core_hsalsa20(s, n, k, sigma);
            var sn = new Uint8Array(8);
            for (var i = 0; i < 8; i++) sn[i] = n[i + 16];
            return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
        }

        /*
         * Port of Andrew Moon's Poly1305-donna-16. Public domain.
         * https://github.com/floodyberry/poly1305-donna
         */

        var poly1305 = function (key) {
            this.buffer = new Uint8Array(16);
            this.r = new Uint16Array(10);
            this.h = new Uint16Array(10);
            this.pad = new Uint16Array(8);
            this.leftover = 0;
            this.fin = 0;

            var t0, t1, t2, t3, t4, t5, t6, t7;

            t0 = (key[0] & 0xff) | ((key[1] & 0xff) << 8);
            this.r[0] = t0 & 0x1fff;
            t1 = (key[2] & 0xff) | ((key[3] & 0xff) << 8);
            this.r[1] = ((t0 >>> 13) | (t1 << 3)) & 0x1fff;
            t2 = (key[4] & 0xff) | ((key[5] & 0xff) << 8);
            this.r[2] = ((t1 >>> 10) | (t2 << 6)) & 0x1f03;
            t3 = (key[6] & 0xff) | ((key[7] & 0xff) << 8);
            this.r[3] = ((t2 >>> 7) | (t3 << 9)) & 0x1fff;
            t4 = (key[8] & 0xff) | ((key[9] & 0xff) << 8);
            this.r[4] = ((t3 >>> 4) | (t4 << 12)) & 0x00ff;
            this.r[5] = (t4 >>> 1) & 0x1ffe;
            t5 = (key[10] & 0xff) | ((key[11] & 0xff) << 8);
            this.r[6] = ((t4 >>> 14) | (t5 << 2)) & 0x1fff;
            t6 = (key[12] & 0xff) | ((key[13] & 0xff) << 8);
            this.r[7] = ((t5 >>> 11) | (t6 << 5)) & 0x1f81;
            t7 = (key[14] & 0xff) | ((key[15] & 0xff) << 8);
            this.r[8] = ((t6 >>> 8) | (t7 << 8)) & 0x1fff;
            this.r[9] = (t7 >>> 5) & 0x007f;

            this.pad[0] = (key[16] & 0xff) | ((key[17] & 0xff) << 8);
            this.pad[1] = (key[18] & 0xff) | ((key[19] & 0xff) << 8);
            this.pad[2] = (key[20] & 0xff) | ((key[21] & 0xff) << 8);
            this.pad[3] = (key[22] & 0xff) | ((key[23] & 0xff) << 8);
            this.pad[4] = (key[24] & 0xff) | ((key[25] & 0xff) << 8);
            this.pad[5] = (key[26] & 0xff) | ((key[27] & 0xff) << 8);
            this.pad[6] = (key[28] & 0xff) | ((key[29] & 0xff) << 8);
            this.pad[7] = (key[30] & 0xff) | ((key[31] & 0xff) << 8);
        };

        poly1305.prototype.blocks = function (m, mpos, bytes) {
            var hibit = this.fin ? 0 : 1 << 11;
            var t0, t1, t2, t3, t4, t5, t6, t7, c;
            var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;

            var h0 = this.h[0],
                h1 = this.h[1],
                h2 = this.h[2],
                h3 = this.h[3],
                h4 = this.h[4],
                h5 = this.h[5],
                h6 = this.h[6],
                h7 = this.h[7],
                h8 = this.h[8],
                h9 = this.h[9];

            var r0 = this.r[0],
                r1 = this.r[1],
                r2 = this.r[2],
                r3 = this.r[3],
                r4 = this.r[4],
                r5 = this.r[5],
                r6 = this.r[6],
                r7 = this.r[7],
                r8 = this.r[8],
                r9 = this.r[9];

            while (bytes >= 16) {
                t0 = (m[mpos + 0] & 0xff) | ((m[mpos + 1] & 0xff) << 8);
                h0 += t0 & 0x1fff;
                t1 = (m[mpos + 2] & 0xff) | ((m[mpos + 3] & 0xff) << 8);
                h1 += ((t0 >>> 13) | (t1 << 3)) & 0x1fff;
                t2 = (m[mpos + 4] & 0xff) | ((m[mpos + 5] & 0xff) << 8);
                h2 += ((t1 >>> 10) | (t2 << 6)) & 0x1fff;
                t3 = (m[mpos + 6] & 0xff) | ((m[mpos + 7] & 0xff) << 8);
                h3 += ((t2 >>> 7) | (t3 << 9)) & 0x1fff;
                t4 = (m[mpos + 8] & 0xff) | ((m[mpos + 9] & 0xff) << 8);
                h4 += ((t3 >>> 4) | (t4 << 12)) & 0x1fff;
                h5 += (t4 >>> 1) & 0x1fff;
                t5 = (m[mpos + 10] & 0xff) | ((m[mpos + 11] & 0xff) << 8);
                h6 += ((t4 >>> 14) | (t5 << 2)) & 0x1fff;
                t6 = (m[mpos + 12] & 0xff) | ((m[mpos + 13] & 0xff) << 8);
                h7 += ((t5 >>> 11) | (t6 << 5)) & 0x1fff;
                t7 = (m[mpos + 14] & 0xff) | ((m[mpos + 15] & 0xff) << 8);
                h8 += ((t6 >>> 8) | (t7 << 8)) & 0x1fff;
                h9 += (t7 >>> 5) | hibit;

                c = 0;

                d0 = c;
                d0 += h0 * r0;
                d0 += h1 * (5 * r9);
                d0 += h2 * (5 * r8);
                d0 += h3 * (5 * r7);
                d0 += h4 * (5 * r6);
                c = d0 >>> 13;
                d0 &= 0x1fff;
                d0 += h5 * (5 * r5);
                d0 += h6 * (5 * r4);
                d0 += h7 * (5 * r3);
                d0 += h8 * (5 * r2);
                d0 += h9 * (5 * r1);
                c += d0 >>> 13;
                d0 &= 0x1fff;

                d1 = c;
                d1 += h0 * r1;
                d1 += h1 * r0;
                d1 += h2 * (5 * r9);
                d1 += h3 * (5 * r8);
                d1 += h4 * (5 * r7);
                c = d1 >>> 13;
                d1 &= 0x1fff;
                d1 += h5 * (5 * r6);
                d1 += h6 * (5 * r5);
                d1 += h7 * (5 * r4);
                d1 += h8 * (5 * r3);
                d1 += h9 * (5 * r2);
                c += d1 >>> 13;
                d1 &= 0x1fff;

                d2 = c;
                d2 += h0 * r2;
                d2 += h1 * r1;
                d2 += h2 * r0;
                d2 += h3 * (5 * r9);
                d2 += h4 * (5 * r8);
                c = d2 >>> 13;
                d2 &= 0x1fff;
                d2 += h5 * (5 * r7);
                d2 += h6 * (5 * r6);
                d2 += h7 * (5 * r5);
                d2 += h8 * (5 * r4);
                d2 += h9 * (5 * r3);
                c += d2 >>> 13;
                d2 &= 0x1fff;

                d3 = c;
                d3 += h0 * r3;
                d3 += h1 * r2;
                d3 += h2 * r1;
                d3 += h3 * r0;
                d3 += h4 * (5 * r9);
                c = d3 >>> 13;
                d3 &= 0x1fff;
                d3 += h5 * (5 * r8);
                d3 += h6 * (5 * r7);
                d3 += h7 * (5 * r6);
                d3 += h8 * (5 * r5);
                d3 += h9 * (5 * r4);
                c += d3 >>> 13;
                d3 &= 0x1fff;

                d4 = c;
                d4 += h0 * r4;
                d4 += h1 * r3;
                d4 += h2 * r2;
                d4 += h3 * r1;
                d4 += h4 * r0;
                c = d4 >>> 13;
                d4 &= 0x1fff;
                d4 += h5 * (5 * r9);
                d4 += h6 * (5 * r8);
                d4 += h7 * (5 * r7);
                d4 += h8 * (5 * r6);
                d4 += h9 * (5 * r5);
                c += d4 >>> 13;
                d4 &= 0x1fff;

                d5 = c;
                d5 += h0 * r5;
                d5 += h1 * r4;
                d5 += h2 * r3;
                d5 += h3 * r2;
                d5 += h4 * r1;
                c = d5 >>> 13;
                d5 &= 0x1fff;
                d5 += h5 * r0;
                d5 += h6 * (5 * r9);
                d5 += h7 * (5 * r8);
                d5 += h8 * (5 * r7);
                d5 += h9 * (5 * r6);
                c += d5 >>> 13;
                d5 &= 0x1fff;

                d6 = c;
                d6 += h0 * r6;
                d6 += h1 * r5;
                d6 += h2 * r4;
                d6 += h3 * r3;
                d6 += h4 * r2;
                c = d6 >>> 13;
                d6 &= 0x1fff;
                d6 += h5 * r1;
                d6 += h6 * r0;
                d6 += h7 * (5 * r9);
                d6 += h8 * (5 * r8);
                d6 += h9 * (5 * r7);
                c += d6 >>> 13;
                d6 &= 0x1fff;

                d7 = c;
                d7 += h0 * r7;
                d7 += h1 * r6;
                d7 += h2 * r5;
                d7 += h3 * r4;
                d7 += h4 * r3;
                c = d7 >>> 13;
                d7 &= 0x1fff;
                d7 += h5 * r2;
                d7 += h6 * r1;
                d7 += h7 * r0;
                d7 += h8 * (5 * r9);
                d7 += h9 * (5 * r8);
                c += d7 >>> 13;
                d7 &= 0x1fff;

                d8 = c;
                d8 += h0 * r8;
                d8 += h1 * r7;
                d8 += h2 * r6;
                d8 += h3 * r5;
                d8 += h4 * r4;
                c = d8 >>> 13;
                d8 &= 0x1fff;
                d8 += h5 * r3;
                d8 += h6 * r2;
                d8 += h7 * r1;
                d8 += h8 * r0;
                d8 += h9 * (5 * r9);
                c += d8 >>> 13;
                d8 &= 0x1fff;

                d9 = c;
                d9 += h0 * r9;
                d9 += h1 * r8;
                d9 += h2 * r7;
                d9 += h3 * r6;
                d9 += h4 * r5;
                c = d9 >>> 13;
                d9 &= 0x1fff;
                d9 += h5 * r4;
                d9 += h6 * r3;
                d9 += h7 * r2;
                d9 += h8 * r1;
                d9 += h9 * r0;
                c += d9 >>> 13;
                d9 &= 0x1fff;

                c = ((c << 2) + c) | 0;
                c = (c + d0) | 0;
                d0 = c & 0x1fff;
                c = c >>> 13;
                d1 += c;

                h0 = d0;
                h1 = d1;
                h2 = d2;
                h3 = d3;
                h4 = d4;
                h5 = d5;
                h6 = d6;
                h7 = d7;
                h8 = d8;
                h9 = d9;

                mpos += 16;
                bytes -= 16;
            }
            this.h[0] = h0;
            this.h[1] = h1;
            this.h[2] = h2;
            this.h[3] = h3;
            this.h[4] = h4;
            this.h[5] = h5;
            this.h[6] = h6;
            this.h[7] = h7;
            this.h[8] = h8;
            this.h[9] = h9;
        };

        poly1305.prototype.finish = function (mac, macpos) {
            var g = new Uint16Array(10);
            var c, mask, f, i;

            if (this.leftover) {
                i = this.leftover;
                this.buffer[i++] = 1;
                for (; i < 16; i++) this.buffer[i] = 0;
                this.fin = 1;
                this.blocks(this.buffer, 0, 16);
            }

            c = this.h[1] >>> 13;
            this.h[1] &= 0x1fff;
            for (i = 2; i < 10; i++) {
                this.h[i] += c;
                c = this.h[i] >>> 13;
                this.h[i] &= 0x1fff;
            }
            this.h[0] += c * 5;
            c = this.h[0] >>> 13;
            this.h[0] &= 0x1fff;
            this.h[1] += c;
            c = this.h[1] >>> 13;
            this.h[1] &= 0x1fff;
            this.h[2] += c;

            g[0] = this.h[0] + 5;
            c = g[0] >>> 13;
            g[0] &= 0x1fff;
            for (i = 1; i < 10; i++) {
                g[i] = this.h[i] + c;
                c = g[i] >>> 13;
                g[i] &= 0x1fff;
            }
            g[9] -= 1 << 13;

            mask = (c ^ 1) - 1;
            for (i = 0; i < 10; i++) g[i] &= mask;
            mask = ~mask;
            for (i = 0; i < 10; i++) this.h[i] = (this.h[i] & mask) | g[i];

            this.h[0] = (this.h[0] | (this.h[1] << 13)) & 0xffff;
            this.h[1] = ((this.h[1] >>> 3) | (this.h[2] << 10)) & 0xffff;
            this.h[2] = ((this.h[2] >>> 6) | (this.h[3] << 7)) & 0xffff;
            this.h[3] = ((this.h[3] >>> 9) | (this.h[4] << 4)) & 0xffff;
            this.h[4] =
                ((this.h[4] >>> 12) | (this.h[5] << 1) | (this.h[6] << 14)) &
                0xffff;
            this.h[5] = ((this.h[6] >>> 2) | (this.h[7] << 11)) & 0xffff;
            this.h[6] = ((this.h[7] >>> 5) | (this.h[8] << 8)) & 0xffff;
            this.h[7] = ((this.h[8] >>> 8) | (this.h[9] << 5)) & 0xffff;

            f = this.h[0] + this.pad[0];
            this.h[0] = f & 0xffff;
            for (i = 1; i < 8; i++) {
                f = (((this.h[i] + this.pad[i]) | 0) + (f >>> 16)) | 0;
                this.h[i] = f & 0xffff;
            }

            mac[macpos + 0] = (this.h[0] >>> 0) & 0xff;
            mac[macpos + 1] = (this.h[0] >>> 8) & 0xff;
            mac[macpos + 2] = (this.h[1] >>> 0) & 0xff;
            mac[macpos + 3] = (this.h[1] >>> 8) & 0xff;
            mac[macpos + 4] = (this.h[2] >>> 0) & 0xff;
            mac[macpos + 5] = (this.h[2] >>> 8) & 0xff;
            mac[macpos + 6] = (this.h[3] >>> 0) & 0xff;
            mac[macpos + 7] = (this.h[3] >>> 8) & 0xff;
            mac[macpos + 8] = (this.h[4] >>> 0) & 0xff;
            mac[macpos + 9] = (this.h[4] >>> 8) & 0xff;
            mac[macpos + 10] = (this.h[5] >>> 0) & 0xff;
            mac[macpos + 11] = (this.h[5] >>> 8) & 0xff;
            mac[macpos + 12] = (this.h[6] >>> 0) & 0xff;
            mac[macpos + 13] = (this.h[6] >>> 8) & 0xff;
            mac[macpos + 14] = (this.h[7] >>> 0) & 0xff;
            mac[macpos + 15] = (this.h[7] >>> 8) & 0xff;
        };

        poly1305.prototype.update = function (m, mpos, bytes) {
            var i, want;

            if (this.leftover) {
                want = 16 - this.leftover;
                if (want > bytes) want = bytes;
                for (i = 0; i < want; i++)
                    this.buffer[this.leftover + i] = m[mpos + i];
                bytes -= want;
                mpos += want;
                this.leftover += want;
                if (this.leftover < 16) return;
                this.blocks(this.buffer, 0, 16);
                this.leftover = 0;
            }

            if (bytes >= 16) {
                want = bytes - (bytes % 16);
                this.blocks(m, mpos, want);
                mpos += want;
                bytes -= want;
            }

            if (bytes) {
                for (i = 0; i < bytes; i++)
                    this.buffer[this.leftover + i] = m[mpos + i];
                this.leftover += bytes;
            }
        };

        function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
            var s = new poly1305(k);
            s.update(m, mpos, n);
            s.finish(out, outpos);
            return 0;
        }

        function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
            var x = new Uint8Array(16);
            crypto_onetimeauth(x, 0, m, mpos, n, k);
            return crypto_verify_16(h, hpos, x, 0);
        }

        function crypto_secretbox(c, m, d, n, k) {
            var i;
            if (d < 32) return -1;
            crypto_stream_xor(c, 0, m, 0, d, n, k);
            crypto_onetimeauth(c, 16, c, 32, d - 32, c);
            for (i = 0; i < 16; i++) c[i] = 0;
            return 0;
        }

        function crypto_secretbox_open(m, c, d, n, k) {
            var i;
            var x = new Uint8Array(32);
            if (d < 32) return -1;
            crypto_stream(x, 0, 32, n, k);
            if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0)
                return -1;
            crypto_stream_xor(m, 0, c, 0, d, n, k);
            for (i = 0; i < 32; i++) m[i] = 0;
            return 0;
        }

        function set25519(r, a) {
            var i;
            for (i = 0; i < 16; i++) r[i] = a[i] | 0;
        }

        function car25519(o) {
            var i,
                v,
                c = 1;
            for (i = 0; i < 16; i++) {
                v = o[i] + c + 65535;
                c = Math.floor(v / 65536);
                o[i] = v - c * 65536;
            }
            o[0] += c - 1 + 37 * (c - 1);
        }

        function sel25519(p, q, b) {
            var t,
                c = ~(b - 1);
            for (var i = 0; i < 16; i++) {
                t = c & (p[i] ^ q[i]);
                p[i] ^= t;
                q[i] ^= t;
            }
        }

        function pack25519(o, n) {
            var i, j, b;
            var m = gf(),
                t = gf();
            for (i = 0; i < 16; i++) t[i] = n[i];
            car25519(t);
            car25519(t);
            car25519(t);
            for (j = 0; j < 2; j++) {
                m[0] = t[0] - 0xffed;
                for (i = 1; i < 15; i++) {
                    m[i] = t[i] - 0xffff - ((m[i - 1] >> 16) & 1);
                    m[i - 1] &= 0xffff;
                }
                m[15] = t[15] - 0x7fff - ((m[14] >> 16) & 1);
                b = (m[15] >> 16) & 1;
                m[14] &= 0xffff;
                sel25519(t, m, 1 - b);
            }
            for (i = 0; i < 16; i++) {
                o[2 * i] = t[i] & 0xff;
                o[2 * i + 1] = t[i] >> 8;
            }
        }

        function neq25519(a, b) {
            var c = new Uint8Array(32),
                d = new Uint8Array(32);
            pack25519(c, a);
            pack25519(d, b);
            return crypto_verify_32(c, 0, d, 0);
        }

        function par25519(a) {
            var d = new Uint8Array(32);
            pack25519(d, a);
            return d[0] & 1;
        }

        function unpack25519(o, n) {
            var i;
            for (i = 0; i < 16; i++) o[i] = n[2 * i] + (n[2 * i + 1] << 8);
            o[15] &= 0x7fff;
        }

        function A(o, a, b) {
            for (var i = 0; i < 16; i++) o[i] = a[i] + b[i];
        }

        function Z(o, a, b) {
            for (var i = 0; i < 16; i++) o[i] = a[i] - b[i];
        }

        function M(o, a, b) {
            var v,
                c,
                t0 = 0,
                t1 = 0,
                t2 = 0,
                t3 = 0,
                t4 = 0,
                t5 = 0,
                t6 = 0,
                t7 = 0,
                t8 = 0,
                t9 = 0,
                t10 = 0,
                t11 = 0,
                t12 = 0,
                t13 = 0,
                t14 = 0,
                t15 = 0,
                t16 = 0,
                t17 = 0,
                t18 = 0,
                t19 = 0,
                t20 = 0,
                t21 = 0,
                t22 = 0,
                t23 = 0,
                t24 = 0,
                t25 = 0,
                t26 = 0,
                t27 = 0,
                t28 = 0,
                t29 = 0,
                t30 = 0,
                b0 = b[0],
                b1 = b[1],
                b2 = b[2],
                b3 = b[3],
                b4 = b[4],
                b5 = b[5],
                b6 = b[6],
                b7 = b[7],
                b8 = b[8],
                b9 = b[9],
                b10 = b[10],
                b11 = b[11],
                b12 = b[12],
                b13 = b[13],
                b14 = b[14],
                b15 = b[15];

            v = a[0];
            t0 += v * b0;
            t1 += v * b1;
            t2 += v * b2;
            t3 += v * b3;
            t4 += v * b4;
            t5 += v * b5;
            t6 += v * b6;
            t7 += v * b7;
            t8 += v * b8;
            t9 += v * b9;
            t10 += v * b10;
            t11 += v * b11;
            t12 += v * b12;
            t13 += v * b13;
            t14 += v * b14;
            t15 += v * b15;
            v = a[1];
            t1 += v * b0;
            t2 += v * b1;
            t3 += v * b2;
            t4 += v * b3;
            t5 += v * b4;
            t6 += v * b5;
            t7 += v * b6;
            t8 += v * b7;
            t9 += v * b8;
            t10 += v * b9;
            t11 += v * b10;
            t12 += v * b11;
            t13 += v * b12;
            t14 += v * b13;
            t15 += v * b14;
            t16 += v * b15;
            v = a[2];
            t2 += v * b0;
            t3 += v * b1;
            t4 += v * b2;
            t5 += v * b3;
            t6 += v * b4;
            t7 += v * b5;
            t8 += v * b6;
            t9 += v * b7;
            t10 += v * b8;
            t11 += v * b9;
            t12 += v * b10;
            t13 += v * b11;
            t14 += v * b12;
            t15 += v * b13;
            t16 += v * b14;
            t17 += v * b15;
            v = a[3];
            t3 += v * b0;
            t4 += v * b1;
            t5 += v * b2;
            t6 += v * b3;
            t7 += v * b4;
            t8 += v * b5;
            t9 += v * b6;
            t10 += v * b7;
            t11 += v * b8;
            t12 += v * b9;
            t13 += v * b10;
            t14 += v * b11;
            t15 += v * b12;
            t16 += v * b13;
            t17 += v * b14;
            t18 += v * b15;
            v = a[4];
            t4 += v * b0;
            t5 += v * b1;
            t6 += v * b2;
            t7 += v * b3;
            t8 += v * b4;
            t9 += v * b5;
            t10 += v * b6;
            t11 += v * b7;
            t12 += v * b8;
            t13 += v * b9;
            t14 += v * b10;
            t15 += v * b11;
            t16 += v * b12;
            t17 += v * b13;
            t18 += v * b14;
            t19 += v * b15;
            v = a[5];
            t5 += v * b0;
            t6 += v * b1;
            t7 += v * b2;
            t8 += v * b3;
            t9 += v * b4;
            t10 += v * b5;
            t11 += v * b6;
            t12 += v * b7;
            t13 += v * b8;
            t14 += v * b9;
            t15 += v * b10;
            t16 += v * b11;
            t17 += v * b12;
            t18 += v * b13;
            t19 += v * b14;
            t20 += v * b15;
            v = a[6];
            t6 += v * b0;
            t7 += v * b1;
            t8 += v * b2;
            t9 += v * b3;
            t10 += v * b4;
            t11 += v * b5;
            t12 += v * b6;
            t13 += v * b7;
            t14 += v * b8;
            t15 += v * b9;
            t16 += v * b10;
            t17 += v * b11;
            t18 += v * b12;
            t19 += v * b13;
            t20 += v * b14;
            t21 += v * b15;
            v = a[7];
            t7 += v * b0;
            t8 += v * b1;
            t9 += v * b2;
            t10 += v * b3;
            t11 += v * b4;
            t12 += v * b5;
            t13 += v * b6;
            t14 += v * b7;
            t15 += v * b8;
            t16 += v * b9;
            t17 += v * b10;
            t18 += v * b11;
            t19 += v * b12;
            t20 += v * b13;
            t21 += v * b14;
            t22 += v * b15;
            v = a[8];
            t8 += v * b0;
            t9 += v * b1;
            t10 += v * b2;
            t11 += v * b3;
            t12 += v * b4;
            t13 += v * b5;
            t14 += v * b6;
            t15 += v * b7;
            t16 += v * b8;
            t17 += v * b9;
            t18 += v * b10;
            t19 += v * b11;
            t20 += v * b12;
            t21 += v * b13;
            t22 += v * b14;
            t23 += v * b15;
            v = a[9];
            t9 += v * b0;
            t10 += v * b1;
            t11 += v * b2;
            t12 += v * b3;
            t13 += v * b4;
            t14 += v * b5;
            t15 += v * b6;
            t16 += v * b7;
            t17 += v * b8;
            t18 += v * b9;
            t19 += v * b10;
            t20 += v * b11;
            t21 += v * b12;
            t22 += v * b13;
            t23 += v * b14;
            t24 += v * b15;
            v = a[10];
            t10 += v * b0;
            t11 += v * b1;
            t12 += v * b2;
            t13 += v * b3;
            t14 += v * b4;
            t15 += v * b5;
            t16 += v * b6;
            t17 += v * b7;
            t18 += v * b8;
            t19 += v * b9;
            t20 += v * b10;
            t21 += v * b11;
            t22 += v * b12;
            t23 += v * b13;
            t24 += v * b14;
            t25 += v * b15;
            v = a[11];
            t11 += v * b0;
            t12 += v * b1;
            t13 += v * b2;
            t14 += v * b3;
            t15 += v * b4;
            t16 += v * b5;
            t17 += v * b6;
            t18 += v * b7;
            t19 += v * b8;
            t20 += v * b9;
            t21 += v * b10;
            t22 += v * b11;
            t23 += v * b12;
            t24 += v * b13;
            t25 += v * b14;
            t26 += v * b15;
            v = a[12];
            t12 += v * b0;
            t13 += v * b1;
            t14 += v * b2;
            t15 += v * b3;
            t16 += v * b4;
            t17 += v * b5;
            t18 += v * b6;
            t19 += v * b7;
            t20 += v * b8;
            t21 += v * b9;
            t22 += v * b10;
            t23 += v * b11;
            t24 += v * b12;
            t25 += v * b13;
            t26 += v * b14;
            t27 += v * b15;
            v = a[13];
            t13 += v * b0;
            t14 += v * b1;
            t15 += v * b2;
            t16 += v * b3;
            t17 += v * b4;
            t18 += v * b5;
            t19 += v * b6;
            t20 += v * b7;
            t21 += v * b8;
            t22 += v * b9;
            t23 += v * b10;
            t24 += v * b11;
            t25 += v * b12;
            t26 += v * b13;
            t27 += v * b14;
            t28 += v * b15;
            v = a[14];
            t14 += v * b0;
            t15 += v * b1;
            t16 += v * b2;
            t17 += v * b3;
            t18 += v * b4;
            t19 += v * b5;
            t20 += v * b6;
            t21 += v * b7;
            t22 += v * b8;
            t23 += v * b9;
            t24 += v * b10;
            t25 += v * b11;
            t26 += v * b12;
            t27 += v * b13;
            t28 += v * b14;
            t29 += v * b15;
            v = a[15];
            t15 += v * b0;
            t16 += v * b1;
            t17 += v * b2;
            t18 += v * b3;
            t19 += v * b4;
            t20 += v * b5;
            t21 += v * b6;
            t22 += v * b7;
            t23 += v * b8;
            t24 += v * b9;
            t25 += v * b10;
            t26 += v * b11;
            t27 += v * b12;
            t28 += v * b13;
            t29 += v * b14;
            t30 += v * b15;

            t0 += 38 * t16;
            t1 += 38 * t17;
            t2 += 38 * t18;
            t3 += 38 * t19;
            t4 += 38 * t20;
            t5 += 38 * t21;
            t6 += 38 * t22;
            t7 += 38 * t23;
            t8 += 38 * t24;
            t9 += 38 * t25;
            t10 += 38 * t26;
            t11 += 38 * t27;
            t12 += 38 * t28;
            t13 += 38 * t29;
            t14 += 38 * t30;
            // t15 left as is

            // first car
            c = 1;
            v = t0 + c + 65535;
            c = Math.floor(v / 65536);
            t0 = v - c * 65536;
            v = t1 + c + 65535;
            c = Math.floor(v / 65536);
            t1 = v - c * 65536;
            v = t2 + c + 65535;
            c = Math.floor(v / 65536);
            t2 = v - c * 65536;
            v = t3 + c + 65535;
            c = Math.floor(v / 65536);
            t3 = v - c * 65536;
            v = t4 + c + 65535;
            c = Math.floor(v / 65536);
            t4 = v - c * 65536;
            v = t5 + c + 65535;
            c = Math.floor(v / 65536);
            t5 = v - c * 65536;
            v = t6 + c + 65535;
            c = Math.floor(v / 65536);
            t6 = v - c * 65536;
            v = t7 + c + 65535;
            c = Math.floor(v / 65536);
            t7 = v - c * 65536;
            v = t8 + c + 65535;
            c = Math.floor(v / 65536);
            t8 = v - c * 65536;
            v = t9 + c + 65535;
            c = Math.floor(v / 65536);
            t9 = v - c * 65536;
            v = t10 + c + 65535;
            c = Math.floor(v / 65536);
            t10 = v - c * 65536;
            v = t11 + c + 65535;
            c = Math.floor(v / 65536);
            t11 = v - c * 65536;
            v = t12 + c + 65535;
            c = Math.floor(v / 65536);
            t12 = v - c * 65536;
            v = t13 + c + 65535;
            c = Math.floor(v / 65536);
            t13 = v - c * 65536;
            v = t14 + c + 65535;
            c = Math.floor(v / 65536);
            t14 = v - c * 65536;
            v = t15 + c + 65535;
            c = Math.floor(v / 65536);
            t15 = v - c * 65536;
            t0 += c - 1 + 37 * (c - 1);

            // second car
            c = 1;
            v = t0 + c + 65535;
            c = Math.floor(v / 65536);
            t0 = v - c * 65536;
            v = t1 + c + 65535;
            c = Math.floor(v / 65536);
            t1 = v - c * 65536;
            v = t2 + c + 65535;
            c = Math.floor(v / 65536);
            t2 = v - c * 65536;
            v = t3 + c + 65535;
            c = Math.floor(v / 65536);
            t3 = v - c * 65536;
            v = t4 + c + 65535;
            c = Math.floor(v / 65536);
            t4 = v - c * 65536;
            v = t5 + c + 65535;
            c = Math.floor(v / 65536);
            t5 = v - c * 65536;
            v = t6 + c + 65535;
            c = Math.floor(v / 65536);
            t6 = v - c * 65536;
            v = t7 + c + 65535;
            c = Math.floor(v / 65536);
            t7 = v - c * 65536;
            v = t8 + c + 65535;
            c = Math.floor(v / 65536);
            t8 = v - c * 65536;
            v = t9 + c + 65535;
            c = Math.floor(v / 65536);
            t9 = v - c * 65536;
            v = t10 + c + 65535;
            c = Math.floor(v / 65536);
            t10 = v - c * 65536;
            v = t11 + c + 65535;
            c = Math.floor(v / 65536);
            t11 = v - c * 65536;
            v = t12 + c + 65535;
            c = Math.floor(v / 65536);
            t12 = v - c * 65536;
            v = t13 + c + 65535;
            c = Math.floor(v / 65536);
            t13 = v - c * 65536;
            v = t14 + c + 65535;
            c = Math.floor(v / 65536);
            t14 = v - c * 65536;
            v = t15 + c + 65535;
            c = Math.floor(v / 65536);
            t15 = v - c * 65536;
            t0 += c - 1 + 37 * (c - 1);

            o[0] = t0;
            o[1] = t1;
            o[2] = t2;
            o[3] = t3;
            o[4] = t4;
            o[5] = t5;
            o[6] = t6;
            o[7] = t7;
            o[8] = t8;
            o[9] = t9;
            o[10] = t10;
            o[11] = t11;
            o[12] = t12;
            o[13] = t13;
            o[14] = t14;
            o[15] = t15;
        }

        function S(o, a) {
            M(o, a, a);
        }

        function inv25519(o, i) {
            var c = gf();
            var a;
            for (a = 0; a < 16; a++) c[a] = i[a];
            for (a = 253; a >= 0; a--) {
                S(c, c);
                if (a !== 2 && a !== 4) M(c, c, i);
            }
            for (a = 0; a < 16; a++) o[a] = c[a];
        }

        function pow2523(o, i) {
            var c = gf();
            var a;
            for (a = 0; a < 16; a++) c[a] = i[a];
            for (a = 250; a >= 0; a--) {
                S(c, c);
                if (a !== 1) M(c, c, i);
            }
            for (a = 0; a < 16; a++) o[a] = c[a];
        }

        function crypto_scalarmult(q, n, p) {
            var z = new Uint8Array(32);
            var x = new Float64Array(80),
                r,
                i;
            var a = gf(),
                b = gf(),
                c = gf(),
                d = gf(),
                e = gf(),
                f = gf();
            for (i = 0; i < 31; i++) z[i] = n[i];
            z[31] = (n[31] & 127) | 64;
            z[0] &= 248;
            unpack25519(x, p);
            for (i = 0; i < 16; i++) {
                b[i] = x[i];
                d[i] = a[i] = c[i] = 0;
            }
            a[0] = d[0] = 1;
            for (i = 254; i >= 0; --i) {
                r = (z[i >>> 3] >>> (i & 7)) & 1;
                sel25519(a, b, r);
                sel25519(c, d, r);
                A(e, a, c);
                Z(a, a, c);
                A(c, b, d);
                Z(b, b, d);
                S(d, e);
                S(f, a);
                M(a, c, a);
                M(c, b, e);
                A(e, a, c);
                Z(a, a, c);
                S(b, a);
                Z(c, d, f);
                M(a, c, _121665);
                A(a, a, d);
                M(c, c, a);
                M(a, d, f);
                M(d, b, x);
                S(b, e);
                sel25519(a, b, r);
                sel25519(c, d, r);
            }
            for (i = 0; i < 16; i++) {
                x[i + 16] = a[i];
                x[i + 32] = c[i];
                x[i + 48] = b[i];
                x[i + 64] = d[i];
            }
            var x32 = x.subarray(32);
            var x16 = x.subarray(16);
            inv25519(x32, x32);
            M(x16, x16, x32);
            pack25519(q, x16);
            return 0;
        }

        function crypto_scalarmult_base(q, n) {
            return crypto_scalarmult(q, n, _9);
        }

        function crypto_box_keypair(y, x) {
            randombytes(x, 32);
            return crypto_scalarmult_base(y, x);
        }

        function crypto_box_beforenm(k, y, x) {
            var s = new Uint8Array(32);
            crypto_scalarmult(s, x, y);
            return crypto_core_hsalsa20(k, _0, s, sigma);
        }

        var crypto_box_afternm = crypto_secretbox;
        var crypto_box_open_afternm = crypto_secretbox_open;

        function crypto_box(c, m, d, n, y, x) {
            var k = new Uint8Array(32);
            crypto_box_beforenm(k, y, x);
            return crypto_box_afternm(c, m, d, n, k);
        }

        function crypto_box_open(m, c, d, n, y, x) {
            var k = new Uint8Array(32);
            crypto_box_beforenm(k, y, x);
            return crypto_box_open_afternm(m, c, d, n, k);
        }

        var K = [
            0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd, 0xb5c0fbcf,
            0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc, 0x3956c25b, 0xf348b538,
            0x59f111f1, 0xb605d019, 0x923f82a4, 0xaf194f9b, 0xab1c5ed5,
            0xda6d8118, 0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
            0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2, 0x72be5d74,
            0xf27b896f, 0x80deb1fe, 0x3b1696b1, 0x9bdc06a7, 0x25c71235,
            0xc19bf174, 0xcf692694, 0xe49b69c1, 0x9ef14ad2, 0xefbe4786,
            0x384f25e3, 0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
            0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483, 0x5cb0a9dc,
            0xbd41fbd4, 0x76f988da, 0x831153b5, 0x983e5152, 0xee66dfab,
            0xa831c66d, 0x2db43210, 0xb00327c8, 0x98fb213f, 0xbf597fc7,
            0xbeef0ee4, 0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
            0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70, 0x27b70a85,
            0x46d22ffc, 0x2e1b2138, 0x5c26c926, 0x4d2c6dfc, 0x5ac42aed,
            0x53380d13, 0x9d95b3df, 0x650a7354, 0x8baf63de, 0x766a0abb,
            0x3c77b2a8, 0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
            0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001, 0xc24b8b70,
            0xd0f89791, 0xc76c51a3, 0x0654be30, 0xd192e819, 0xd6ef5218,
            0xd6990624, 0x5565a910, 0xf40e3585, 0x5771202a, 0x106aa070,
            0x32bbd1b8, 0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
            0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8, 0x391c0cb3,
            0xc5c95a63, 0x4ed8aa4a, 0xe3418acb, 0x5b9cca4f, 0x7763e373,
            0x682e6ff3, 0xd6b2b8a3, 0x748f82ee, 0x5defb2fc, 0x78a5636f,
            0x43172f60, 0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
            0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9, 0xbef9a3f7,
            0xb2c67915, 0xc67178f2, 0xe372532b, 0xca273ece, 0xea26619c,
            0xd186b8c7, 0x21c0c207, 0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f,
            0xee6ed178, 0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
            0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b, 0x28db77f5,
            0x23047d84, 0x32caab7b, 0x40c72493, 0x3c9ebe0a, 0x15c9bebc,
            0x431d67c4, 0x9c100d4c, 0x4cc5d4be, 0xcb3e42b6, 0x597f299c,
            0xfc657e2a, 0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817,
        ];

        function crypto_hashblocks_hl(hh, hl, m, n) {
            var wh = new Int32Array(16),
                wl = new Int32Array(16),
                bh0,
                bh1,
                bh2,
                bh3,
                bh4,
                bh5,
                bh6,
                bh7,
                bl0,
                bl1,
                bl2,
                bl3,
                bl4,
                bl5,
                bl6,
                bl7,
                th,
                tl,
                i,
                j,
                h,
                l,
                a,
                b,
                c,
                d;

            var ah0 = hh[0],
                ah1 = hh[1],
                ah2 = hh[2],
                ah3 = hh[3],
                ah4 = hh[4],
                ah5 = hh[5],
                ah6 = hh[6],
                ah7 = hh[7],
                al0 = hl[0],
                al1 = hl[1],
                al2 = hl[2],
                al3 = hl[3],
                al4 = hl[4],
                al5 = hl[5],
                al6 = hl[6],
                al7 = hl[7];

            var pos = 0;
            while (n >= 128) {
                for (i = 0; i < 16; i++) {
                    j = 8 * i + pos;
                    wh[i] =
                        (m[j + 0] << 24) |
                        (m[j + 1] << 16) |
                        (m[j + 2] << 8) |
                        m[j + 3];
                    wl[i] =
                        (m[j + 4] << 24) |
                        (m[j + 5] << 16) |
                        (m[j + 6] << 8) |
                        m[j + 7];
                }
                for (i = 0; i < 80; i++) {
                    bh0 = ah0;
                    bh1 = ah1;
                    bh2 = ah2;
                    bh3 = ah3;
                    bh4 = ah4;
                    bh5 = ah5;
                    bh6 = ah6;
                    bh7 = ah7;

                    bl0 = al0;
                    bl1 = al1;
                    bl2 = al2;
                    bl3 = al3;
                    bl4 = al4;
                    bl5 = al5;
                    bl6 = al6;
                    bl7 = al7;

                    // add
                    h = ah7;
                    l = al7;

                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;

                    // Sigma1
                    h =
                        ((ah4 >>> 14) | (al4 << (32 - 14))) ^
                        ((ah4 >>> 18) | (al4 << (32 - 18))) ^
                        ((al4 >>> (41 - 32)) | (ah4 << (32 - (41 - 32))));
                    l =
                        ((al4 >>> 14) | (ah4 << (32 - 14))) ^
                        ((al4 >>> 18) | (ah4 << (32 - 18))) ^
                        ((ah4 >>> (41 - 32)) | (al4 << (32 - (41 - 32))));

                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;

                    // Ch
                    h = (ah4 & ah5) ^ (~ah4 & ah6);
                    l = (al4 & al5) ^ (~al4 & al6);

                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;

                    // K
                    h = K[i * 2];
                    l = K[i * 2 + 1];

                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;

                    // w
                    h = wh[i % 16];
                    l = wl[i % 16];

                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;

                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;

                    th = (c & 0xffff) | (d << 16);
                    tl = (a & 0xffff) | (b << 16);

                    // add
                    h = th;
                    l = tl;

                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;

                    // Sigma0
                    h =
                        ((ah0 >>> 28) | (al0 << (32 - 28))) ^
                        ((al0 >>> (34 - 32)) | (ah0 << (32 - (34 - 32)))) ^
                        ((al0 >>> (39 - 32)) | (ah0 << (32 - (39 - 32))));
                    l =
                        ((al0 >>> 28) | (ah0 << (32 - 28))) ^
                        ((ah0 >>> (34 - 32)) | (al0 << (32 - (34 - 32)))) ^
                        ((ah0 >>> (39 - 32)) | (al0 << (32 - (39 - 32))));

                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;

                    // Maj
                    h = (ah0 & ah1) ^ (ah0 & ah2) ^ (ah1 & ah2);
                    l = (al0 & al1) ^ (al0 & al2) ^ (al1 & al2);

                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;

                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;

                    bh7 = (c & 0xffff) | (d << 16);
                    bl7 = (a & 0xffff) | (b << 16);

                    // add
                    h = bh3;
                    l = bl3;

                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;

                    h = th;
                    l = tl;

                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;

                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;

                    bh3 = (c & 0xffff) | (d << 16);
                    bl3 = (a & 0xffff) | (b << 16);

                    ah1 = bh0;
                    ah2 = bh1;
                    ah3 = bh2;
                    ah4 = bh3;
                    ah5 = bh4;
                    ah6 = bh5;
                    ah7 = bh6;
                    ah0 = bh7;

                    al1 = bl0;
                    al2 = bl1;
                    al3 = bl2;
                    al4 = bl3;
                    al5 = bl4;
                    al6 = bl5;
                    al7 = bl6;
                    al0 = bl7;

                    if (i % 16 === 15) {
                        for (j = 0; j < 16; j++) {
                            // add
                            h = wh[j];
                            l = wl[j];

                            a = l & 0xffff;
                            b = l >>> 16;
                            c = h & 0xffff;
                            d = h >>> 16;

                            h = wh[(j + 9) % 16];
                            l = wl[(j + 9) % 16];

                            a += l & 0xffff;
                            b += l >>> 16;
                            c += h & 0xffff;
                            d += h >>> 16;

                            // sigma0
                            th = wh[(j + 1) % 16];
                            tl = wl[(j + 1) % 16];
                            h =
                                ((th >>> 1) | (tl << (32 - 1))) ^
                                ((th >>> 8) | (tl << (32 - 8))) ^
                                (th >>> 7);
                            l =
                                ((tl >>> 1) | (th << (32 - 1))) ^
                                ((tl >>> 8) | (th << (32 - 8))) ^
                                ((tl >>> 7) | (th << (32 - 7)));

                            a += l & 0xffff;
                            b += l >>> 16;
                            c += h & 0xffff;
                            d += h >>> 16;

                            // sigma1
                            th = wh[(j + 14) % 16];
                            tl = wl[(j + 14) % 16];
                            h =
                                ((th >>> 19) | (tl << (32 - 19))) ^
                                ((tl >>> (61 - 32)) |
                                    (th << (32 - (61 - 32)))) ^
                                (th >>> 6);
                            l =
                                ((tl >>> 19) | (th << (32 - 19))) ^
                                ((th >>> (61 - 32)) |
                                    (tl << (32 - (61 - 32)))) ^
                                ((tl >>> 6) | (th << (32 - 6)));

                            a += l & 0xffff;
                            b += l >>> 16;
                            c += h & 0xffff;
                            d += h >>> 16;

                            b += a >>> 16;
                            c += b >>> 16;
                            d += c >>> 16;

                            wh[j] = (c & 0xffff) | (d << 16);
                            wl[j] = (a & 0xffff) | (b << 16);
                        }
                    }
                }

                // add
                h = ah0;
                l = al0;

                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;

                h = hh[0];
                l = hl[0];

                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;

                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;

                hh[0] = ah0 = (c & 0xffff) | (d << 16);
                hl[0] = al0 = (a & 0xffff) | (b << 16);

                h = ah1;
                l = al1;

                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;

                h = hh[1];
                l = hl[1];

                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;

                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;

                hh[1] = ah1 = (c & 0xffff) | (d << 16);
                hl[1] = al1 = (a & 0xffff) | (b << 16);

                h = ah2;
                l = al2;

                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;

                h = hh[2];
                l = hl[2];

                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;

                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;

                hh[2] = ah2 = (c & 0xffff) | (d << 16);
                hl[2] = al2 = (a & 0xffff) | (b << 16);

                h = ah3;
                l = al3;

                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;

                h = hh[3];
                l = hl[3];

                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;

                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;

                hh[3] = ah3 = (c & 0xffff) | (d << 16);
                hl[3] = al3 = (a & 0xffff) | (b << 16);

                h = ah4;
                l = al4;

                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;

                h = hh[4];
                l = hl[4];

                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;

                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;

                hh[4] = ah4 = (c & 0xffff) | (d << 16);
                hl[4] = al4 = (a & 0xffff) | (b << 16);

                h = ah5;
                l = al5;

                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;

                h = hh[5];
                l = hl[5];

                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;

                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;

                hh[5] = ah5 = (c & 0xffff) | (d << 16);
                hl[5] = al5 = (a & 0xffff) | (b << 16);

                h = ah6;
                l = al6;

                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;

                h = hh[6];
                l = hl[6];

                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;

                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;

                hh[6] = ah6 = (c & 0xffff) | (d << 16);
                hl[6] = al6 = (a & 0xffff) | (b << 16);

                h = ah7;
                l = al7;

                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;

                h = hh[7];
                l = hl[7];

                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;

                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;

                hh[7] = ah7 = (c & 0xffff) | (d << 16);
                hl[7] = al7 = (a & 0xffff) | (b << 16);

                pos += 128;
                n -= 128;
            }

            return n;
        }

        function crypto_hash(out, m, n) {
            var hh = new Int32Array(8),
                hl = new Int32Array(8),
                x = new Uint8Array(256),
                i,
                b = n;

            hh[0] = 0x6a09e667;
            hh[1] = 0xbb67ae85;
            hh[2] = 0x3c6ef372;
            hh[3] = 0xa54ff53a;
            hh[4] = 0x510e527f;
            hh[5] = 0x9b05688c;
            hh[6] = 0x1f83d9ab;
            hh[7] = 0x5be0cd19;

            hl[0] = 0xf3bcc908;
            hl[1] = 0x84caa73b;
            hl[2] = 0xfe94f82b;
            hl[3] = 0x5f1d36f1;
            hl[4] = 0xade682d1;
            hl[5] = 0x2b3e6c1f;
            hl[6] = 0xfb41bd6b;
            hl[7] = 0x137e2179;

            crypto_hashblocks_hl(hh, hl, m, n);
            n %= 128;

            for (i = 0; i < n; i++) x[i] = m[b - n + i];
            x[n] = 128;

            n = 256 - 128 * (n < 112 ? 1 : 0);
            x[n - 9] = 0;
            ts64(x, n - 8, (b / 0x20000000) | 0, b << 3);
            crypto_hashblocks_hl(hh, hl, x, n);

            for (i = 0; i < 8; i++) ts64(out, 8 * i, hh[i], hl[i]);

            return 0;
        }

        function add(p, q) {
            var a = gf(),
                b = gf(),
                c = gf(),
                d = gf(),
                e = gf(),
                f = gf(),
                g = gf(),
                h = gf(),
                t = gf();

            Z(a, p[1], p[0]);
            Z(t, q[1], q[0]);
            M(a, a, t);
            A(b, p[0], p[1]);
            A(t, q[0], q[1]);
            M(b, b, t);
            M(c, p[3], q[3]);
            M(c, c, D2);
            M(d, p[2], q[2]);
            A(d, d, d);
            Z(e, b, a);
            Z(f, d, c);
            A(g, d, c);
            A(h, b, a);

            M(p[0], e, f);
            M(p[1], h, g);
            M(p[2], g, f);
            M(p[3], e, h);
        }

        function cswap(p, q, b) {
            var i;
            for (i = 0; i < 4; i++) {
                sel25519(p[i], q[i], b);
            }
        }

        function pack(r, p) {
            var tx = gf(),
                ty = gf(),
                zi = gf();
            inv25519(zi, p[2]);
            M(tx, p[0], zi);
            M(ty, p[1], zi);
            pack25519(r, ty);
            r[31] ^= par25519(tx) << 7;
        }

        function scalarmult(p, q, s) {
            var b, i;
            set25519(p[0], gf0);
            set25519(p[1], gf1);
            set25519(p[2], gf1);
            set25519(p[3], gf0);
            for (i = 255; i >= 0; --i) {
                b = (s[(i / 8) | 0] >> (i & 7)) & 1;
                cswap(p, q, b);
                add(q, p);
                add(p, p);
                cswap(p, q, b);
            }
        }

        function scalarbase(p, s) {
            var q = [gf(), gf(), gf(), gf()];
            set25519(q[0], X);
            set25519(q[1], Y);
            set25519(q[2], gf1);
            M(q[3], X, Y);
            scalarmult(p, q, s);
        }

        function crypto_sign_keypair(pk, sk, seeded) {
            var d = new Uint8Array(64);
            var p = [gf(), gf(), gf(), gf()];
            var i;

            if (!seeded) randombytes(sk, 32);
            crypto_hash(d, sk, 32);
            d[0] &= 248;
            d[31] &= 127;
            d[31] |= 64;

            scalarbase(p, d);
            pack(pk, p);

            for (i = 0; i < 32; i++) sk[i + 32] = pk[i];
            return 0;
        }

        var L = new Float64Array([
            0xed, 0xd3, 0xf5, 0x5c, 0x1a, 0x63, 0x12, 0x58, 0xd6, 0x9c, 0xf7,
            0xa2, 0xde, 0xf9, 0xde, 0x14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0x10,
        ]);

        function modL(r, x) {
            var carry, i, j, k;
            for (i = 63; i >= 32; --i) {
                carry = 0;
                for (j = i - 32, k = i - 12; j < k; ++j) {
                    x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                    carry = Math.floor((x[j] + 128) / 256);
                    x[j] -= carry * 256;
                }
                x[j] += carry;
                x[i] = 0;
            }
            carry = 0;
            for (j = 0; j < 32; j++) {
                x[j] += carry - (x[31] >> 4) * L[j];
                carry = x[j] >> 8;
                x[j] &= 255;
            }
            for (j = 0; j < 32; j++) x[j] -= carry * L[j];
            for (i = 0; i < 32; i++) {
                x[i + 1] += x[i] >> 8;
                r[i] = x[i] & 255;
            }
        }

        function reduce(r) {
            var x = new Float64Array(64),
                i;
            for (i = 0; i < 64; i++) x[i] = r[i];
            for (i = 0; i < 64; i++) r[i] = 0;
            modL(r, x);
        }

        // Note: difference from C - smlen returned, not passed as argument.
        function crypto_sign(sm, m, n, sk) {
            var d = new Uint8Array(64),
                h = new Uint8Array(64),
                r = new Uint8Array(64);
            var i,
                j,
                x = new Float64Array(64);
            var p = [gf(), gf(), gf(), gf()];

            crypto_hash(d, sk, 32);
            d[0] &= 248;
            d[31] &= 127;
            d[31] |= 64;

            var smlen = n + 64;
            for (i = 0; i < n; i++) sm[64 + i] = m[i];
            for (i = 0; i < 32; i++) sm[32 + i] = d[32 + i];

            crypto_hash(r, sm.subarray(32), n + 32);
            reduce(r);
            scalarbase(p, r);
            pack(sm, p);

            for (i = 32; i < 64; i++) sm[i] = sk[i];
            crypto_hash(h, sm, n + 64);
            reduce(h);

            for (i = 0; i < 64; i++) x[i] = 0;
            for (i = 0; i < 32; i++) x[i] = r[i];
            for (i = 0; i < 32; i++) {
                for (j = 0; j < 32; j++) {
                    x[i + j] += h[i] * d[j];
                }
            }

            modL(sm.subarray(32), x);
            return smlen;
        }

        function unpackneg(r, p) {
            var t = gf(),
                chk = gf(),
                num = gf(),
                den = gf(),
                den2 = gf(),
                den4 = gf(),
                den6 = gf();

            set25519(r[2], gf1);
            unpack25519(r[1], p);
            S(num, r[1]);
            M(den, num, D);
            Z(num, num, r[2]);
            A(den, r[2], den);

            S(den2, den);
            S(den4, den2);
            M(den6, den4, den2);
            M(t, den6, num);
            M(t, t, den);

            pow2523(t, t);
            M(t, t, num);
            M(t, t, den);
            M(t, t, den);
            M(r[0], t, den);

            S(chk, r[0]);
            M(chk, chk, den);
            if (neq25519(chk, num)) M(r[0], r[0], I);

            S(chk, r[0]);
            M(chk, chk, den);
            if (neq25519(chk, num)) return -1;

            if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);

            M(r[3], r[0], r[1]);
            return 0;
        }

        function crypto_sign_open(m, sm, n, pk) {
            var i;
            var t = new Uint8Array(32),
                h = new Uint8Array(64);
            var p = [gf(), gf(), gf(), gf()],
                q = [gf(), gf(), gf(), gf()];

            if (n < 64) return -1;

            if (unpackneg(q, pk)) return -1;

            for (i = 0; i < n; i++) m[i] = sm[i];
            for (i = 0; i < 32; i++) m[i + 32] = pk[i];
            crypto_hash(h, m, n);
            reduce(h);
            scalarmult(p, q, h);

            scalarbase(q, sm.subarray(32));
            add(p, q);
            pack(t, p);

            n -= 64;
            if (crypto_verify_32(sm, 0, t, 0)) {
                for (i = 0; i < n; i++) m[i] = 0;
                return -1;
            }

            for (i = 0; i < n; i++) m[i] = sm[i + 64];
            return n;
        }

        var crypto_secretbox_KEYBYTES = 32,
            crypto_secretbox_NONCEBYTES = 24,
            crypto_secretbox_ZEROBYTES = 32,
            crypto_secretbox_BOXZEROBYTES = 16,
            crypto_scalarmult_BYTES = 32,
            crypto_scalarmult_SCALARBYTES = 32,
            crypto_box_PUBLICKEYBYTES = 32,
            crypto_box_SECRETKEYBYTES = 32,
            crypto_box_BEFORENMBYTES = 32,
            crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES,
            crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES,
            crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES,
            crypto_sign_BYTES = 64,
            crypto_sign_PUBLICKEYBYTES = 32,
            crypto_sign_SECRETKEYBYTES = 64,
            crypto_sign_SEEDBYTES = 32,
            crypto_hash_BYTES = 64;

        nacl.lowlevel = {
            crypto_core_hsalsa20: crypto_core_hsalsa20,
            crypto_stream_xor: crypto_stream_xor,
            crypto_stream: crypto_stream,
            crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
            crypto_stream_salsa20: crypto_stream_salsa20,
            crypto_onetimeauth: crypto_onetimeauth,
            crypto_onetimeauth_verify: crypto_onetimeauth_verify,
            crypto_verify_16: crypto_verify_16,
            crypto_verify_32: crypto_verify_32,
            crypto_secretbox: crypto_secretbox,
            crypto_secretbox_open: crypto_secretbox_open,
            crypto_scalarmult: crypto_scalarmult,
            crypto_scalarmult_base: crypto_scalarmult_base,
            crypto_box_beforenm: crypto_box_beforenm,
            crypto_box_afternm: crypto_box_afternm,
            crypto_box: crypto_box,
            crypto_box_open: crypto_box_open,
            crypto_box_keypair: crypto_box_keypair,
            crypto_hash: crypto_hash,
            crypto_sign: crypto_sign,
            crypto_sign_keypair: crypto_sign_keypair,
            crypto_sign_open: crypto_sign_open,

            crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
            crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
            crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
            crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
            crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
            crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
            crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
            crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
            crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
            crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
            crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
            crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
            crypto_sign_BYTES: crypto_sign_BYTES,
            crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
            crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
            crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
            crypto_hash_BYTES: crypto_hash_BYTES,

            gf: gf,
            D: D,
            L: L,
            pack25519: pack25519,
            unpack25519: unpack25519,
            M: M,
            A: A,
            S: S,
            Z: Z,
            pow2523: pow2523,
            add: add,
            set25519: set25519,
            modL: modL,
            scalarmult: scalarmult,
            scalarbase: scalarbase,
        };

        /* High-level API */

        function checkLengths(k, n) {
            if (k.length !== crypto_secretbox_KEYBYTES)
                throw new Error('bad key size');
            if (n.length !== crypto_secretbox_NONCEBYTES)
                throw new Error('bad nonce size');
        }

        function checkBoxLengths(pk, sk) {
            if (pk.length !== crypto_box_PUBLICKEYBYTES)
                throw new Error('bad public key size');
            if (sk.length !== crypto_box_SECRETKEYBYTES)
                throw new Error('bad secret key size');
        }

        function checkArrayTypes() {
            for (var i = 0; i < arguments.length; i++) {
                if (!(arguments[i] instanceof Uint8Array))
                    throw new TypeError('unexpected type, use Uint8Array');
            }
        }

        function cleanup(arr) {
            for (var i = 0; i < arr.length; i++) arr[i] = 0;
        }

        nacl.randomBytes = function (n) {
            var b = new Uint8Array(n);
            randombytes(b, n);
            return b;
        };

        nacl.secretbox = function (msg, nonce, key) {
            checkArrayTypes(msg, nonce, key);
            checkLengths(key, nonce);
            var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
            var c = new Uint8Array(m.length);
            for (var i = 0; i < msg.length; i++)
                m[i + crypto_secretbox_ZEROBYTES] = msg[i];
            crypto_secretbox(c, m, m.length, nonce, key);
            return c.subarray(crypto_secretbox_BOXZEROBYTES);
        };

        nacl.secretbox.open = function (box, nonce, key) {
            checkArrayTypes(box, nonce, key);
            checkLengths(key, nonce);
            var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
            var m = new Uint8Array(c.length);
            for (var i = 0; i < box.length; i++)
                c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
            if (c.length < 32) return null;
            if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0)
                return null;
            return m.subarray(crypto_secretbox_ZEROBYTES);
        };

        nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
        nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
        nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;

        nacl.scalarMult = function (n, p) {
            checkArrayTypes(n, p);
            if (n.length !== crypto_scalarmult_SCALARBYTES)
                throw new Error('bad n size');
            if (p.length !== crypto_scalarmult_BYTES)
                throw new Error('bad p size');
            var q = new Uint8Array(crypto_scalarmult_BYTES);
            crypto_scalarmult(q, n, p);
            return q;
        };

        nacl.scalarMult.base = function (n) {
            checkArrayTypes(n);
            if (n.length !== crypto_scalarmult_SCALARBYTES)
                throw new Error('bad n size');
            var q = new Uint8Array(crypto_scalarmult_BYTES);
            crypto_scalarmult_base(q, n);
            return q;
        };

        nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
        nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;

        nacl.box = function (msg, nonce, publicKey, secretKey) {
            var k = nacl.box.before(publicKey, secretKey);
            return nacl.secretbox(msg, nonce, k);
        };

        nacl.box.before = function (publicKey, secretKey) {
            checkArrayTypes(publicKey, secretKey);
            checkBoxLengths(publicKey, secretKey);
            var k = new Uint8Array(crypto_box_BEFORENMBYTES);
            crypto_box_beforenm(k, publicKey, secretKey);
            return k;
        };

        nacl.box.after = nacl.secretbox;

        nacl.box.open = function (msg, nonce, publicKey, secretKey) {
            var k = nacl.box.before(publicKey, secretKey);
            return nacl.secretbox.open(msg, nonce, k);
        };

        nacl.box.open.after = nacl.secretbox.open;

        nacl.box.keyPair = function () {
            var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
            var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
            crypto_box_keypair(pk, sk);
            return { publicKey: pk, secretKey: sk };
        };

        nacl.box.keyPair.fromSecretKey = function (secretKey) {
            checkArrayTypes(secretKey);
            if (secretKey.length !== crypto_box_SECRETKEYBYTES)
                throw new Error('bad secret key size');
            var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
            crypto_scalarmult_base(pk, secretKey);
            return { publicKey: pk, secretKey: new Uint8Array(secretKey) };
        };

        nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
        nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
        nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
        nacl.box.nonceLength = crypto_box_NONCEBYTES;
        nacl.box.overheadLength = nacl.secretbox.overheadLength;

        nacl.sign = function (msg, secretKey) {
            checkArrayTypes(msg, secretKey);
            if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
                throw new Error('bad secret key size');
            var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
            crypto_sign(signedMsg, msg, msg.length, secretKey);
            return signedMsg;
        };

        nacl.sign.open = function (signedMsg, publicKey) {
            checkArrayTypes(signedMsg, publicKey);
            if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
                throw new Error('bad public key size');
            var tmp = new Uint8Array(signedMsg.length);
            var mlen = crypto_sign_open(
                tmp,
                signedMsg,
                signedMsg.length,
                publicKey,
            );
            if (mlen < 0) return null;
            var m = new Uint8Array(mlen);
            for (var i = 0; i < m.length; i++) m[i] = tmp[i];
            return m;
        };

        nacl.sign.detached = function (msg, secretKey) {
            var signedMsg = nacl.sign(msg, secretKey);
            var sig = new Uint8Array(crypto_sign_BYTES);
            for (var i = 0; i < sig.length; i++) sig[i] = signedMsg[i];
            return sig;
        };

        nacl.sign.detached.verify = function (msg, sig, publicKey) {
            checkArrayTypes(msg, sig, publicKey);
            if (sig.length !== crypto_sign_BYTES)
                throw new Error('bad signature size');
            if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
                throw new Error('bad public key size');
            var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
            var m = new Uint8Array(crypto_sign_BYTES + msg.length);
            var i;
            for (i = 0; i < crypto_sign_BYTES; i++) sm[i] = sig[i];
            for (i = 0; i < msg.length; i++) sm[i + crypto_sign_BYTES] = msg[i];
            return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
        };

        nacl.sign.keyPair = function () {
            var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
            var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
            crypto_sign_keypair(pk, sk);
            return { publicKey: pk, secretKey: sk };
        };

        nacl.sign.keyPair.fromSecretKey = function (secretKey) {
            checkArrayTypes(secretKey);
            if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
                throw new Error('bad secret key size');
            var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
            for (var i = 0; i < pk.length; i++) pk[i] = secretKey[32 + i];
            return { publicKey: pk, secretKey: new Uint8Array(secretKey) };
        };

        nacl.sign.keyPair.fromSeed = function (seed) {
            checkArrayTypes(seed);
            if (seed.length !== crypto_sign_SEEDBYTES)
                throw new Error('bad seed size');
            var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
            var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
            for (var i = 0; i < 32; i++) sk[i] = seed[i];
            crypto_sign_keypair(pk, sk, true);
            return { publicKey: pk, secretKey: sk };
        };

        nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
        nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
        nacl.sign.seedLength = crypto_sign_SEEDBYTES;
        nacl.sign.signatureLength = crypto_sign_BYTES;

        nacl.hash = function (msg) {
            checkArrayTypes(msg);
            var h = new Uint8Array(crypto_hash_BYTES);
            crypto_hash(h, msg, msg.length);
            return h;
        };

        nacl.hash.hashLength = crypto_hash_BYTES;

        nacl.verify = function (x, y) {
            checkArrayTypes(x, y);
            // Zero length arguments are considered not equal.
            if (x.length === 0 || y.length === 0) return false;
            if (x.length !== y.length) return false;
            return vn(x, 0, y, 0, x.length) === 0 ? true : false;
        };

        nacl.setPRNG = function (fn) {
            randombytes = fn;
        };

        (function () {
            // Initialize PRNG if environment provides CSPRNG.
            // If not, methods calling randombytes will throw.
            var crypto =
                typeof self !== 'undefined'
                    ? self.crypto || self.msCrypto
                    : null;
            if (crypto && crypto.getRandomValues) {
                // Browsers.
                var QUOTA = 65536;
                nacl.setPRNG(function (x, n) {
                    var i,
                        v = new Uint8Array(n);
                    for (i = 0; i < n; i += QUOTA) {
                        crypto.getRandomValues(
                            v.subarray(i, i + Math.min(n - i, QUOTA)),
                        );
                    }
                    for (i = 0; i < n; i++) x[i] = v[i];
                    cleanup(v);
                });
            } else if (typeof commonjsRequire !== 'undefined') {
                // Node.js.
                crypto = require$$0;
                if (crypto && crypto.randomBytes) {
                    nacl.setPRNG(function (x, n) {
                        var i,
                            v = crypto.randomBytes(n);
                        for (i = 0; i < n; i++) x[i] = v[i];
                        cleanup(v);
                    });
                }
            }
        })();
    })(module.exports ? module.exports : (self.nacl = self.nacl || {}));
})(naclFast);

var naclFastExports = naclFast.exports;
var nacl = /*@__PURE__*/ getDefaultExportFromCjs(naclFastExports);

/// TODO: extract wallet into its own npm package
const { sign } = nacl;
/// Mock Solana web3 library
class Wallet {
    constructor(keypair, url, commitment) {
        this.signTransaction = async tx => {
            await tx.sign([this._keypair]);
            return tx;
        };
        this.sendTransaction = async transaction => {
            const signature =
                await this._connection.sendTransaction(transaction);
            return signature;
        };
        this.signAllTransactions = async transactions => {
            const signedTxs = await Promise.all(
                transactions.map(async tx => {
                    return await this.signTransaction(tx);
                }),
            );
            return signedTxs;
        };
        this.signMessage = async message => {
            return sign.detached(message, this._keypair.secretKey);
        };
        this.sendAndConfirmTransaction = async (transaction, signers = []) => {
            const response = await web3_js.sendAndConfirmTransaction(
                this._connection,
                transaction,
                [this._keypair, ...signers],
                {
                    commitment: this._commitment,
                },
            );
            return response;
        };
        this._publicKey = keypair.publicKey;
        this._keypair = keypair;
        this._connection = new web3_js.Connection(url);
        this._url = url;
        this._commitment = commitment;
    }
}

// TODO consider adding isNodeWallet
const useWallet = (
    keypair,
    url = 'http://127.0.0.1:8899',
    commitment = 'confirmed',
) => {
    url = url !== 'mock' ? url : 'http://127.0.0.1:8899';
    const wallet = new Wallet(keypair, url, commitment);
    return {
        publicKey: wallet._publicKey,
        sendAndConfirmTransaction: wallet.sendAndConfirmTransaction,
        signMessage: wallet.signMessage,
        signTransaction: wallet.signTransaction,
        signAllTransactions: wallet.signAllTransactions,
        sendTransaction: wallet.sendTransaction,
    };
};

const FIELD_SIZE = new anchor.BN(
    '21888242871839275222246405745257275088548364400416034343698204186575808495617',
);
const HIGHEST_ADDRESS_PLUS_ONE = new anchor.BN(
    '452312848583266388373324160190187140051835877600158453279131187530910662655',
);
// TODO: implement properly
const noopProgram = 'noopb9bkMVfRPU8AsbpTUg8AQkHtKwMYZiFUjNRtMmV';
const lightProgram = 'SySTEM1eSU2p4BGQfQpimFEWWSC1XDFeun3Nqzz3rT7';
const accountCompressionProgram = 'compr6CUsB5m2jS4Y3831ztGSTnDpnKJTKS95d64XVq'; // also: merkletree program
const getRegisteredProgramPda = () =>
    new web3_js.PublicKey('35hkDgaAKwMCaxRz2ocSZ6NaUrtKkyNqU6c4RV3tYJRh'); // TODO: better labelling. gov authority pda
const getAccountCompressionAuthority = () =>
    web3_js.PublicKey.findProgramAddressSync(
        [require$$0$1.Buffer.from('cpi_authority')],
        new web3_js.PublicKey(
            // TODO: can add check to ensure its consistent with the idl
            lightProgram,
        ),
    )[0];
const defaultStaticAccounts = () => [
    new web3_js.PublicKey(getRegisteredProgramPda()),
    new web3_js.PublicKey(noopProgram),
    new web3_js.PublicKey(accountCompressionProgram),
    new web3_js.PublicKey(getAccountCompressionAuthority()),
];
const defaultStaticAccountsStruct = () => {
    return {
        registeredProgramPda: new web3_js.PublicKey(getRegisteredProgramPda()),
        noopProgram: new web3_js.PublicKey(noopProgram),
        accountCompressionProgram: new web3_js.PublicKey(
            accountCompressionProgram,
        ),
        accountCompressionAuthority: new web3_js.PublicKey(
            getAccountCompressionAuthority(),
        ),
        cpiSignatureAccount: null,
    };
};
const defaultTestStateTreeAccounts = () => {
    return {
        nullifierQueue: new web3_js.PublicKey(nullifierQueuePubkey),
        merkleTree: new web3_js.PublicKey(merkletreePubkey),
        merkleTreeHeight: DEFAULT_MERKLE_TREE_HEIGHT,
        addressTree: new web3_js.PublicKey(addressTree),
        addressQueue: new web3_js.PublicKey(addressQueue),
    };
};
const nullifierQueuePubkey = 'nfq1NvQDJ2GEgnS8zt9prAe8rjjpAW1zFkrvZoBR148';
const merkletreePubkey = 'smt1NamzXdq4AMqS2fS2F1i5KTYPZRhoHgWx38d8WsT';
const addressTree = 'amt1Ayt45jfbdw5YSo7iz6WZxUmnZsQTYXy82hVwyC2';
const addressQueue = 'aq1S9z4reTSQAdgWHGD2zDaS39sjGrAxbR31vxJ2F4F';
const confirmConfig = {
    commitment: 'confirmed',
    preflightCommitment: 'confirmed',
};
const DEFAULT_MERKLE_TREE_HEIGHT = 26;
const DEFAULT_MERKLE_TREE_ROOTS = 2800;
/** Threshold (per asset) at which new in-UTXOs get merged, in order to reduce UTXO pool size */
const UTXO_MERGE_THRESHOLD = 20;
const UTXO_MERGE_MAXIMUM = 10;
/**
 * Treshold after which the currently used transaction Merkle tree is switched
 * to the next one
 */
const TRANSACTION_MERKLE_TREE_ROLLOVER_THRESHOLD = new anchor.BN(
    Math.floor(2 ** DEFAULT_MERKLE_TREE_HEIGHT * 0.95),
);
/**
 * Fee to provide continous funding for the state Merkle tree.
 * Once the state Merkle tree is at 95% capacity the accumulated fees
 * will be used to fund the next state Merkle tree with the same parameters.
 *
 * Is charged per output compressed account.
 */
const STATE_MERKLE_TREE_ROLLOVER_FEE = new anchor.BN(300);
/**
 * Fee to provide continous funding for the address queue and address Merkle tree.
 * Once the address Merkle tree is at 95% capacity the accumulated fees
 * will be used to fund the next address queue and address tree with the same parameters.
 *
 * Is charged per newly created address.
 */
const ADDRESS_QUEUE_ROLLOVER_FEE = new anchor.BN(392);
/**
 * Is charged if the transaction nullifies at least one compressed account.
 */
const STATE_MERKLE_TREE_NETWORK_FEE = new anchor.BN(5000);
/**
 * Is charged if the transaction creates at least one address.
 */
const ADDRESS_TREE_NETWORK_FEE = new anchor.BN(5000);

var _a$1;
/**
 * Returns true if being run inside a web browser,
 * false if in a Node process or electron app.
 */
process.env.ANCHOR_BROWSER ||
    (typeof window !== 'undefined' &&
        !((_a$1 = window.process) === null || _a$1 === void 0
            ? void 0
            : _a$1.hasOwnProperty('type')));

var safeBuffer = { exports: {} };

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */

(function (module, exports) {
    /* eslint-disable node/no-deprecated-api */
    var buffer = require$$0$1;
    var Buffer = buffer.Buffer;

    // alternative to using Object.keys for old browsers
    function copyProps(src, dst) {
        for (var key in src) {
            dst[key] = src[key];
        }
    }
    if (
        Buffer.from &&
        Buffer.alloc &&
        Buffer.allocUnsafe &&
        Buffer.allocUnsafeSlow
    ) {
        module.exports = buffer;
    } else {
        // Copy properties from require('buffer')
        copyProps(buffer, exports);
        exports.Buffer = SafeBuffer;
    }

    function SafeBuffer(arg, encodingOrOffset, length) {
        return Buffer(arg, encodingOrOffset, length);
    }

    SafeBuffer.prototype = Object.create(Buffer.prototype);

    // Copy static methods from Buffer
    copyProps(Buffer, SafeBuffer);

    SafeBuffer.from = function (arg, encodingOrOffset, length) {
        if (typeof arg === 'number') {
            throw new TypeError('Argument must not be a number');
        }
        return Buffer(arg, encodingOrOffset, length);
    };

    SafeBuffer.alloc = function (size, fill, encoding) {
        if (typeof size !== 'number') {
            throw new TypeError('Argument must be a number');
        }
        var buf = Buffer(size);
        if (fill !== undefined) {
            if (typeof encoding === 'string') {
                buf.fill(fill, encoding);
            } else {
                buf.fill(fill);
            }
        } else {
            buf.fill(0);
        }
        return buf;
    };

    SafeBuffer.allocUnsafe = function (size) {
        if (typeof size !== 'number') {
            throw new TypeError('Argument must be a number');
        }
        return Buffer(size);
    };

    SafeBuffer.allocUnsafeSlow = function (size) {
        if (typeof size !== 'number') {
            throw new TypeError('Argument must be a number');
        }
        return buffer.SlowBuffer(size);
    };
})(safeBuffer, safeBuffer.exports);

var safeBufferExports = safeBuffer.exports;

// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
// @ts-ignore
var _Buffer = safeBufferExports.Buffer;
function base(ALPHABET) {
    if (ALPHABET.length >= 255) {
        throw new TypeError('Alphabet too long');
    }
    var BASE_MAP = new Uint8Array(256);
    for (var j = 0; j < BASE_MAP.length; j++) {
        BASE_MAP[j] = 255;
    }
    for (var i = 0; i < ALPHABET.length; i++) {
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) {
            throw new TypeError(x + ' is ambiguous');
        }
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256); // log(BASE) / log(256), rounded up
    var iFACTOR = Math.log(256) / Math.log(BASE); // log(256) / log(BASE), rounded up
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) {
            source = _Buffer.from(source);
        }
        if (!_Buffer.isBuffer(source)) {
            throw new TypeError('Expected Buffer');
        }
        if (source.length === 0) {
            return '';
        }
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while (pbegin !== pend && source[pbegin] === 0) {
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = ((pend - pbegin) * iFACTOR + 1) >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while (pbegin !== pend) {
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for (
                var it1 = size - 1;
                (carry !== 0 || i < length) && it1 !== -1;
                it1--, i++
            ) {
                carry += (256 * b58[it1]) >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = (carry / BASE) >>> 0;
            }
            if (carry !== 0) {
                throw new Error('Non-zero carry');
            }
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while (it2 !== size && b58[it2] === 0) {
            it2++;
        }
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for (; it2 < size; ++it2) {
            str += ALPHABET.charAt(b58[it2]);
        }
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') {
            throw new TypeError('Expected String');
        }
        if (source.length === 0) {
            return _Buffer.alloc(0);
        }
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while (source[psz] === LEADER) {
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = ((source.length - psz) * FACTOR + 1) >>> 0; // log(58) / log(256), rounded up.
        var b256 = new Uint8Array(size);
        // Process the characters.
        while (source[psz]) {
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) {
                return;
            }
            var i = 0;
            for (
                var it3 = size - 1;
                (carry !== 0 || i < length) && it3 !== -1;
                it3--, i++
            ) {
                carry += (BASE * b256[it3]) >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = (carry / 256) >>> 0;
            }
            if (carry !== 0) {
                throw new Error('Non-zero carry');
            }
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while (it4 !== size && b256[it4] === 0) {
            it4++;
        }
        var vch = _Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while (it4 !== size) {
            vch[j++] = b256[it4++];
        }
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) {
            return buffer;
        }
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode,
    };
}
var src = base;

var basex = src;
var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

var bs58$2 = basex(ALPHABET);

var bs58$3 = /*@__PURE__*/ getDefaultExportFromCjs(bs58$2);

function encode$4(data) {
    return bs58$3.encode(data);
}
function decode$4(data) {
    return bs58$3.decode(data);
}

// TODO: consider implementing BN254 as wrapper class around _BN mirroring
// PublicKey this would encapsulate our runtime checks and also enforce
// typesafety at compile time
const bn = (number, base, endian) => new anchor.BN(number, base, endian);
/** Create a bigint instance with <254-bit max size and base58 capabilities */
const createBN254 = (number, base) => {
    if (base === 'base58') {
        if (typeof number !== 'string')
            throw new Error('Must be a base58 string');
        return createBN254(decode$4(number));
    }
    const bigintNumber = new anchor.BN(number, base);
    return enforceSize(bigintNumber);
};
/**
 * Enforces a maximum size of <254 bits for bigint instances. This is necessary
 * for compatibility with zk-SNARKs, where hashes must be less than the field
 * modulus (~2^254).
 */
function enforceSize(bigintNumber) {
    if (bigintNumber.gte(FIELD_SIZE)) {
        throw new Error('Value is too large. Max <254 bits');
    }
    return bigintNumber;
}
/** Convert <254-bit bigint to Base58 string.  */
function encodeBN254toBase58(bigintNumber) {
    /// enforce size
    const bn254 = createBN254(bigintNumber);
    const bn254Buffer = bn254.toArrayLike(require$$0$1.Buffer, undefined, 32);
    return encode$4(bn254Buffer);
}
//@ts-ignore
if (undefined) {
    //@ts-ignore
    const { it, expect, describe } = undefined;
    describe('createBN254 function', () => {
        it('should create a BN254 from a string', () => {
            const bigint = createBN254('100');
            expect(bigint.toNumber()).toBe(100);
        });
        it('should create a BN254 from a number', () => {
            const bigint = createBN254(100);
            expect(bigint.toNumber()).toBe(100);
        });
        it('should create a BN254 from a bigint', () => {
            const bigint = createBN254(bn(100));
            expect(bigint.toNumber()).toBe(100);
        });
        it('should create a BN254 from a Buffer', () => {
            const bigint = createBN254(require$$0$1.Buffer.from([100]));
            expect(bigint.toNumber()).toBe(100);
        });
        it('should create a BN254 from a Uint8Array', () => {
            const bigint = createBN254(new Uint8Array([100]));
            expect(bigint.toNumber()).toBe(100);
        });
        it('should create a BN254 from a number[]', () => {
            const bigint = createBN254([100]);
            expect(bigint.toNumber()).toBe(100);
        });
        it('should create a BN254 from a base58 string', () => {
            const bigint = createBN254('2j', 'base58');
            expect(bigint.toNumber()).toBe(bn(100).toNumber());
        });
    });
    describe('encodeBN254toBase58 function', () => {
        it('should convert a BN254 to a base58 string, pad to 32 implicitly', () => {
            const bigint = createBN254('100');
            const base58 = encodeBN254toBase58(bigint);
            expect(base58).toBe('11111111111111111111111111111112j');
        });
        it('should match transformation via pubkey', () => {
            const refHash = [
                13, 225, 248, 105, 237, 121, 108, 70, 70, 197, 240, 130, 226,
                236, 129, 58, 213, 50, 236, 99, 216, 99, 91, 201, 141, 76, 196,
                33, 41, 181, 236, 187,
            ];
            const base58 = encodeBN254toBase58(bn(refHash));
            const pubkeyConv = new web3_js.PublicKey(refHash).toBase58();
            expect(base58).toBe(pubkeyConv);
        });
        it('should pad to 32 bytes converting BN to Pubkey', () => {
            const refHash31 = [
                13, 225, 248, 105, 237, 121, 108, 70, 70, 197, 240, 130, 226,
                236, 129, 58, 213, 50, 236, 99, 216, 99, 91, 201, 141, 76, 196,
                33, 41, 181, 236,
            ];
            const base58 = encodeBN254toBase58(bn(refHash31));
            expect(
                createBN254(base58, 'base58').toArray('be', 32),
            ).to.be.deep.equal([0].concat(refHash31));
        });
        it('should throw an error for a value that is too large', () => {
            expect(() => createBN254(FIELD_SIZE)).toThrow(
                'Value is too large. Max <254 bits',
            );
        });
    });
}

const createCompressedAccount = (owner, lamports, data, address) => ({
    owner,
    lamports: lamports !== null && lamports !== void 0 ? lamports : bn(0),
    address: address !== null && address !== void 0 ? address : null,
    data: data !== null && data !== void 0 ? data : null,
});
const createCompressedAccountWithMerkleContext = (
    merkleContext,
    owner,
    lamports,
    data,
    address,
) =>
    Object.assign(
        Object.assign(
            Object.assign(
                {},
                createCompressedAccount(owner, lamports, data, address),
            ),
            merkleContext,
        ),
        { readOnly: false },
    );
const createMerkleContext = (
    merkleTree,
    nullifierQueue,
    hash, // TODO: BN254,
    leafIndex,
) => ({
    merkleTree,
    nullifierQueue,
    hash,
    leafIndex,
});
//@ts-ignore
if (undefined) {
    //@ts-ignore
    const { it, expect, describe } = undefined;
    describe('createCompressedAccount function', () => {
        it('should create a compressed account with default values', () => {
            const owner = web3_js.PublicKey.unique();
            const account = createCompressedAccount(owner);
            expect(account).toEqual({
                owner,
                lamports: bn(0),
                address: null,
                data: null,
            });
        });
        it('should create a compressed account with provided values', () => {
            const owner = web3_js.PublicKey.unique();
            const lamports = bn(100);
            const data = {
                discriminator: [0],
                data: require$$0$1.Buffer.from(new Uint8Array([1, 2, 3])),
                dataHash: [0],
            };
            const address = Array.from(web3_js.PublicKey.unique().toBytes());
            const account = createCompressedAccount(
                owner,
                lamports,
                data,
                address,
            );
            expect(account).toEqual({
                owner,
                lamports,
                address,
                data,
            });
        });
    });
    describe('createCompressedAccountWithMerkleContext function', () => {
        it('should create a compressed account with merkle context', () => {
            const owner = web3_js.PublicKey.unique();
            const merkleTree = web3_js.PublicKey.unique();
            const nullifierQueue = web3_js.PublicKey.unique();
            const hash = new Array(32).fill(1);
            const leafIndex = 0;
            const merkleContext = createMerkleContext(
                merkleTree,
                nullifierQueue,
                hash,
                leafIndex,
            );
            const accountWithMerkleContext =
                createCompressedAccountWithMerkleContext(merkleContext, owner);
            expect(accountWithMerkleContext).toEqual({
                owner,
                lamports: bn(0),
                address: null,
                data: null,
                merkleTree,
                nullifierQueue,
                hash,
                leafIndex,
                readOnly: false,
            });
        });
    });
    describe('createMerkleContext function', () => {
        it('should create a merkle context', () => {
            const merkleTree = web3_js.PublicKey.unique();
            const nullifierQueue = web3_js.PublicKey.unique();
            const hash = new Array(32).fill(1);
            const leafIndex = 0;
            const merkleContext = createMerkleContext(
                merkleTree,
                nullifierQueue,
                hash,
                leafIndex,
            );
            expect(merkleContext).toEqual({
                merkleTree,
                nullifierQueue,
                hash,
                leafIndex,
            });
        });
    });
}

function number$1(n) {
    if (!Number.isSafeInteger(n) || n < 0)
        throw new Error(`positive integer expected, not ${n}`);
}
// copied from utils
function isBytes(a) {
    return (
        a instanceof Uint8Array ||
        (a != null &&
            typeof a === 'object' &&
            a.constructor.name === 'Uint8Array')
    );
}
function bytes$1(b, ...lengths) {
    if (!isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length))
        throw new Error(
            `Uint8Array expected of length ${lengths}, not of length=${b.length}`,
        );
}
function exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished)
        throw new Error('Hash#digest() has already been called');
}
function output(out, instance) {
    bytes$1(out);
    const min = instance.outputLen;
    if (out.length < min) {
        throw new Error(
            `digestInto() expects output buffer of length at least ${min}`,
        );
    }
}

const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function fromBig(n, le = false) {
    if (le)
        return {
            h: Number(n & U32_MASK64),
            l: Number((n >> _32n) & U32_MASK64),
        };
    return {
        h: Number((n >> _32n) & U32_MASK64) | 0,
        l: Number(n & U32_MASK64) | 0,
    };
}
function split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for (let i = 0; i < lst.length; i++) {
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [h, l];
    }
    return [Ah, Al];
}
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s) => (h << s) | (l >>> (32 - s));
const rotlSL = (h, l, s) => (l << s) | (h >>> (32 - s));
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s) => (l << (s - 32)) | (h >>> (64 - s));
const rotlBL = (h, l, s) => (h << (s - 32)) | (l >>> (64 - s));

/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const u32 = arr =>
    new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const isLE = new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44;
// The byte swap operation for uint32
const byteSwap = word =>
    ((word << 24) & 0xff000000) |
    ((word << 8) & 0xff0000) |
    ((word >>> 8) & 0xff00) |
    ((word >>> 24) & 0xff);
// In place byte swap for Uint32Array
function byteSwap32(arr) {
    for (let i = 0; i < arr.length; i++) {
        arr[i] = byteSwap(arr[i]);
    }
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */
function utf8ToBytes(str) {
    if (typeof str !== 'string')
        throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */
function toBytes(data) {
    if (typeof data === 'string') data = utf8ToBytes(data);
    bytes$1(data);
    return data;
}
// For runtime check if class implements interface
class Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
function wrapConstructor(hashCons) {
    const hashC = msg => hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = () => hashCons();
    return hashC;
}

// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const SHA3_PI = [];
const SHA3_ROTL = [];
const _SHA3_IOTA = [];
const _0n = /* @__PURE__ */ BigInt(0);
const _1n = /* @__PURE__ */ BigInt(1);
const _2n = /* @__PURE__ */ BigInt(2);
const _7n = /* @__PURE__ */ BigInt(7);
const _256n = /* @__PURE__ */ BigInt(256);
const _0x71n = /* @__PURE__ */ BigInt(0x71);
for (let round = 0, R = _1n, x = 1, y = 0; round < 24; round++) {
    // Pi
    [x, y] = [y, (2 * x + 3 * y) % 5];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((((round + 1) * (round + 2)) / 2) % 64);
    // Iota
    let t = _0n;
    for (let j = 0; j < 7; j++) {
        R = ((R << _1n) ^ ((R >> _7n) * _0x71n)) % _256n;
        if (R & _2n) t ^= _1n << ((_1n << /* @__PURE__ */ BigInt(j)) - _1n);
    }
    _SHA3_IOTA.push(t);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ split(_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const rotlH = (h, l, s) => (s > 32 ? rotlBH(h, l, s) : rotlSH(h, l, s));
const rotlL = (h, l, s) => (s > 32 ? rotlBL(h, l, s) : rotlSL(h, l, s));
// Same as keccakf1600, but allows to skip some rounds
function keccakP(s, rounds = 24) {
    const B = new Uint32Array(5 * 2);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for (let round = 24 - rounds; round < 24; round++) {
        // Theta θ
        for (let x = 0; x < 10; x++)
            B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for (let x = 0; x < 10; x += 2) {
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for (let y = 0; y < 50; y += 10) {
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for (let t = 0; t < 24; t++) {
            const shift = SHA3_ROTL[t];
            const Th = rotlH(curH, curL, shift);
            const Tl = rotlL(curH, curL, shift);
            const PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for (let y = 0; y < 50; y += 10) {
            for (let x = 0; x < 10; x++) B[x] = s[y + x];
            for (let x = 0; x < 10; x++)
                s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class Keccak extends Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24) {
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        number$1(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200)
            throw new Error('Sha3 supports only keccak-f1600 function');
        this.state = new Uint8Array(200);
        this.state32 = u32(this.state);
    }
    keccak() {
        if (!isLE) byteSwap32(this.state32);
        keccakP(this.state32, this.rounds);
        if (!isLE) byteSwap32(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        exists(this);
        const { blockLen, state } = this;
        data = toBytes(data);
        const len = data.length;
        for (let pos = 0; pos < len; ) {
            const take = Math.min(blockLen - this.pos, len - pos);
            for (let i = 0; i < take; i++) state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state, suffix, pos, blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        exists(this, false);
        bytes$1(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen } = this;
        for (let pos = 0, len = out.length; pos < len; ) {
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF)
            throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        number$1(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        output(out, this);
        if (this.finished) throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const gen = (suffix, blockLen, outputLen) =>
    wrapConstructor(() => new Keccak(blockLen, suffix, outputLen));
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */
const keccak_256 = /* @__PURE__ */ gen(0x01, 136, 256 / 8);

function byteArrayToKeypair(byteArray) {
    return web3_js.Keypair.fromSecretKey(Uint8Array.from(byteArray));
}
/**
 * @internal
 * convert BN to hex with '0x' prefix
 */
function toHex(bn) {
    return '0x' + bn.toString('hex');
}
const toArray$1 = value => (Array.isArray(value) ? value : [value]);
const bufToDecStr = buf => {
    return createBN254(buf).toString();
};
function isSmallerThanBn254FieldSizeBe(bytes) {
    const bigint = bn(bytes, undefined, 'be');
    return bigint.lt(FIELD_SIZE);
}
async function hashToBn254FieldSizeBe(bytes) {
    let bumpSeed = 255;
    while (bumpSeed >= 0) {
        const inputWithBumpSeed = require$$0$1.Buffer.concat([
            bytes,
            require$$0$1.Buffer.from([bumpSeed]),
        ]);
        const hash = keccak_256(inputWithBumpSeed);
        if (hash.length !== 32) {
            throw new Error('Invalid hash length');
        }
        hash[0] = 0;
        if (isSmallerThanBn254FieldSizeBe(require$$0$1.Buffer.from(hash))) {
            return [require$$0$1.Buffer.from(hash), bumpSeed];
        }
        bumpSeed -= 1;
    }
    return null;
}
/** Mutates array in place */
function pushUniqueItems(items, map) {
    items.forEach(item => {
        if (!map.includes(item)) {
            map.push(item);
        }
    });
}
function toCamelCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map(v => toCamelCase(v));
    } else if (obj !== null && obj.constructor === Object) {
        return Object.keys(obj).reduce((result, key) => {
            const camelCaseKey = key.replace(/([-_][a-z])/gi, $1 => {
                return $1.toUpperCase().replace('-', '').replace('_', '');
            });
            result[camelCaseKey] = toCamelCase(obj[key]);
            return result;
        }, {});
    }
    return obj;
}
// FIXME: check bundling and how to resolve the type error
//@ts-ignore
if (undefined) {
    //@ts-ignore
    const { it, expect, describe } = undefined;
    describe('toArray function', () => {
        it('should convert a single item to an array', () => {
            expect(toArray$1(1)).toEqual([1]);
        });
        it('should leave an array unchanged', () => {
            expect(toArray$1([1, 2, 3])).toEqual([1, 2, 3]);
        });
    });
    describe('isSmallerThanBn254FieldSizeBe function', () => {
        it('should return true for a small number', () => {
            const buf = require$$0$1.Buffer.from(
                '0000000000000000000000000000000000000000000000000000000000000000',
                'hex',
            );
            expect(isSmallerThanBn254FieldSizeBe(buf)).toBe(true);
        });
        it('should return false for a large number', () => {
            const buf = require$$0$1.Buffer.from(
                '0000000000000000000000000000000000000000000000000000000000000065',
                'hex',
            ).reverse();
            expect(isSmallerThanBn254FieldSizeBe(buf)).toBe(false);
        });
    });
    describe('hashToBn254FieldSizeBe function', () => {
        const bytes = [
            131, 219, 249, 246, 221, 196, 33, 3, 114, 23, 121, 235, 18, 229, 71,
            152, 39, 87, 169, 208, 143, 101, 43, 128, 245, 59, 22, 134, 182,
            231, 116, 33,
        ];
        const refResult = [
            0, 146, 15, 187, 171, 163, 183, 93, 237, 121, 37, 231, 55, 162, 208,
            188, 244, 77, 185, 157, 93, 9, 101, 193, 220, 247, 109, 94, 48, 212,
            98, 149,
        ];
        it('should return a valid value for initial buffer', async () => {
            const result = await hashToBn254FieldSizeBe(
                require$$0$1.Buffer.from(bytes),
            );
            expect(Array.from(result[0])).toEqual(refResult);
        });
        it('should return a valid value for initial buffer', async () => {
            const buf = require$$0$1.Buffer.from(
                '0000000000000000000000000000000000000000000000000000000000000000',
                'hex',
            );
            const result = await hashToBn254FieldSizeBe(buf);
            expect(result).not.toBeNull();
            if (result) {
                expect(result[0]).toBeInstanceOf(require$$0$1.Buffer);
                expect(result[1]).toBe(255);
            }
        });
        it('should return a valid value for a buffer that can be hashed to a smaller value', async () => {
            const buf = require$$0$1.Buffer.from(
                'fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe',
                'hex',
            );
            const result = await hashToBn254FieldSizeBe(buf);
            expect(result).not.toBeNull();
            if (result) {
                expect(result[1]).toBeLessThanOrEqual(255);
                expect(result[0]).toBeInstanceOf(require$$0$1.Buffer);
                // Check if the hashed value is indeed smaller than the bn254 field size
                expect(isSmallerThanBn254FieldSizeBe(result[0])).toBe(true);
            }
        });
        it('should correctly hash the input buffer', async () => {
            const buf = require$$0$1.Buffer.from('deadbeef', 'hex');
            const result = await hashToBn254FieldSizeBe(buf);
            expect(result).not.toBeNull();
            if (result) {
                // Since the actual hash value depends on the crypto implementation and input,
                // we cannot predict the exact output. However, we can check if the output is valid.
                expect(result[0].length).toBe(32); // SHA-256 hash length
                expect(result[1]).toBeLessThanOrEqual(255);
                expect(isSmallerThanBn254FieldSizeBe(result[0])).toBe(true);
            }
        });
    });
    describe('pushUniqueItems function', () => {
        it('should add unique items', () => {
            const map = [1, 2, 3];
            const itemsToAdd = [3, 4, 5];
            pushUniqueItems(itemsToAdd, map);
            expect(map).toEqual([1, 2, 3, 4, 5]);
        });
        it('should ignore duplicates', () => {
            const map = [1, 2, 3];
            const itemsToAdd = [1, 2, 3];
            pushUniqueItems(itemsToAdd, map);
            expect(map).toEqual([1, 2, 3]);
        });
        it('should handle empty arrays', () => {
            const map = [];
            const itemsToAdd = [];
            pushUniqueItems(itemsToAdd, map);
            expect(map).toEqual([]);
        });
    });
    describe('bufToDecStr', () => {
        it("should convert buffer [0] to '0'", () => {
            expect(bufToDecStr(require$$0$1.Buffer.from([0]))).toEqual('0');
        });
        it("should convert buffer [1] to '1'", () => {
            expect(bufToDecStr(require$$0$1.Buffer.from([1]))).toEqual('1');
        });
        it("should convert buffer [1, 0] to '256'", () => {
            expect(bufToDecStr(require$$0$1.Buffer.from([1, 0]))).toEqual(
                '256',
            );
        });
        it("should convert buffer [1, 1] to '257'", () => {
            expect(bufToDecStr(require$$0$1.Buffer.from([1, 1]))).toEqual(
                '257',
            );
        });
        it("should convert buffer [7, 91, 205, 21] to '123456789'", () => {
            expect(
                bufToDecStr(require$$0$1.Buffer.from([7, 91, 205, 21])),
            ).toEqual('123456789');
        });
    });
    describe('toCamelCase', () => {
        it('should convert object keys to camelCase', () => {
            const input = { test_key: 1, 'another-testKey': 2 };
            const expected = { testKey: 1, anotherTestKey: 2 };
            expect(toCamelCase(input)).toEqual(expected);
        });
        it('should handle arrays of objects', () => {
            const input = [{ array_key: 3 }, { 'another_array-key': 4 }];
            const expected = [{ arrayKey: 3 }, { anotherArrayKey: 4 }];
            expect(toCamelCase(input)).toEqual(expected);
        });
        it('should return the input if it is neither an object nor an array', () => {
            const input = 'testString';
            expect(toCamelCase(input)).toBe(input);
        });
    });
}

/**
 * @internal Finds the index of a PublicKey in an array, or adds it if not
 * present
 * */
function getIndexOrAdd(accountsArray, key) {
    const index = accountsArray.findIndex(existingKey =>
        existingKey.equals(key),
    );
    if (index === -1) {
        accountsArray.push(key);
        return accountsArray.length - 1;
    }
    return index;
}
/** @internal */
function padOutputStateMerkleTrees(
    outputStateMerkleTrees,
    numberOfOutputCompressedAccounts,
    inputCompressedAccountsWithMerkleContext,
) {
    if (numberOfOutputCompressedAccounts <= 0) {
        return [];
    }
    /// Default: use the 0th state tree of input state for all output accounts
    if (outputStateMerkleTrees === undefined) {
        if (inputCompressedAccountsWithMerkleContext.length === 0) {
            return new Array(numberOfOutputCompressedAccounts).fill(
                defaultTestStateTreeAccounts().merkleTree,
            );
        }
        return new Array(numberOfOutputCompressedAccounts).fill(
            inputCompressedAccountsWithMerkleContext[0].merkleTree,
        );
        /// Align the number of output state trees with the number of output
        /// accounts, and fill up with 0th output state tree
    } else {
        /// Into array
        const treesArray = toArray$1(outputStateMerkleTrees);
        if (treesArray.length >= numberOfOutputCompressedAccounts) {
            return treesArray.slice(0, numberOfOutputCompressedAccounts);
        } else {
            return treesArray.concat(
                new Array(
                    numberOfOutputCompressedAccounts - treesArray.length,
                ).fill(treesArray[0]),
            );
        }
    }
}
function toAccountMetas(remainingAccounts) {
    return remainingAccounts.map(account => ({
        pubkey: account,
        isWritable: true,
        isSigner: false,
    }));
}
// TODO: include owner and lamports in packing.
/**
 * Packs Compressed Accounts.
 *
 * Replaces PublicKey with index pointer to remaining accounts.
 *
 * @param inputCompressedAccounts           Ix input state to be consumed
 * @param inputStateRootIndices             The recent state root indices of the
 *                                          input state. The expiry is tied to
 *                                          the proof.
 * @param outputCompressedAccounts          Ix output state to be created
 * @param outputStateMerkleTrees            Optional output state trees to be
 *                                          inserted into the output state.
 *                                          Defaults to the 0th state tree of
 *                                          the input state. Gets padded to the
 *                                          length of outputCompressedAccounts.
 *
 * @param remainingAccounts                 Optional existing array of accounts
 *                                          to append to.
 **/
function packCompressedAccounts(
    inputCompressedAccounts,
    inputStateRootIndices,
    outputCompressedAccounts,
    outputStateMerkleTrees,
    remainingAccounts = [],
) {
    const _remainingAccounts = remainingAccounts.slice();
    const packedInputCompressedAccounts = [];
    const packedOutputCompressedAccounts = [];
    /// input
    inputCompressedAccounts.forEach((account, index) => {
        const merkleTreePubkeyIndex = getIndexOrAdd(
            _remainingAccounts,
            account.merkleTree,
        );
        const nullifierQueuePubkeyIndex = getIndexOrAdd(
            _remainingAccounts,
            account.nullifierQueue,
        );
        packedInputCompressedAccounts.push({
            compressedAccount: {
                owner: account.owner,
                lamports: account.lamports,
                address: account.address,
                data: account.data,
            },
            merkleContext: {
                merkleTreePubkeyIndex,
                nullifierQueuePubkeyIndex,
                leafIndex: account.leafIndex,
                queueIndex: null,
            },
            rootIndex: inputStateRootIndices[index],
            readOnly: false,
        });
    });
    /// output
    const paddedOutputStateMerkleTrees = padOutputStateMerkleTrees(
        outputStateMerkleTrees,
        outputCompressedAccounts.length,
        inputCompressedAccounts,
    );
    outputCompressedAccounts.forEach((account, index) => {
        const merkleTreePubkeyIndex = getIndexOrAdd(
            _remainingAccounts,
            paddedOutputStateMerkleTrees[index],
        );
        packedOutputCompressedAccounts.push({
            compressedAccount: {
                owner: account.owner,
                lamports: account.lamports,
                address: account.address,
                data: account.data,
            },
            merkleTreeIndex: merkleTreePubkeyIndex,
        });
    });
    return {
        packedInputCompressedAccounts,
        packedOutputCompressedAccounts,
        remainingAccounts: _remainingAccounts,
    };
}
//@ts-ignore
if (undefined) {
    //@ts-ignore
    const { describe, it, expect } = undefined;
    // Inline unit tests for padOutputStateMerkleTrees function
    describe('padOutputStateMerkleTrees', () => {
        const treeA = web3_js.PublicKey.unique();
        const treeB = web3_js.PublicKey.unique();
        const treeC = web3_js.PublicKey.unique();
        const accA = { merkleTree: treeA };
        const accB = { merkleTree: treeB };
        it('should use the 0th state tree of input state if no output state trees are provided', () => {
            const result = padOutputStateMerkleTrees(undefined, 3, [
                accA,
                accB,
            ]);
            expect(result).toEqual([treeA, treeA, treeA]);
        });
        it('should fill up with the first state tree if provided trees are less than required', () => {
            const result = padOutputStateMerkleTrees([treeA, treeB], 5, []);
            expect(result).toEqual([treeA, treeB, treeA, treeA, treeA]);
        });
        it('should remove extra trees if the number of output state trees is greater than the number of output accounts', () => {
            const result = padOutputStateMerkleTrees(
                [treeA, treeB, treeC],
                2,
                [],
            );
            expect(result).toEqual([treeA, treeB]);
        });
        it('should return the same outputStateMerkleTrees if its length equals the number of output compressed accounts', () => {
            const result = padOutputStateMerkleTrees(
                [treeA, treeB, treeC],
                3,
                [],
            );
            expect(result).toEqual([treeA, treeB, treeC]);
        });
    });
}

const validateSufficientBalance = balance => {
    if (balance.lt(bn(0))) {
        throw new Error('Not enough balance for transfer');
    }
};
const validateSameOwner = compressedAccounts => {
    if (compressedAccounts.length === 0) {
        throw new Error('No accounts provided for validation');
    }
    const zerothOwner = compressedAccounts[0].owner;
    if (
        !compressedAccounts.every(account => account.owner.equals(zerothOwner))
    ) {
        throw new Error('All input accounts must have the same owner');
    }
};

/**
 * Derive an address for a compressed account from a seed and a merkle tree
 * public key.
 *
 * @param seed              Seed to derive the address from
 * @param merkleTreePubkey  Merkle tree public key. Defaults to
 *                          defaultTestStateTreeAccounts().merkleTree
 * @returns                 Derived address
 */
async function deriveAddress(
    seed,
    merkleTreePubkey = defaultTestStateTreeAccounts().merkleTree,
) {
    const bytes = merkleTreePubkey.toBytes();
    const combined = Buffer.from([...bytes, ...seed]);
    const hash = await hashToBn254FieldSizeBe(combined);
    if (hash === null) {
        throw new Error('DeriveAddressError');
    }
    const buf = hash[0];
    return new web3_js.PublicKey(buf);
}
/**
 * Packs new address params for instruction data in TypeScript clients
 *
 * @param newAddressParams      New address params
 * @param remainingAccounts     Remaining accounts
 * @returns                     Packed new address params
 */
function packNewAddressParams(newAddressParams, remainingAccounts) {
    const _remainingAccounts = remainingAccounts.slice();
    const newAddressParamsPacked = newAddressParams.map(x => ({
        seed: Array.from(x.seed),
        addressMerkleTreeRootIndex: x.addressMerkleTreeRootIndex,
        addressMerkleTreeAccountIndex: 0, // will be assigned later
        addressQueueAccountIndex: 0, // will be assigned later
    }));
    newAddressParams.forEach((params, i) => {
        newAddressParamsPacked[i].addressMerkleTreeAccountIndex = getIndexOrAdd(
            _remainingAccounts,
            params.addressMerkleTreePubkey,
        );
    });
    newAddressParams.forEach((params, i) => {
        newAddressParamsPacked[i].addressQueueAccountIndex = getIndexOrAdd(
            _remainingAccounts,
            params.addressQueuePubkey,
        );
    });
    return { newAddressParamsPacked, remainingAccounts: _remainingAccounts };
}
//@ts-ignore
if (undefined) {
    //@ts-ignore
    const { it, expect, describe } = undefined;
    describe('deriveAddress function', () => {
        it('should derive a valid address from a seed and a merkle tree public key', async () => {
            const seed = new Uint8Array([1, 2, 3, 4]);
            const merkleTreePubkey = new web3_js.PublicKey(
                '11111111111111111111111111111111',
            );
            const derivedAddress = await deriveAddress(seed, merkleTreePubkey);
            expect(derivedAddress).toBeInstanceOf(web3_js.PublicKey);
        });
    });
    describe('packNewAddressParams function', () => {
        it('should pack new address params correctly', () => {
            const newAddressParams = [
                {
                    seed: new Uint8Array([1, 2, 3, 4]),
                    addressMerkleTreeRootIndex: 0,
                    addressMerkleTreePubkey: new web3_js.PublicKey(
                        '11111111111111111111111111111111',
                    ),
                    addressQueuePubkey: new web3_js.PublicKey(
                        '11111111111111111111111111111112',
                    ),
                },
            ];
            const remainingAccounts = [
                new web3_js.PublicKey('11111111111111111111111111111112'),
                new web3_js.PublicKey('11111111111111111111111111111111'),
            ];
            const packedParams = packNewAddressParams(
                newAddressParams,
                remainingAccounts,
            );
            expect(
                packedParams.newAddressParamsPacked[0]
                    .addressMerkleTreeAccountIndex,
            ).toBe(1);
            expect(
                packedParams.newAddressParamsPacked[0].addressQueueAccountIndex,
            ).toBe(0);
        });
    });
}

async function airdropSol({ connection, lamports, recipientPublicKey }) {
    const txHash = await connection.requestAirdrop(
        recipientPublicKey,
        lamports,
    );
    await confirmTransaction(connection, txHash);
    return txHash;
}
async function confirmTransaction(
    connection,
    signature,
    confirmation = 'confirmed',
) {
    const latestBlockHash = await connection.getLatestBlockhash(confirmation);
    const strategy = {
        signature: signature.toString(),
        lastValidBlockHeight: latestBlockHash.lastValidBlockHeight,
        blockhash: latestBlockHash.blockhash,
    };
    return await connection.confirmTransaction(strategy, confirmation);
}

const placeholderValidityProof = () => ({
    a: Array.from({ length: 32 }, (_, i) => i + 1),
    b: Array.from({ length: 64 }, (_, i) => i + 1),
    c: Array.from({ length: 32 }, (_, i) => i + 1),
});
const checkValidityProofShape = proof => {
    if (
        proof.a.length !== 32 ||
        proof.b.length !== 64 ||
        proof.c.length !== 32
    ) {
        throw new Error('ValidityProof has invalid shape');
    }
};
function proofFromJsonStruct(json) {
    const proofAX = deserializeHexStringToBeBytes(json.ar[0]);
    const proofAY = deserializeHexStringToBeBytes(json.ar[1]);
    const proofA = new Uint8Array([...proofAX, ...proofAY]);
    const proofBX0 = deserializeHexStringToBeBytes(json.bs[0][0]);
    const proofBX1 = deserializeHexStringToBeBytes(json.bs[0][1]);
    const proofBY0 = deserializeHexStringToBeBytes(json.bs[1][0]);
    const proofBY1 = deserializeHexStringToBeBytes(json.bs[1][1]);
    const proofB = new Uint8Array([
        ...proofBX0,
        ...proofBX1,
        ...proofBY0,
        ...proofBY1,
    ]);
    const proofCX = deserializeHexStringToBeBytes(json.krs[0]);
    const proofCY = deserializeHexStringToBeBytes(json.krs[1]);
    const proofC = new Uint8Array([...proofCX, ...proofCY]);
    const proofABC = { a: proofA, b: proofB, c: proofC };
    return proofABC;
}
// TODO: add unit test for negation
// TODO: test if LE BE issue. unit test
function negateAndCompressProof(proof) {
    const proofA = proof.a;
    const proofB = proof.b;
    const proofC = proof.c;
    const aXElement = proofA.slice(0, 32);
    const aYElement = new anchor.BN(proofA.slice(32, 64), 32, 'be');
    /// Negate
    const proofAIsPositive = yElementIsPositiveG1(aYElement) ? false : true;
    /// First byte of proofA is the bitmask
    aXElement[0] = addBitmaskToByte(aXElement[0], proofAIsPositive);
    const bXElement = proofB.slice(0, 64);
    const bYElement = proofB.slice(64, 128);
    const proofBIsPositive = yElementIsPositiveG2(
        new anchor.BN(bYElement.slice(0, 32), 32, 'be'),
        new anchor.BN(bYElement.slice(32, 64), 32, 'be'),
    );
    bXElement[0] = addBitmaskToByte(bXElement[0], proofBIsPositive);
    const cXElement = proofC.slice(0, 32);
    const cYElement = proofC.slice(32, 64);
    const proofCIsPositive = yElementIsPositiveG1(
        new anchor.BN(cYElement, 32, 'be'),
    );
    cXElement[0] = addBitmaskToByte(cXElement[0], proofCIsPositive);
    const compressedProof = {
        a: Array.from(aXElement),
        b: Array.from(bXElement),
        c: Array.from(cXElement),
    };
    return compressedProof;
}
function deserializeHexStringToBeBytes(hexStr) {
    // Using BN for simpler conversion from hex string to byte array
    const bn = new anchor.BN(
        hexStr.startsWith('0x') ? hexStr.substring(2) : hexStr,
        'hex',
    );
    return new Uint8Array(bn.toArray('be', 32));
}
function yElementIsPositiveG1(yElement) {
    return yElement.lte(FIELD_SIZE.sub(yElement));
}
function yElementIsPositiveG2(yElement1, yElement2) {
    const fieldMidpoint = FIELD_SIZE.div(new anchor.BN(2));
    // Compare the first component of the y coordinate
    if (yElement1.lt(fieldMidpoint)) {
        return true;
    } else if (yElement1.gt(fieldMidpoint)) {
        return false;
    }
    // If the first component is equal to the midpoint, compare the second component
    return yElement2.lt(fieldMidpoint);
}
// bitmask compatible with solana altbn128 compression syscall and arkworks' implementation
// https://github.com/arkworks-rs/algebra/blob/master/ff/src/fields/models/fp/mod.rs#L580
// https://github.com/arkworks-rs/algebra/blob/master/serialize/src/flags.rs#L18
// fn u8_bitmask(value: u8, inf: bool, neg: bool) -> u8 {
//     let mut mask = 0;
//     match self {
//         inf => mask |= 1 << 6,
//         neg => mask |= 1 << 7,
//         _ => (),
//     }
//     mask
// }
function addBitmaskToByte(byte, yIsPositive) {
    if (!yIsPositive) {
        return (byte |= 1 << 7);
    } else {
        return byte;
    }
}
//@ts-ignore
if (undefined) {
    //@ts-ignore
    const { it, expect, describe } = undefined;
    // Unit test for addBitmaskToByte function
    describe('addBitmaskToByte', () => {
        it('should add a bitmask to the byte if yIsPositive is false', () => {
            const byte = 0b00000000;
            const yIsPositive = false;
            const result = addBitmaskToByte(byte, yIsPositive);
            expect(result).toBe(0b10000000); // 128 in binary, which is 1 << 7
        });
        it('should not modify the byte if yIsPositive is true', () => {
            const byte = 0b00000000;
            const yIsPositive = true;
            const result = addBitmaskToByte(byte, yIsPositive);
            expect(result).toBe(0b00000000);
        });
    });
    describe('test prover server', () => {
        const TEST_JSON = {
            ar: [
                '0x22bdaa3187d8fe294925a66fa0165a11bc9e07678fa2fc72402ebfd33d521c69',
                '0x2d18ff780b69898b4cdd8d7b6ac72d077799399f0f45e52665426456f3903584',
            ],
            bs: [
                [
                    '0x138cc0962e49f76a701d2871d2799892c9782940095eb0429e979f336d2e162d',
                    '0x2fe1bfbb15cbfb83d7e00ace23e45f890604003783eaf34affa35e0d6f4822bc',
                ],
                [
                    '0x1a89264f82cc6e8ef1c696bea0b5803c28c0ba6ab61366bcb71e73a4135cae8d',
                    '0xf778d857b3df01a4100265c9d014ce02d47425f0114685356165fa5ee3f3a26',
                ],
            ],
            krs: [
                '0x176b6ae9001f66832951e2d43a98a972667447bb1781f534b70cb010270dcdd3',
                '0xb748d5fac1686db28d94c02250af7eb4f28dfdabc8983305c45bcbc6e163eeb',
            ],
        };
        const COMPRESSED_PROOF_A = [
            34, 189, 170, 49, 135, 216, 254, 41, 73, 37, 166, 111, 160, 22, 90,
            17, 188, 158, 7, 103, 143, 162, 252, 114, 64, 46, 191, 211, 61, 82,
            28, 105,
        ];
        const COMPRESSED_PROOF_B = [
            147, 140, 192, 150, 46, 73, 247, 106, 112, 29, 40, 113, 210, 121,
            152, 146, 201, 120, 41, 64, 9, 94, 176, 66, 158, 151, 159, 51, 109,
            46, 22, 45, 47, 225, 191, 187, 21, 203, 251, 131, 215, 224, 10, 206,
            35, 228, 95, 137, 6, 4, 0, 55, 131, 234, 243, 74, 255, 163, 94, 13,
            111, 72, 34, 188,
        ];
        const COMPRESSED_PROOF_C = [
            23, 107, 106, 233, 0, 31, 102, 131, 41, 81, 226, 212, 58, 152, 169,
            114, 102, 116, 71, 187, 23, 129, 245, 52, 183, 12, 176, 16, 39, 13,
            205, 211,
        ];
        it('should execute a compressed token mint', async () => {
            const proof = proofFromJsonStruct(TEST_JSON);
            const compressedProof = negateAndCompressProof(proof);
            expect(compressedProof.a).toEqual(COMPRESSED_PROOF_A);
            expect(compressedProof.b).toEqual(COMPRESSED_PROOF_B);
            expect(compressedProof.c).toEqual(COMPRESSED_PROOF_C);
        });
    });
    describe('Validity Proof Functions', () => {
        describe('placeholderValidityProof', () => {
            it('should create a validity proof with correct shape', () => {
                const validityProof = placeholderValidityProof();
                expect(validityProof.a.length).toBe(32);
                expect(validityProof.b.length).toBe(64);
                expect(validityProof.c.length).toBe(32);
            });
        });
        describe('checkValidityProofShape', () => {
            it('should not throw an error for valid proof shape', () => {
                const validProof = {
                    a: Array.from(new Uint8Array(32)),
                    b: Array.from(new Uint8Array(64)),
                    c: Array.from(new Uint8Array(32)),
                };
                expect(() => checkValidityProofShape(validProof)).not.toThrow();
            });
            it('should throw an error for an invalid proof', () => {
                const invalidProof = {
                    a: Array.from(new Uint8Array(31)), // incorrect length
                    b: Array.from(new Uint8Array(64)),
                    c: Array.from(new Uint8Array(32)),
                };
                expect(() => checkValidityProofShape(invalidProof)).toThrow(
                    'ValidityProof has invalid shape',
                );
            });
        });
    });
}

/** pipe function */
function pipe(initialFunction, ...functions) {
    return initialValue =>
        functions.reduce(
            (currentValue, currentFunction) => currentFunction(currentValue),
            initialFunction(initialValue),
        );
}
//@ts-ignore
if (undefined) {
    //@ts-ignore
    const { it, expect, describe } = undefined;
    describe('pipe', () => {
        it('should return the result of applying all fns to the initial value', () => {
            const addOne = x => x + 1;
            const multiplyByTwo = x => x * 2;
            const subtractThree = x => x - 3;
            const addOneMultiplyByTwoSubtractThree = pipe(
                addOne,
                multiplyByTwo,
                subtractThree,
            );
            expect(addOneMultiplyByTwoSubtractThree(5)).toBe(9);
        });
    });
}

/**
 * Builds a versioned Transaction from instructions.
 *
 * @param instructions          instructions to include
 * @param payerPublicKey        fee payer public key
 * @param blockhash             blockhash to use
 * @param lookupTableAccounts   lookup table accounts to include
 *
 * @return VersionedTransaction
 */
function buildTx(instructions, payerPublicKey, blockhash, lookupTableAccounts) {
    const messageV0 = new web3_js.TransactionMessage({
        payerKey: payerPublicKey,
        recentBlockhash: blockhash,
        instructions,
    }).compileToV0Message(lookupTableAccounts);
    return new web3_js.VersionedTransaction(messageV0);
}
/**
 * Sends a versioned transaction and confirms it.
 *
 * @param rpc               connection to use
 * @param tx                versioned transaction to send
 * @param confirmOptions    confirmation options
 * @param blockHashCtx      blockhash context for confirmation
 *
 * @return TransactionSignature
 */
async function sendAndConfirmTx(rpc, tx, confirmOptions, blockHashCtx) {
    const txId = await rpc.sendTransaction(tx, confirmOptions);
    if (!blockHashCtx) blockHashCtx = await rpc.getLatestBlockhash();
    const transactionConfirmationStrategy0 = {
        signature: txId,
        blockhash: blockHashCtx.blockhash,
        lastValidBlockHeight: blockHashCtx.lastValidBlockHeight,
    };
    const ctxAndRes = await rpc.confirmTransaction(
        transactionConfirmationStrategy0,
        (confirmOptions === null || confirmOptions === void 0
            ? void 0
            : confirmOptions.commitment) ||
            rpc.commitment ||
            'confirmed',
    );
    const slot = ctxAndRes.context.slot;
    await rpc.confirmTransactionIndexed(slot);
    return txId;
}
/**
 * Confirms a transaction with a given txId.
 *
 * @param rpc               connection to use
 * @param txId              transaction signature to confirm
 * @param confirmOptions    confirmation options
 * @param blockHashCtx      blockhash context for confirmation
 * @return SignatureResult
 */
async function confirmTx(rpc, txId, confirmOptions, blockHashCtx) {
    if (!blockHashCtx) blockHashCtx = await rpc.getLatestBlockhash();
    const transactionConfirmationStrategy = {
        signature: txId,
        blockhash: blockHashCtx.blockhash,
        lastValidBlockHeight: blockHashCtx.lastValidBlockHeight,
    };
    const res = await rpc.confirmTransaction(
        transactionConfirmationStrategy,
        (confirmOptions === null || confirmOptions === void 0
            ? void 0
            : confirmOptions.commitment) ||
            rpc.commitment ||
            'confirmed',
    );
    const slot = res.context.slot;
    await rpc.confirmTransactionIndexed(slot);
    return res;
}
/**
 * Builds a versioned Transaction from instructions and signs it.
 *
 * @param instructions          instructions to include in the transaction
 * @param payer                 payer of the transaction
 * @param blockhash             recent blockhash to use in the transaction
 * @param additionalSigners     non-feepayer signers to include in the
 *                              transaction
 * @param lookupTableAccounts   lookup table accounts to include in the
 *                              transaction
 */
function buildAndSignTx(
    instructions,
    payer,
    blockhash,
    additionalSigners = [],
    lookupTableAccounts,
) {
    if (additionalSigners.includes(payer))
        throw new Error('payer must not be in additionalSigners');
    const allSigners = [payer, ...additionalSigners];
    const tx = buildTx(
        instructions,
        payer.publicKey,
        blockhash,
        lookupTableAccounts,
    );
    tx.sign(allSigners);
    return tx;
}

// zzz
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

let c = 1;
const ALICE = getTestKeypair(255);
const BOB = getTestKeypair(254);
const CHARLIE = getTestKeypair(253);
const DAVE = getTestKeypair(252);
/**
 * Create a new account and airdrop lamports to it
 *
 * @param rpc       connection to use
 * @param lamports  amount of lamports to airdrop
 * @param counter   counter to use for generating the keypair.
 *                  If undefined or >255, generates random keypair.
 */
async function newAccountWithLamports(
    rpc,
    lamports = 1000000000,
    counter = undefined,
) {
    /// get random keypair
    if (counter === undefined || counter > 255) {
        counter = 256;
    }
    const account = getTestKeypair(counter);
    const sig = await rpc.requestAirdrop(account.publicKey, lamports);
    await confirmTx(rpc, sig);
    return account;
}
function getConnection() {
    const url = 'http://127.0.0.1:8899';
    const connection = new web3_js.Connection(url, 'confirmed');
    return connection;
}
/**
 * For use in tests.
 * Generate a unique keypair by passing in a counter <255. If no counter
 * is supplied, it uses and increments a global counter.
 * if counter > 255, generates random keypair
 */
function getTestKeypair(counter = undefined) {
    if (!counter) {
        counter = c;
        c++;
    }
    if (counter > 255) {
        return web3_js.Keypair.generate();
    }
    const seed = new Uint8Array(32);
    seed[31] = counter; // le
    return web3_js.Keypair.fromSeed(seed);
}
//@ts-ignore
if (undefined) {
    //@ts-ignore
    const { describe, it, expect } = undefined;
    describe('getTestKeypair', () => {
        it('should generate a keypair with a specific counter', () => {
            const keypair = getTestKeypair(10);
            const keypair2 = getTestKeypair(10);
            expect(keypair).toEqual(keypair2);
            expect(keypair).toBeInstanceOf(web3_js.Keypair);
            expect(keypair.publicKey).toBeDefined();
            expect(keypair.secretKey).toBeDefined();
        });
        it('should generate random keypair if counter is greater than 255', () => {
            const testFn = () => getTestKeypair(256);
            const kp1 = testFn();
            const kp2 = testFn();
            expect(kp1).not.toEqual(kp2);
        });
        it('should increment the global counter if no counter is provided', () => {
            const initialKeypair = getTestKeypair();
            const nextKeypair = getTestKeypair();
            const nextNextKeypair = getTestKeypair();
            const nextNextNextKeypair = getTestKeypair(3);
            expect(initialKeypair).not.toEqual(nextKeypair);
            expect(nextKeypair).not.toEqual(nextNextKeypair);
            expect(nextNextKeypair).toEqual(nextNextNextKeypair);
        });
    });
}

const sumUpLamports = accounts => {
    return accounts.reduce(
        (acc, account) => acc.add(bn(account.lamports)),
        bn(0),
    );
};
const SOL_POOL_PDA_SEED = require$$0$1.Buffer.from('sol_pool_pda');
class LightSystemProgram {
    /**
     * @internal
     */
    constructor() {}
    static get program() {
        if (!this._program) {
            this.initializeProgram();
        }
        return this._program;
    }
    /**
     * @internal
     * Cwct1kQLwJm8Z3HetLu8m4SXkhD6FZ5fXbJQCxTxPnGY
     *
     */
    static deriveCompressedSolPda() {
        const seeds = [SOL_POOL_PDA_SEED];
        const [address, _] = web3_js.PublicKey.findProgramAddressSync(
            seeds,
            this.programId,
        );
        return address;
    }
    /**
     * Initializes the program statically if not already initialized.
     */
    static initializeProgram() {
        if (!this._program) {
            const mockKeypair = web3_js.Keypair.generate();
            const mockConnection = new web3_js.Connection(
                'http://127.0.0.1:8899',
                'confirmed',
            );
            const mockProvider = new anchor.AnchorProvider(
                mockConnection,
                useWallet(mockKeypair),
                {
                    commitment: 'confirmed',
                    preflightCommitment: 'confirmed',
                },
            );
            anchor.setProvider(mockProvider);
            this._program = new anchor.Program(
                IDL$3,
                this.programId,
                mockProvider,
            );
        }
    }
    static createTransferOutputState(
        inputCompressedAccounts,
        toAddress,
        lamports,
    ) {
        lamports = bn(lamports);
        const inputLamports = sumUpLamports(inputCompressedAccounts);
        const changeLamports = inputLamports.sub(lamports);
        validateSufficientBalance(changeLamports);
        if (changeLamports.eq(bn(0))) {
            return [createCompressedAccount(toAddress, lamports)];
        }
        validateSameOwner(inputCompressedAccounts);
        const outputCompressedAccounts = [
            createCompressedAccount(
                inputCompressedAccounts[0].owner,
                changeLamports,
            ),
            createCompressedAccount(toAddress, lamports),
        ];
        return outputCompressedAccounts;
    }
    static createDecompressOutputState(inputCompressedAccounts, lamports) {
        lamports = bn(lamports);
        const inputLamports = sumUpLamports(inputCompressedAccounts);
        const changeLamports = inputLamports.sub(lamports);
        validateSufficientBalance(changeLamports);
        /// lamports gets decompressed
        if (changeLamports.eq(bn(0))) {
            return [];
        }
        validateSameOwner(inputCompressedAccounts);
        const outputCompressedAccounts = [
            createCompressedAccount(
                inputCompressedAccounts[0].owner,
                changeLamports,
            ),
        ];
        return outputCompressedAccounts;
    }
    /**
     * No data by default
     */
    static createNewAddressOutputState(
        address,
        owner,
        lamports,
        inputCompressedAccounts,
    ) {
        lamports = bn(lamports !== null && lamports !== void 0 ? lamports : 0);
        const inputLamports = sumUpLamports(
            inputCompressedAccounts !== null &&
                inputCompressedAccounts !== void 0
                ? inputCompressedAccounts
                : [],
        );
        const changeLamports = inputLamports.sub(lamports);
        validateSufficientBalance(changeLamports);
        if (changeLamports.eq(bn(0)) || !inputCompressedAccounts) {
            return [
                createCompressedAccount(owner, lamports, undefined, address),
            ];
        }
        validateSameOwner(inputCompressedAccounts);
        const outputCompressedAccounts = [
            createCompressedAccount(
                inputCompressedAccounts[0].owner,
                changeLamports,
            ),
            createCompressedAccount(owner, lamports, undefined, address),
        ];
        return outputCompressedAccounts;
    }
    /**
     * Creates instruction to create compressed account with PDA.
     * Cannot write data.
     *
     * TODO: support transfer of lamports to the new account.
     */
    static async createAccount({
        payer,
        newAddressParams,
        newAddress,
        recentValidityProof,
        outputStateTree,
        inputCompressedAccounts,
        inputStateRootIndices,
        lamports,
    }) {
        const outputCompressedAccounts = this.createNewAddressOutputState(
            newAddress,
            payer,
            lamports,
            inputCompressedAccounts,
        );
        /// Pack accounts
        const {
            packedInputCompressedAccounts,
            packedOutputCompressedAccounts,
            remainingAccounts: _remainingAccounts,
        } = packCompressedAccounts(
            inputCompressedAccounts !== null &&
                inputCompressedAccounts !== void 0
                ? inputCompressedAccounts
                : [],
            inputStateRootIndices !== null && inputStateRootIndices !== void 0
                ? inputStateRootIndices
                : [],
            outputCompressedAccounts,
            outputStateTree,
        );
        const { newAddressParamsPacked, remainingAccounts } =
            packNewAddressParams([newAddressParams], _remainingAccounts);
        const rawData = {
            proof: recentValidityProof,
            inputCompressedAccountsWithMerkleContext:
                packedInputCompressedAccounts,
            outputCompressedAccounts: packedOutputCompressedAccounts,
            relayFee: null,
            newAddressParams: newAddressParamsPacked,
            compressOrDecompressLamports: null,
            isCompress: false,
        };
        /// Encode instruction data
        const ixData = this.program.coder.types.encode(
            'InstructionDataInvoke',
            rawData,
        );
        /// Build anchor instruction
        const instruction = await this.program.methods
            .invoke(ixData)
            .accounts(
                Object.assign(
                    Object.assign({}, defaultStaticAccountsStruct()),
                    {
                        feePayer: payer,
                        authority: payer,
                        solPoolPda: null,
                        decompressionRecipient: null,
                        systemProgram: web3_js.SystemProgram.programId,
                    },
                ),
            )
            .remainingAccounts(toAccountMetas(remainingAccounts))
            .instruction();
        return instruction;
    }
    /**
     * Creates a transaction instruction that transfers compressed lamports from
     * one owner to another.
     */
    static async transfer({
        payer,
        inputCompressedAccounts,
        toAddress,
        lamports,
        recentInputStateRootIndices,
        recentValidityProof,
        outputStateTrees,
    }) {
        /// Create output state
        const outputCompressedAccounts = this.createTransferOutputState(
            inputCompressedAccounts,
            toAddress,
            lamports,
        );
        /// Pack accounts
        const {
            packedInputCompressedAccounts,
            packedOutputCompressedAccounts,
            remainingAccounts,
        } = packCompressedAccounts(
            inputCompressedAccounts,
            recentInputStateRootIndices,
            outputCompressedAccounts,
            outputStateTrees,
        );
        /// Encode instruction data
        const data = this.program.coder.types.encode('InstructionDataInvoke', {
            proof: recentValidityProof,
            inputCompressedAccountsWithMerkleContext:
                packedInputCompressedAccounts,
            outputCompressedAccounts: packedOutputCompressedAccounts,
            relayFee: null,
            /// TODO: here and on-chain: option<newAddressInputs> or similar.
            newAddressParams: [],
            compressOrDecompressLamports: null,
            isCompress: false,
        });
        /// Build anchor instruction
        const instruction = await this.program.methods
            .invoke(data)
            .accounts(
                Object.assign(
                    Object.assign({}, defaultStaticAccountsStruct()),
                    {
                        feePayer: payer,
                        authority: payer,
                        solPoolPda: null,
                        decompressionRecipient: null,
                        systemProgram: web3_js.SystemProgram.programId,
                    },
                ),
            )
            .remainingAccounts(toAccountMetas(remainingAccounts))
            .instruction();
        return instruction;
    }
    /**
     * Creates a transaction instruction that transfers compressed lamports from
     * one owner to another.
     */
    // TODO: add support for non-fee-payer owner
    static async compress({ payer, toAddress, lamports, outputStateTree }) {
        /// Create output state
        lamports = bn(lamports);
        const outputCompressedAccount = createCompressedAccount(
            toAddress,
            lamports,
        );
        /// Pack accounts
        const {
            packedInputCompressedAccounts,
            packedOutputCompressedAccounts,
            remainingAccounts,
        } = packCompressedAccounts(
            [],
            [],
            [outputCompressedAccount],
            outputStateTree,
        );
        /// Encode instruction data
        const rawInputs = {
            proof: null,
            inputCompressedAccountsWithMerkleContext:
                packedInputCompressedAccounts,
            outputCompressedAccounts: packedOutputCompressedAccounts,
            relayFee: null,
            /// TODO: here and on-chain: option<newAddressInputs> or similar.
            newAddressParams: [],
            compressOrDecompressLamports: lamports,
            isCompress: true,
        };
        const data = this.program.coder.types.encode(
            'InstructionDataInvoke',
            rawInputs,
        );
        /// Build anchor instruction
        const instruction = await this.program.methods
            .invoke(data)
            .accounts(
                Object.assign(
                    Object.assign({}, defaultStaticAccountsStruct()),
                    {
                        feePayer: payer,
                        authority: payer,
                        solPoolPda: this.deriveCompressedSolPda(),
                        decompressionRecipient: null,
                        systemProgram: web3_js.SystemProgram.programId,
                    },
                ),
            )
            .remainingAccounts(toAccountMetas(remainingAccounts))
            .instruction();
        return instruction;
    }
    /**
     * Creates a transaction instruction that transfers compressed lamports from
     * one owner to another.
     */
    static async decompress({
        payer,
        inputCompressedAccounts,
        toAddress,
        lamports,
        recentInputStateRootIndices,
        recentValidityProof,
        outputStateTree,
    }) {
        /// Create output state
        lamports = bn(lamports);
        const outputCompressedAccounts = this.createDecompressOutputState(
            inputCompressedAccounts,
            lamports,
        );
        /// Pack accounts
        const {
            packedInputCompressedAccounts,
            packedOutputCompressedAccounts,
            remainingAccounts,
        } = packCompressedAccounts(
            inputCompressedAccounts,
            recentInputStateRootIndices,
            outputCompressedAccounts,
            outputStateTree,
        );
        /// Encode instruction data
        const data = this.program.coder.types.encode('InstructionDataInvoke', {
            proof: recentValidityProof,
            inputCompressedAccountsWithMerkleContext:
                packedInputCompressedAccounts,
            outputCompressedAccounts: packedOutputCompressedAccounts,
            relayFee: null,
            /// TODO: here and on-chain: option<newAddressInputs> or similar.
            newAddressParams: [],
            compressOrDecompressLamports: lamports,
            isCompress: false,
        });
        /// Build anchor instruction
        const instruction = await this.program.methods
            .invoke(data)
            .accounts(
                Object.assign(
                    Object.assign({}, defaultStaticAccountsStruct()),
                    {
                        feePayer: payer,
                        authority: payer,
                        solPoolPda: this.deriveCompressedSolPda(),
                        decompressionRecipient: toAddress,
                        systemProgram: web3_js.SystemProgram.programId,
                    },
                ),
            )
            .remainingAccounts(toAccountMetas(remainingAccounts))
            .instruction();
        return instruction;
    }
}
/**
 * Public key that identifies the CompressedPda program
 */
LightSystemProgram.programId = new web3_js.PublicKey(
    // TODO: can add check to ensure its consistent with the idl
    'SySTEM1eSU2p4BGQfQpimFEWWSC1XDFeun3Nqzz3rT7',
);
LightSystemProgram._program = null;
/**
 * Selects the minimal number of compressed SOL accounts for a transfer.
 *
 * 1. Sorts the accounts by amount in descending order
 * 2. Accumulates the amount until it is greater than or equal to the transfer
 *    amount
 */
function selectMinCompressedSolAccountsForTransfer(accounts, transferLamports) {
    let accumulatedLamports = bn(0);
    transferLamports = bn(transferLamports);
    const selectedAccounts = [];
    accounts.sort((a, b) => b.lamports.cmp(a.lamports));
    for (const account of accounts) {
        if (accumulatedLamports.gte(bn(transferLamports))) break;
        accumulatedLamports = accumulatedLamports.add(account.lamports);
        selectedAccounts.push(account);
    }
    if (accumulatedLamports.lt(bn(transferLamports))) {
        throw new Error(
            `Not enough balance for transfer. Required: ${transferLamports.toString()}, available: ${accumulatedLamports.toString()}`,
        );
    }
    return [selectedAccounts, accumulatedLamports];
}

/**
 * Compress lamports to a solana address
 *
 * @param rpc             RPC to use
 * @param payer           Payer of the transaction and initialization fees
 * @param lamports        Amount of lamports to compress
 * @param toAddress       Address of the recipient compressed account
 * @param outputStateTree Optional output state tree. Defaults to a current shared state tree.
 * @param confirmOptions  Options for confirming the transaction
 *
 * @return Transaction signature
 */
/// TODO: add multisig support
/// TODO: add support for payer != owner
async function compress(
    rpc,
    payer,
    lamports,
    toAddress,
    outputStateTree,
    confirmOptions,
) {
    const { blockhash } = await rpc.getLatestBlockhash();
    const ix = await LightSystemProgram.compress({
        payer: payer.publicKey,
        toAddress,
        lamports,
        outputStateTree,
    });
    const tx = buildAndSignTx(
        [
            web3_js.ComputeBudgetProgram.setComputeUnitLimit({
                units: 1000000,
            }),
            ix,
        ],
        payer,
        blockhash,
        [],
    );
    const txId = await sendAndConfirmTx(rpc, tx, confirmOptions);
    return txId;
}

/**
 * Create compressed account with address
 *
 * @param rpc               RPC to use
 * @param payer             Payer of the transaction and initialization fees
 * @param seed              Seed to derive the new account address
 * @param programId         Owner of the new account
 * @param addressTree       Optional address tree. Defaults to a current shared
 *                          address tree.
 * @param addressQueue      Optional address queue. Defaults to a current shared
 *                          address queue.
 * @param outputStateTree   Optional output state tree. Defaults to a current
 *                          shared state tree.
 * @param confirmOptions    Options for confirming the transaction
 *
 * @return                  Transaction signature
 */
async function createAccount(
    rpc,
    payer,
    seed,
    programId,
    addressTree,
    addressQueue,
    outputStateTree,
    confirmOptions,
) {
    const { blockhash } = await rpc.getLatestBlockhash();
    addressTree =
        addressTree !== null && addressTree !== void 0
            ? addressTree
            : defaultTestStateTreeAccounts().addressTree;
    addressQueue =
        addressQueue !== null && addressQueue !== void 0
            ? addressQueue
            : defaultTestStateTreeAccounts().addressQueue;
    /// TODO: enforce program-derived
    const address = await deriveAddress(seed, addressTree);
    const proof = await rpc.getValidityProofV0(undefined, [
        {
            address: bn(address.toBytes()),
            tree: addressTree,
            queue: addressQueue,
        },
    ]);
    const params = {
        seed: seed,
        addressMerkleTreeRootIndex: proof.rootIndices[0],
        addressMerkleTreePubkey: proof.merkleTrees[0],
        addressQueuePubkey: proof.nullifierQueues[0],
    };
    const ix = await LightSystemProgram.createAccount({
        payer: payer.publicKey,
        newAddressParams: params,
        newAddress: Array.from(address.toBytes()),
        recentValidityProof: proof.compressedProof,
        programId,
        outputStateTree,
    });
    const tx = buildAndSignTx(
        [
            web3_js.ComputeBudgetProgram.setComputeUnitLimit({
                units: 1000000,
            }),
            ix,
        ],
        payer,
        blockhash,
        [],
    );
    const txId = await sendAndConfirmTx(rpc, tx, confirmOptions);
    return txId;
}
/**
 * Create compressed account with address and lamports
 *
 * @param rpc               RPC to use
 * @param payer             Payer of the transaction and initialization fees
 * @param seed              Seed to derive the new account address
 * @param lamports          Number of compressed lamports to initialize the
 *                          account with
 * @param programId         Owner of the new account
 * @param addressTree       Optional address tree. Defaults to a current shared
 *                          address tree.
 * @param addressQueue      Optional address queue. Defaults to a current shared
 *                          address queue.
 * @param outputStateTree   Optional output state tree. Defaults to a current
 *                          shared state tree.
 * @param confirmOptions    Options for confirming the transaction
 *
 * @return                  Transaction signature
 */
// TODO: add support for payer != user owner
async function createAccountWithLamports(
    rpc,
    payer,
    seed,
    lamports,
    programId,
    addressTree,
    addressQueue,
    outputStateTree,
    confirmOptions,
) {
    lamports = bn(lamports);
    const compressedAccounts = await rpc.getCompressedAccountsByOwner(
        payer.publicKey,
    );
    const [inputAccounts] = selectMinCompressedSolAccountsForTransfer(
        compressedAccounts.items,
        lamports,
    );
    const { blockhash } = await rpc.getLatestBlockhash();
    addressTree =
        addressTree !== null && addressTree !== void 0
            ? addressTree
            : defaultTestStateTreeAccounts().addressTree;
    addressQueue =
        addressQueue !== null && addressQueue !== void 0
            ? addressQueue
            : defaultTestStateTreeAccounts().addressQueue;
    /// TODO: enforce program-derived
    const address = await deriveAddress(seed, addressTree);
    const proof = await rpc.getValidityProof(
        inputAccounts.map(account => bn(account.hash)),
        [bn(address.toBytes())],
    );
    /// TODO(crank): Adapt before supporting addresses in rpc / cranked address trees.
    /// Currently expects address roots to be consistent with one another and
    /// static. See test-rpc.ts for more details.
    const params = {
        seed: seed,
        addressMerkleTreeRootIndex:
            proof.rootIndices[proof.rootIndices.length - 1],
        addressMerkleTreePubkey:
            proof.merkleTrees[proof.merkleTrees.length - 1],
        addressQueuePubkey:
            proof.nullifierQueues[proof.nullifierQueues.length - 1],
    };
    const ix = await LightSystemProgram.createAccount({
        payer: payer.publicKey,
        newAddressParams: params,
        newAddress: Array.from(address.toBytes()),
        recentValidityProof: proof.compressedProof,
        inputCompressedAccounts: inputAccounts,
        inputStateRootIndices: proof.rootIndices,
        programId,
        outputStateTree,
    });
    const tx = buildAndSignTx(
        [
            web3_js.ComputeBudgetProgram.setComputeUnitLimit({
                units: 1000000,
            }),
            ix,
        ],
        payer,
        blockhash,
        [],
    );
    const txId = await sendAndConfirmTx(rpc, tx, confirmOptions);
    return txId;
}

/**
 * Decompress lamports into a solana account
 *
 * @param rpc             RPC to use
 * @param payer           Payer of the transaction and initialization fees
 * @param lamports        Amount of lamports to compress
 * @param toAddress       Address of the recipient compressed account
 * @param outputStateTree Optional output state tree. Defaults to a current shared state tree.
 * @param confirmOptions  Options for confirming the transaction
 *
 * @return Transaction signature
 */
/// TODO: add multisig support
/// TODO: add support for payer != owner
async function decompress(
    rpc,
    payer,
    lamports,
    recipient,
    outputStateTree,
    confirmOptions,
) {
    /// TODO: use dynamic state tree and nullifier queue
    const userCompressedAccountsWithMerkleContext = (
        await rpc.getCompressedAccountsByOwner(payer.publicKey)
    ).items;
    lamports = bn(lamports);
    const inputLamports = sumUpLamports(
        userCompressedAccountsWithMerkleContext,
    );
    if (lamports.gt(inputLamports)) {
        throw new Error(
            `Not enough compressed lamports. Expected ${lamports}, got ${inputLamports}`,
        );
    }
    const proof = await rpc.getValidityProof(
        userCompressedAccountsWithMerkleContext.map(x => bn(x.hash)),
    );
    const { blockhash } = await rpc.getLatestBlockhash();
    const ix = await LightSystemProgram.decompress({
        payer: payer.publicKey,
        toAddress: recipient,
        outputStateTree: outputStateTree,
        inputCompressedAccounts: userCompressedAccountsWithMerkleContext,
        recentValidityProof: proof.compressedProof,
        recentInputStateRootIndices: proof.rootIndices,
        lamports,
    });
    const tx = buildAndSignTx(
        [
            web3_js.ComputeBudgetProgram.setComputeUnitLimit({
                units: 1000000,
            }),
            ix,
        ],
        payer,
        blockhash,
        [],
    );
    const txId = await sendAndConfirmTx(rpc, tx, confirmOptions);
    return txId;
}

/** @internal remove signer from signers if part of signers */
function dedupeSigner(signer, signers) {
    if (signers.includes(signer)) {
        return signers.filter(
            s => s.publicKey.toString() !== signer.publicKey.toString(),
        );
    }
    return signers;
}

/**
 * Transfer compressed lamports from one owner to another
 *
 * @param rpc            Rpc to use
 * @param payer          Payer of transaction fees
 * @param lamports       Number of lamports to transfer
 * @param owner          Owner of the compressed lamports
 * @param toAddress      Destination address of the recipient
 * @param merkleTree     State tree account that the compressed lamports should be
 *                       inserted into. Defaults to the default state tree account.
 * @param confirmOptions Options for confirming the transaction
 * @param config         Configuration for fetching compressed accounts
 *
 *
 * @return Signature of the confirmed transaction
 */
async function transfer(
    rpc,
    payer,
    lamports,
    owner,
    toAddress,
    /// TODO: allow multiple
    merkleTree,
    confirmOptions,
) {
    var _a;
    let accumulatedLamports = bn(0);
    const compressedAccounts = [];
    let cursor;
    const batchSize = 1000; // Maximum allowed by the API
    lamports = bn(lamports);
    while (accumulatedLamports.lt(lamports)) {
        const batchConfig = {
            filters: undefined,
            dataSlice: undefined,
            cursor,
            limit: new anchor.BN(batchSize),
        };
        const batch = await rpc.getCompressedAccountsByOwner(
            owner.publicKey,
            batchConfig,
        );
        for (const account of batch.items) {
            if (account.lamports.gt(new anchor.BN(0))) {
                compressedAccounts.push(account);
                accumulatedLamports = accumulatedLamports.add(account.lamports);
            }
        }
        cursor = (_a = batch.cursor) !== null && _a !== void 0 ? _a : undefined;
        if (batch.items.length < batchSize || accumulatedLamports.gte(lamports))
            break;
    }
    if (accumulatedLamports.lt(lamports)) {
        throw new Error(
            `Not enough balance for transfer. Required: ${lamports.toString()}, available: ${accumulatedLamports.toString()}`,
        );
    }
    const [inputAccounts] = selectMinCompressedSolAccountsForTransfer(
        compressedAccounts,
        lamports,
    );
    const proof = await rpc.getValidityProof(
        inputAccounts.map(account => bn(account.hash)),
    );
    const ix = await LightSystemProgram.transfer({
        payer: payer.publicKey,
        inputCompressedAccounts: inputAccounts,
        toAddress,
        lamports,
        recentInputStateRootIndices: proof.rootIndices,
        recentValidityProof: proof.compressedProof,
        outputStateTrees: merkleTree,
    });
    const { blockhash } = await rpc.getLatestBlockhash();
    const signedTx = buildAndSignTx(
        [
            web3_js.ComputeBudgetProgram.setComputeUnitLimit({
                units: 1000000,
            }),
            ix,
        ],
        payer,
        blockhash,
    );
    const txId = await sendAndConfirmTx(rpc, signedTx, confirmOptions);
    return txId;
}

const IDL$2 = {
    version: '1.2.0',
    name: 'account_compression',
    constants: [
        {
            name: 'CPI_AUTHORITY_PDA_SEED',
            type: 'bytes',
            value: '[99, 112, 105, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121]',
        },
        {
            name: 'GROUP_AUTHORITY_SEED',
            type: 'bytes',
            value: '[103, 114, 111, 117, 112, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121]',
        },
        {
            name: 'STATE_MERKLE_TREE_HEIGHT',
            type: 'u64',
            value: '26',
        },
        {
            name: 'STATE_MERKLE_TREE_CHANGELOG',
            type: 'u64',
            value: '1400',
        },
        {
            name: 'STATE_MERKLE_TREE_ROOTS',
            type: 'u64',
            value: '2400',
        },
        {
            name: 'STATE_MERKLE_TREE_CANOPY_DEPTH',
            type: 'u64',
            value: '10',
        },
        {
            name: 'STATE_NULLIFIER_QUEUE_VALUES',
            type: 'u16',
            value: '28_807',
        },
        {
            name: 'STATE_NULLIFIER_QUEUE_SEQUENCE_THRESHOLD',
            type: 'u64',
            value: '2400',
        },
        {
            name: 'ADDRESS_MERKLE_TREE_HEIGHT',
            type: 'u64',
            value: '26',
        },
        {
            name: 'ADDRESS_MERKLE_TREE_CHANGELOG',
            type: 'u64',
            value: '1400',
        },
        {
            name: 'ADDRESS_MERKLE_TREE_ROOTS',
            type: 'u64',
            value: '2400',
        },
        {
            name: 'ADDRESS_MERKLE_TREE_CANOPY_DEPTH',
            type: 'u64',
            value: '10',
        },
        {
            name: 'ADDRESS_MERKLE_TREE_INDEXED_CHANGELOG',
            type: 'u64',
            value: '1400',
        },
        {
            name: 'ADDRESS_QUEUE_VALUES',
            type: 'u16',
            value: '28_807',
        },
        {
            name: 'ADDRESS_QUEUE_SEQUENCE_THRESHOLD',
            type: 'u64',
            value: '2400',
        },
        {
            name: 'NOOP_PUBKEY',
            type: {
                array: ['u8', 32],
            },
            value: '[11 , 188 , 15 , 192 , 187 , 71 , 202 , 47 , 116 , 196 , 17 , 46 , 148 , 171 , 19 , 207 , 163 , 198 , 52 , 229 , 220 , 23 , 234 , 203 , 3 , 205 , 26 , 35 , 205 , 126 , 120 , 124 ,]',
        },
    ],
    instructions: [
        {
            name: 'initializeAddressMerkleTreeAndQueue',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'merkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'queue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
            ],
            args: [
                {
                    name: 'index',
                    type: 'u64',
                },
                {
                    name: 'programOwner',
                    type: {
                        option: 'publicKey',
                    },
                },
                {
                    name: 'forester',
                    type: {
                        option: 'publicKey',
                    },
                },
                {
                    name: 'addressMerkleTreeConfig',
                    type: {
                        defined: 'AddressMerkleTreeConfig',
                    },
                },
                {
                    name: 'addressQueueConfig',
                    type: {
                        defined: 'AddressQueueConfig',
                    },
                },
            ],
        },
        {
            name: 'insertAddresses',
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['Fee payer pays rollover fee.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'addresses',
                    type: {
                        vec: {
                            array: ['u8', 32],
                        },
                    },
                },
            ],
        },
        {
            name: 'updateAddressMerkleTree',
            docs: ['Updates the address Merkle tree with a new address.'],
            accounts: [
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'queue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'merkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'logWrapper',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'changelogIndex',
                    type: 'u16',
                },
                {
                    name: 'indexedChangelogIndex',
                    type: 'u16',
                },
                {
                    name: 'value',
                    type: 'u16',
                },
                {
                    name: 'lowAddressIndex',
                    type: 'u64',
                },
                {
                    name: 'lowAddressValue',
                    type: {
                        array: ['u8', 32],
                    },
                },
                {
                    name: 'lowAddressNextIndex',
                    type: 'u64',
                },
                {
                    name: 'lowAddressNextValue',
                    type: {
                        array: ['u8', 32],
                    },
                },
                {
                    name: 'lowAddressProof',
                    type: {
                        array: [
                            {
                                array: ['u8', 32],
                            },
                            16,
                        ],
                    },
                },
            ],
        },
        {
            name: 'rolloverAddressMerkleTreeAndQueue',
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: [
                        'Signer used to receive rollover accounts rentexemption reimbursement.',
                    ],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'newAddressMerkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'newQueue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'oldAddressMerkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'oldQueue',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: 'initializeGroupAuthority',
            docs: [
                'initialize group (a group can be used to give multiple programs access',
                'to the same Merkle trees by registering the programs to the group)',
            ],
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'seed',
                    isMut: false,
                    isSigner: true,
                    docs: [
                        'Seed public key used to derive the group authority.',
                    ],
                },
                {
                    name: 'groupAuthority',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'authority',
                    type: 'publicKey',
                },
            ],
        },
        {
            name: 'updateGroupAuthority',
            accounts: [
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'groupAuthority',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'authority',
                    type: 'publicKey',
                },
            ],
        },
        {
            name: 'registerProgramToGroup',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'programToBeRegistered',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'groupAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: 'deregisterProgram',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'groupAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'closeRecipient',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: 'initializeStateMerkleTreeAndNullifierQueue',
            docs: [
                'Initializes a new Merkle tree from config bytes.',
                'Index is an optional identifier and not checked by the program.',
            ],
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'merkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'nullifierQueue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
            ],
            args: [
                {
                    name: 'index',
                    type: 'u64',
                },
                {
                    name: 'programOwner',
                    type: {
                        option: 'publicKey',
                    },
                },
                {
                    name: 'forester',
                    type: {
                        option: 'publicKey',
                    },
                },
                {
                    name: 'stateMerkleTreeConfig',
                    type: {
                        defined: 'StateMerkleTreeConfig',
                    },
                },
                {
                    name: 'nullifierQueueConfig',
                    type: {
                        defined: 'NullifierQueueConfig',
                    },
                },
                {
                    name: 'additionalBytes',
                    type: 'u64',
                },
            ],
        },
        {
            name: 'appendLeavesToMerkleTrees',
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['Fee payer pays rollover fee.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                    docs: [
                        'Checked whether instruction is accessed by a registered program or owner = authority.',
                    ],
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                    docs: [
                        'Some assumes that the Merkle trees are accessed by a registered program.',
                        'None assumes that the Merkle trees are accessed by its owner.',
                    ],
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'leaves',
                    type: {
                        vec: {
                            defined: '(u8,[u8;32])',
                        },
                    },
                },
            ],
        },
        {
            name: 'nullifyLeaves',
            accounts: [
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'logWrapper',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'merkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'nullifierQueue',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'changeLogIndices',
                    type: {
                        vec: 'u64',
                    },
                },
                {
                    name: 'leavesQueueIndices',
                    type: {
                        vec: 'u16',
                    },
                },
                {
                    name: 'leafIndices',
                    type: {
                        vec: 'u64',
                    },
                },
                {
                    name: 'proofs',
                    type: {
                        vec: {
                            vec: {
                                array: ['u8', 32],
                            },
                        },
                    },
                },
            ],
        },
        {
            name: 'insertIntoNullifierQueues',
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['Fee payer pays rollover fee.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'nullifiers',
                    type: {
                        vec: {
                            array: ['u8', 32],
                        },
                    },
                },
            ],
        },
        {
            name: 'rolloverStateMerkleTreeAndNullifierQueue',
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: [
                        'Signer used to receive rollover accounts rentexemption reimbursement.',
                    ],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'newStateMerkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'newNullifierQueue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'oldStateMerkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'oldNullifierQueue',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [],
        },
    ],
    accounts: [
        {
            name: 'registeredProgram',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'registeredProgramId',
                        type: 'publicKey',
                    },
                    {
                        name: 'groupAuthorityPda',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'accessMetadata',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'owner',
                        docs: ['Owner of the Merkle tree.'],
                        type: 'publicKey',
                    },
                    {
                        name: 'programOwner',
                        docs: [
                            'Program owner of the Merkle tree. This will be used for program owned Merkle trees.',
                        ],
                        type: 'publicKey',
                    },
                    {
                        name: 'forester',
                        docs: [
                            'Optional privileged forester pubkey, can be set for custom Merkle trees',
                            'without a network fee. Merkle trees without network fees are not',
                            'forested by light foresters. The variable is not used in the account',
                            'compression program but the registry program. The registry program',
                            'implements access control to prevent contention during forester. The',
                            'forester pubkey specified in this struct can bypass contention checks.',
                        ],
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'addressMerkleTreeAccount',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'metadata',
                        type: {
                            defined: 'MerkleTreeMetadata',
                        },
                    },
                ],
            },
        },
        {
            name: 'groupAuthority',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'authority',
                        type: 'publicKey',
                    },
                    {
                        name: 'seed',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'merkleTreeMetadata',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'accessMetadata',
                        type: {
                            defined: 'AccessMetadata',
                        },
                    },
                    {
                        name: 'rolloverMetadata',
                        type: {
                            defined: 'RolloverMetadata',
                        },
                    },
                    {
                        name: 'associatedQueue',
                        type: 'publicKey',
                    },
                    {
                        name: 'nextMerkleTree',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'stateMerkleTreeAccount',
            docs: [
                'Concurrent state Merkle tree used for public compressed transactions.',
            ],
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'metadata',
                        type: {
                            defined: 'MerkleTreeMetadata',
                        },
                    },
                ],
            },
        },
        {
            name: 'queueMetadata',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'accessMetadata',
                        type: {
                            defined: 'AccessMetadata',
                        },
                    },
                    {
                        name: 'rolloverMetadata',
                        type: {
                            defined: 'RolloverMetadata',
                        },
                    },
                    {
                        name: 'associatedMerkleTree',
                        type: 'publicKey',
                    },
                    {
                        name: 'nextQueue',
                        type: 'publicKey',
                    },
                    {
                        name: 'queueType',
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'queueAccount',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'metadata',
                        type: {
                            defined: 'QueueMetadata',
                        },
                    },
                ],
            },
        },
        {
            name: 'rolloverMetadata',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'index',
                        docs: ['Unique index.'],
                        type: 'u64',
                    },
                    {
                        name: 'rolloverFee',
                        docs: [
                            'This fee is used for rent for the next account.',
                            'It accumulates in the account so that once the corresponding Merkle tree account is full it can be rolled over',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'rolloverThreshold',
                        docs: [
                            'The threshold in percentage points when the account should be rolled over (95 corresponds to 95% filled).',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'networkFee',
                        docs: ['Tip for maintaining the account.'],
                        type: 'u64',
                    },
                    {
                        name: 'rolledoverSlot',
                        docs: [
                            'The slot when the account was rolled over, a rolled over account should not be written to.',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'closeThreshold',
                        docs: [
                            'If current slot is greater than rolledover_slot + close_threshold and',
                            "the account is empty it can be closed. No 'close' functionality has been",
                            'implemented yet.',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'additionalBytes',
                        docs: [
                            'Placeholder for bytes of additional accounts which are tied to the',
                            'Merkle trees operation and need to be rolled over as well.',
                        ],
                        type: 'u64',
                    },
                ],
            },
        },
    ],
    types: [
        {
            name: 'AddressMerkleTreeConfig',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'height',
                        type: 'u32',
                    },
                    {
                        name: 'changelogSize',
                        type: 'u64',
                    },
                    {
                        name: 'rootsSize',
                        type: 'u64',
                    },
                    {
                        name: 'canopyDepth',
                        type: 'u64',
                    },
                    {
                        name: 'addressChangelogSize',
                        type: 'u64',
                    },
                    {
                        name: 'networkFee',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'rolloverThreshold',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'closeThreshold',
                        type: {
                            option: 'u64',
                        },
                    },
                ],
            },
        },
        {
            name: 'StateMerkleTreeConfig',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'height',
                        type: 'u32',
                    },
                    {
                        name: 'changelogSize',
                        type: 'u64',
                    },
                    {
                        name: 'rootsSize',
                        type: 'u64',
                    },
                    {
                        name: 'canopyDepth',
                        type: 'u64',
                    },
                    {
                        name: 'networkFee',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'rolloverThreshold',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'closeThreshold',
                        type: {
                            option: 'u64',
                        },
                    },
                ],
            },
        },
        {
            name: 'NullifierQueueConfig',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'capacity',
                        type: 'u16',
                    },
                    {
                        name: 'sequenceThreshold',
                        type: 'u64',
                    },
                    {
                        name: 'networkFee',
                        type: {
                            option: 'u64',
                        },
                    },
                ],
            },
        },
        {
            name: 'QueueType',
            type: {
                kind: 'enum',
                variants: [
                    {
                        name: 'NullifierQueue',
                    },
                    {
                        name: 'AddressQueue',
                    },
                ],
            },
        },
        {
            name: 'AddressQueueConfig',
            type: {
                kind: 'alias',
                value: {
                    defined: 'NullifierQueueConfig',
                },
            },
        },
    ],
    errors: [
        {
            code: 6000,
            name: 'IntegerOverflow',
            msg: 'Integer overflow',
        },
        {
            code: 6001,
            name: 'InvalidAuthority',
            msg: 'InvalidAuthority',
        },
        {
            code: 6002,
            name: 'NumberOfLeavesMismatch',
            msg: 'Leaves <> remaining accounts mismatch. The number of remaining accounts must match the number of leaves.',
        },
        {
            code: 6003,
            name: 'InvalidNoopPubkey',
            msg: 'Provided noop program public key is invalid',
        },
        {
            code: 6004,
            name: 'NumberOfChangeLogIndicesMismatch',
            msg: 'Number of change log indices mismatch',
        },
        {
            code: 6005,
            name: 'NumberOfIndicesMismatch',
            msg: 'Number of indices mismatch',
        },
        {
            code: 6006,
            name: 'NumberOfProofsMismatch',
            msg: 'NumberOfProofsMismatch',
        },
        {
            code: 6007,
            name: 'InvalidMerkleProof',
            msg: 'InvalidMerkleProof',
        },
        {
            code: 6008,
            name: 'LeafNotFound',
            msg: 'Could not find the leaf in the queue',
        },
        {
            code: 6009,
            name: 'MerkleTreeAndQueueNotAssociated',
            msg: 'MerkleTreeAndQueueNotAssociated',
        },
        {
            code: 6010,
            name: 'MerkleTreeAlreadyRolledOver',
            msg: 'MerkleTreeAlreadyRolledOver',
        },
        {
            code: 6011,
            name: 'NotReadyForRollover',
            msg: 'NotReadyForRollover',
        },
        {
            code: 6012,
            name: 'RolloverNotConfigured',
            msg: 'RolloverNotConfigured',
        },
        {
            code: 6013,
            name: 'NotAllLeavesProcessed',
            msg: 'NotAllLeavesProcessed',
        },
        {
            code: 6014,
            name: 'InvalidQueueType',
            msg: 'InvalidQueueType',
        },
        {
            code: 6015,
            name: 'InputElementsEmpty',
            msg: 'InputElementsEmpty',
        },
        {
            code: 6016,
            name: 'NoLeavesForMerkleTree',
            msg: 'NoLeavesForMerkleTree',
        },
        {
            code: 6017,
            name: 'InvalidAccountSize',
            msg: 'InvalidAccountSize',
        },
        {
            code: 6018,
            name: 'InsufficientRolloverFee',
            msg: 'InsufficientRolloverFee',
        },
        {
            code: 6019,
            name: 'UnsupportedHeight',
            msg: 'Unsupported Merkle tree height',
        },
        {
            code: 6020,
            name: 'UnsupportedCanopyDepth',
            msg: 'Unsupported canopy depth',
        },
        {
            code: 6021,
            name: 'InvalidSequenceThreshold',
            msg: 'Invalid sequence threshold',
        },
        {
            code: 6022,
            name: 'UnsupportedCloseThreshold',
            msg: 'Unsupported close threshold',
        },
        {
            code: 6023,
            name: 'InvalidAccountBalance',
            msg: 'InvalidAccountBalance',
        },
        {
            code: 6024,
            name: 'UnsupportedAdditionalBytes',
        },
        {
            code: 6025,
            name: 'InvalidGroup',
        },
        {
            code: 6026,
            name: 'ProofLengthMismatch',
        },
    ],
};

const IDL$1 = {
    version: '1.2.0',
    name: 'light_registry',
    constants: [
        {
            name: 'FORESTER_SEED',
            type: 'bytes',
            value: '[102, 111, 114, 101, 115, 116, 101, 114]',
        },
        {
            name: 'FORESTER_EPOCH_SEED',
            type: 'bytes',
            value: '[102, 111, 114, 101, 115, 116, 101, 114, 95, 101, 112, 111, 99, 104]',
        },
        {
            name: 'PROTOCOL_CONFIG_PDA_SEED',
            type: 'bytes',
            value: '[97, 117, 116, 104, 111, 114, 105, 116, 121]',
        },
    ],
    instructions: [
        {
            name: 'initializeProtocolConfig',
            docs: [
                'Initializes the protocol config pda. Can only be called once by the',
                'program account keypair.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'protocolConfigPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'selfProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
                {
                    name: 'protocolConfig',
                    type: {
                        defined: 'ProtocolConfig',
                    },
                },
            ],
        },
        {
            name: 'updateProtocolConfig',
            accounts: [
                {
                    name: 'feePayer',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'protocolConfigPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'newAuthority',
                    isMut: false,
                    isSigner: true,
                    isOptional: true,
                },
            ],
            args: [
                {
                    name: 'protocolConfig',
                    type: {
                        option: {
                            defined: 'ProtocolConfig',
                        },
                    },
                },
            ],
        },
        {
            name: 'registerSystemProgram',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'protocolConfigPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'cpiAuthority',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'groupPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'programToBeRegistered',
                    isMut: false,
                    isSigner: true,
                    docs: [
                        '- is signer so that only the program deployer can register a program.',
                    ],
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
            ],
        },
        {
            name: 'deregisterSystemProgram',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'protocolConfigPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'cpiAuthority',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'groupPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
            ],
        },
        {
            name: 'registerForester',
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'protocolConfigPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'foresterPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
                {
                    name: 'authority',
                    type: 'publicKey',
                },
                {
                    name: 'config',
                    type: {
                        defined: 'ForesterConfig',
                    },
                },
                {
                    name: 'weight',
                    type: {
                        option: 'u64',
                    },
                },
            ],
        },
        {
            name: 'updateForesterPda',
            accounts: [
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'foresterPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'newAuthority',
                    isMut: false,
                    isSigner: true,
                    isOptional: true,
                },
            ],
            args: [
                {
                    name: 'config',
                    type: {
                        option: {
                            defined: 'ForesterConfig',
                        },
                    },
                },
            ],
        },
        {
            name: 'updateForesterPdaWeight',
            accounts: [
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'protocolConfigPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'foresterPda',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'newWeight',
                    type: 'u64',
                },
            ],
        },
        {
            name: 'registerForesterEpoch',
            docs: [
                'Registers the forester for the epoch.',
                '1. Only the forester can register herself for the epoch.',
                '2. Protocol config is copied.',
                '3. Epoch account is created if needed.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'foresterPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'foresterEpochPda',
                    isMut: true,
                    isSigner: false,
                    docs: [
                        'Instruction checks that current_epoch is the the current epoch and that',
                        'the epoch is in registration phase.',
                    ],
                },
                {
                    name: 'protocolConfig',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'epochPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'epoch',
                    type: 'u64',
                },
            ],
        },
        {
            name: 'finalizeRegistration',
            docs: [
                'This transaction can be included as additional instruction in the first',
                'work instructions during the active phase.',
                'Registration Period must be over.',
            ],
            accounts: [
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'foresterEpochPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'epochPda',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: 'reportWork',
            accounts: [
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'foresterEpochPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'epochPda',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: 'initializeAddressMerkleTree',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                    docs: [
                        'Anyone can create new trees just the fees cannot be set arbitrarily.',
                    ],
                },
                {
                    name: 'merkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'queue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'cpiAuthority',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'protocolConfigPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'cpiContextAccount',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
                {
                    name: 'programOwner',
                    type: {
                        option: 'publicKey',
                    },
                },
                {
                    name: 'forester',
                    type: {
                        option: 'publicKey',
                    },
                },
                {
                    name: 'merkleTreeConfig',
                    type: {
                        defined: 'AddressMerkleTreeConfig',
                    },
                },
                {
                    name: 'queueConfig',
                    type: {
                        defined: 'AddressQueueConfig',
                    },
                },
            ],
        },
        {
            name: 'initializeStateMerkleTree',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                    docs: [
                        'Anyone can create new trees just the fees cannot be set arbitrarily.',
                    ],
                },
                {
                    name: 'merkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'queue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'cpiAuthority',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'protocolConfigPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'cpiContextAccount',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
                {
                    name: 'programOwner',
                    type: {
                        option: 'publicKey',
                    },
                },
                {
                    name: 'forester',
                    type: {
                        option: 'publicKey',
                    },
                },
                {
                    name: 'merkleTreeConfig',
                    type: {
                        defined: 'StateMerkleTreeConfig',
                    },
                },
                {
                    name: 'queueConfig',
                    type: {
                        defined: 'NullifierQueueConfig',
                    },
                },
            ],
        },
        {
            name: 'nullify',
            accounts: [
                {
                    name: 'registeredForesterPda',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'cpiAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'logWrapper',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'merkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'nullifierQueue',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
                {
                    name: 'changeLogIndices',
                    type: {
                        vec: 'u64',
                    },
                },
                {
                    name: 'leavesQueueIndices',
                    type: {
                        vec: 'u16',
                    },
                },
                {
                    name: 'indices',
                    type: {
                        vec: 'u64',
                    },
                },
                {
                    name: 'proofs',
                    type: {
                        vec: {
                            vec: {
                                array: ['u8', 32],
                            },
                        },
                    },
                },
            ],
        },
        {
            name: 'updateAddressMerkleTree',
            accounts: [
                {
                    name: 'registeredForesterPda',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'cpiAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'queue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'merkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'logWrapper',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
                {
                    name: 'changelogIndex',
                    type: 'u16',
                },
                {
                    name: 'indexedChangelogIndex',
                    type: 'u16',
                },
                {
                    name: 'value',
                    type: 'u16',
                },
                {
                    name: 'lowAddressIndex',
                    type: 'u64',
                },
                {
                    name: 'lowAddressValue',
                    type: {
                        array: ['u8', 32],
                    },
                },
                {
                    name: 'lowAddressNextIndex',
                    type: 'u64',
                },
                {
                    name: 'lowAddressNextValue',
                    type: {
                        array: ['u8', 32],
                    },
                },
                {
                    name: 'lowAddressProof',
                    type: {
                        array: [
                            {
                                array: ['u8', 32],
                            },
                            16,
                        ],
                    },
                },
            ],
        },
        {
            name: 'rolloverAddressMerkleTreeAndQueue',
            accounts: [
                {
                    name: 'registeredForesterPda',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'cpiAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'newMerkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'newQueue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'oldMerkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'oldQueue',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
            ],
        },
        {
            name: 'rolloverStateMerkleTreeAndQueue',
            accounts: [
                {
                    name: 'registeredForesterPda',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'cpiAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'newMerkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'newQueue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'oldMerkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'oldQueue',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'cpiContextAccount',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'protocolConfigPda',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
            ],
        },
    ],
    accounts: [
        {
            name: 'epochPda',
            docs: ['Is used for tallying and rewards calculation'],
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'epoch',
                        type: 'u64',
                    },
                    {
                        name: 'protocolConfig',
                        type: {
                            defined: 'ProtocolConfig',
                        },
                    },
                    {
                        name: 'totalWork',
                        type: 'u64',
                    },
                    {
                        name: 'registeredWeight',
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'foresterEpochPda',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'authority',
                        type: 'publicKey',
                    },
                    {
                        name: 'config',
                        type: {
                            defined: 'ForesterConfig',
                        },
                    },
                    {
                        name: 'epoch',
                        type: 'u64',
                    },
                    {
                        name: 'weight',
                        type: 'u64',
                    },
                    {
                        name: 'workCounter',
                        type: 'u64',
                    },
                    {
                        name: 'hasReportedWork',
                        docs: [
                            'Work can be reported in an extra round to earn extra performance based',
                            'rewards.',
                        ],
                        type: 'bool',
                    },
                    {
                        name: 'foresterIndex',
                        docs: [
                            'Start index of the range that determines when the forester is eligible to perform work.',
                            'End index is forester_start_index + weight',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'epochActivePhaseStartSlot',
                        type: 'u64',
                    },
                    {
                        name: 'totalEpochWeight',
                        docs: [
                            'Total epoch weight is registered weight of the epoch account after',
                            'registration is concluded and active epoch period starts.',
                        ],
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'protocolConfig',
                        type: {
                            defined: 'ProtocolConfig',
                        },
                    },
                    {
                        name: 'finalizeCounter',
                        docs: [
                            'Incremented every time finalize registration is called.',
                        ],
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'protocolConfigPda',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'authority',
                        type: 'publicKey',
                    },
                    {
                        name: 'bump',
                        type: 'u8',
                    },
                    {
                        name: 'config',
                        type: {
                            defined: 'ProtocolConfig',
                        },
                    },
                ],
            },
        },
        {
            name: 'foresterPda',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'authority',
                        type: 'publicKey',
                    },
                    {
                        name: 'config',
                        type: {
                            defined: 'ForesterConfig',
                        },
                    },
                    {
                        name: 'activeWeight',
                        type: 'u64',
                    },
                    {
                        name: 'pendingWeight',
                        docs: [
                            'Pending weight which will get active once the next epoch starts.',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'currentEpoch',
                        type: 'u64',
                    },
                    {
                        name: 'lastCompressedForesterEpochPdaHash',
                        docs: [
                            'Link to previous compressed forester epoch account hash.',
                        ],
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'lastRegisteredEpoch',
                        type: 'u64',
                    },
                ],
            },
        },
    ],
    types: [
        {
            name: 'ProtocolConfig',
            docs: [
                'Epoch Phases:',
                '1. Registration',
                '2. Active',
                '3. Report Work',
                '4. Post (Epoch has ended, and rewards can be claimed.)',
                '- There is always an active phase in progress, registration and report work',
                'phases run in parallel to a currently active phase.',
            ],
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'genesisSlot',
                        docs: [
                            'Solana slot when the protocol starts operating.',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'minWeight',
                        docs: [
                            'Minimum weight required for a forester to register to an epoch.',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'slotLength',
                        docs: ['Light protocol slot length.'],
                        type: 'u64',
                    },
                    {
                        name: 'registrationPhaseLength',
                        docs: ['Foresters can register for this phase.'],
                        type: 'u64',
                    },
                    {
                        name: 'activePhaseLength',
                        docs: ['Foresters can perform work in this phase.'],
                        type: 'u64',
                    },
                    {
                        name: 'reportWorkPhaseLength',
                        docs: [
                            'Foresters can report work to receive performance based rewards in this',
                            'phase.',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'networkFee',
                        type: 'u64',
                    },
                    {
                        name: 'cpiContextSize',
                        type: 'u64',
                    },
                    {
                        name: 'finalizeCounterLimit',
                        type: 'u64',
                    },
                    {
                        name: 'placeHolder',
                        docs: ['Placeholder for future protocol updates.'],
                        type: 'publicKey',
                    },
                    {
                        name: 'placeHolderA',
                        type: 'u64',
                    },
                    {
                        name: 'placeHolderB',
                        type: 'u64',
                    },
                    {
                        name: 'placeHolderC',
                        type: 'u64',
                    },
                    {
                        name: 'placeHolderD',
                        type: 'u64',
                    },
                    {
                        name: 'placeHolderE',
                        type: 'u64',
                    },
                    {
                        name: 'placeHolderF',
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'ForesterConfig',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'fee',
                        docs: ['Fee in percentage points.'],
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'EpochState',
            type: {
                kind: 'enum',
                variants: [
                    {
                        name: 'Registration',
                    },
                    {
                        name: 'Active',
                    },
                    {
                        name: 'ReportWork',
                    },
                    {
                        name: 'Post',
                    },
                    {
                        name: 'Pre',
                    },
                ],
            },
        },
    ],
    errors: [
        {
            code: 6000,
            name: 'InvalidForester',
            msg: 'InvalidForester',
        },
        {
            code: 6001,
            name: 'NotInReportWorkPhase',
        },
        {
            code: 6002,
            name: 'StakeAccountAlreadySynced',
        },
        {
            code: 6003,
            name: 'EpochEnded',
        },
        {
            code: 6004,
            name: 'ForesterNotEligible',
        },
        {
            code: 6005,
            name: 'NotInRegistrationPeriod',
        },
        {
            code: 6006,
            name: 'WeightInsuffient',
        },
        {
            code: 6007,
            name: 'ForesterAlreadyRegistered',
        },
        {
            code: 6008,
            name: 'InvalidEpochAccount',
        },
        {
            code: 6009,
            name: 'InvalidEpoch',
        },
        {
            code: 6010,
            name: 'EpochStillInProgress',
        },
        {
            code: 6011,
            name: 'NotInActivePhase',
        },
        {
            code: 6012,
            name: 'ForesterAlreadyReportedWork',
        },
        {
            code: 6013,
            name: 'InvalidNetworkFee',
        },
        {
            code: 6014,
            name: 'FinalizeCounterExceeded',
        },
        {
            code: 6015,
            name: 'CpiContextAccountMissing',
        },
        {
            code: 6016,
            name: 'ArithmeticUnderflow',
        },
        {
            code: 6017,
            name: 'RegistrationNotFinalized',
        },
        {
            code: 6018,
            name: 'CpiContextAccountInvalidDataLen',
        },
        {
            code: 6019,
            name: 'InvalidConfigUpdate',
        },
        {
            code: 6020,
            name: 'InvalidSigner',
        },
        {
            code: 6021,
            name: 'GetLatestRegisterEpochFailed',
        },
        {
            code: 6022,
            name: 'GetCurrentActiveEpochFailed',
        },
        {
            code: 6023,
            name: 'ForesterUndefined',
        },
        {
            code: 6024,
            name: 'ForesterDefined',
        },
    ],
};

const IDL = {
    version: '1.2.0',
    name: 'light_compressed_token',
    instructions: [
        {
            name: 'createTokenPool',
            docs: [
                'This instruction creates a token pool for a given mint. Every spl mint',
                'can have one token pool. When a token is compressed the tokens are',
                'transferrred to the token pool, and their compressed equivalent is',
                'minted into a Merkle tree.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['UNCHECKED: only pays fees.'],
                },
                {
                    name: 'tokenPoolPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'mint',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'cpiAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: 'mintTo',
            docs: [
                'Mints tokens from an spl token mint to a list of compressed accounts.',
                'Minted tokens are transferred to a pool account owned by the compressed',
                'token program. The instruction creates one compressed output account for',
                'every amount and pubkey input pair. A constant amount of lamports can be',
                'transferred to each output account to enable. A use case to add lamports',
                'to a compressed token account is to prevent spam. This is the only way',
                'to add lamports to a compressed token account.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['UNCHECKED: only pays fees.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'cpiAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'mint',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenPoolPda',
                    isMut: true,
                    isSigner: false,
                    docs: [
                        'account to a token account of a different mint will fail',
                    ],
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                    docs: ['programs'],
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'merkleTree',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'selfProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'solPoolPda',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
            ],
            args: [
                {
                    name: 'publicKeys',
                    type: {
                        vec: 'publicKey',
                    },
                },
                {
                    name: 'amounts',
                    type: {
                        vec: 'u64',
                    },
                },
                {
                    name: 'lamports',
                    type: {
                        option: 'u64',
                    },
                },
            ],
        },
        {
            name: 'transfer',
            docs: [
                'Transfers compressed tokens from one account to another. All accounts',
                'must be of the same mint. Additional spl tokens can be compressed or',
                'decompressed. In one transaction only compression or decompression is',
                'possible. Lamports can be transferred alongside tokens. If output token',
                'accounts specify less lamports than inputs the remaining lamports are',
                'transferred to an output compressed account. Signer must be owner or',
                'delegate. If a delegated token account is transferred the delegate is',
                'not preserved.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['UNCHECKED: only pays fees.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                    docs: [
                        'Authority is verified through proof since both owner and delegate',
                        'are included in the token data hash, which is a public input to the',
                        'validity proof.',
                    ],
                },
                {
                    name: 'cpiAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'selfProgram',
                    isMut: false,
                    isSigner: false,
                    docs: ['this program is the signer of the cpi.'],
                },
                {
                    name: 'tokenPoolPda',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'compressOrDecompressTokenAccount',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'inputs',
                    type: 'bytes',
                },
            ],
        },
        {
            name: 'approve',
            docs: [
                'Delegates an amount to a delegate. A compressed token account is either',
                'completely delegated or not. Prior delegates are not preserved. Cannot',
                'be called by a delegate.',
                'The instruction creates two output accounts:',
                '1. one account with delegated amount',
                '2. one account with remaining(change) amount',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['UNCHECKED: only pays fees.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                    docs: [
                        'Authority is verified through proof since both owner and delegate',
                        'are included in the token data hash, which is a public input to the',
                        'validity proof.',
                    ],
                },
                {
                    name: 'cpiAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'selfProgram',
                    isMut: false,
                    isSigner: false,
                    docs: ['this program is the signer of the cpi.'],
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'inputs',
                    type: 'bytes',
                },
            ],
        },
        {
            name: 'revoke',
            docs: [
                'Revokes a delegation. The instruction merges all inputs into one output',
                'account. Cannot be called by a delegate. Delegates are not preserved.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['UNCHECKED: only pays fees.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                    docs: [
                        'Authority is verified through proof since both owner and delegate',
                        'are included in the token data hash, which is a public input to the',
                        'validity proof.',
                    ],
                },
                {
                    name: 'cpiAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'selfProgram',
                    isMut: false,
                    isSigner: false,
                    docs: ['this program is the signer of the cpi.'],
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'inputs',
                    type: 'bytes',
                },
            ],
        },
        {
            name: 'freeze',
            docs: [
                'Freezes compressed token accounts. Inputs must not be frozen. Creates as',
                'many outputs as inputs. Balances and delegates are preserved.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['UNCHECKED: only pays fees.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'cpiAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'selfProgram',
                    isMut: false,
                    isSigner: false,
                    docs: ['that this program is the signer of the cpi.'],
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'mint',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'inputs',
                    type: 'bytes',
                },
            ],
        },
        {
            name: 'thaw',
            docs: [
                'Thaws frozen compressed token accounts. Inputs must be frozen. Creates',
                'as many outputs as inputs. Balances and delegates are preserved.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['UNCHECKED: only pays fees.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'cpiAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'selfProgram',
                    isMut: false,
                    isSigner: false,
                    docs: ['that this program is the signer of the cpi.'],
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'mint',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'inputs',
                    type: 'bytes',
                },
            ],
        },
        {
            name: 'burn',
            docs: [
                'Burns compressed tokens and spl tokens from the pool account. Delegates',
                'can burn tokens. The output compressed token account remains delegated.',
                'Creates one output compressed token account.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['UNCHECKED: only pays fees.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                    docs: [
                        'Authority is verified through proof since both owner and delegate',
                        'are included in the token data hash, which is a public input to the',
                        'validity proof.',
                    ],
                },
                {
                    name: 'cpiAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'mint',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenPoolPda',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'selfProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'inputs',
                    type: 'bytes',
                },
            ],
        },
        {
            name: 'stubIdlBuild',
            docs: [
                'This function is a stub to allow Anchor to include the input types in',
                'the IDL. It should not be included in production builds nor be called in',
                'practice.',
            ],
            accounts: [
                {
                    name: 'feePayer',
                    isMut: true,
                    isSigner: true,
                    docs: ['UNCHECKED: only pays fees.'],
                },
                {
                    name: 'authority',
                    isMut: false,
                    isSigner: true,
                    docs: [
                        'Authority is verified through proof since both owner and delegate',
                        'are included in the token data hash, which is a public input to the',
                        'validity proof.',
                    ],
                },
                {
                    name: 'cpiAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'lightSystemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'registeredProgramPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'noopProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'accountCompressionProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'selfProgram',
                    isMut: false,
                    isSigner: false,
                    docs: ['this program is the signer of the cpi.'],
                },
                {
                    name: 'tokenPoolPda',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'compressOrDecompressTokenAccount',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'inputs1',
                    type: {
                        defined: 'CompressedTokenInstructionDataTransfer',
                    },
                },
                {
                    name: 'inputs2',
                    type: {
                        defined: 'TokenData',
                    },
                },
            ],
        },
    ],
    types: [
        {
            name: 'AccessMetadata',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'owner',
                        docs: ['Owner of the Merkle tree.'],
                        type: 'publicKey',
                    },
                    {
                        name: 'programOwner',
                        docs: [
                            'Program owner of the Merkle tree. This will be used for program owned Merkle trees.',
                        ],
                        type: 'publicKey',
                    },
                    {
                        name: 'forester',
                        docs: [
                            'Optional privileged forester pubkey, can be set for custom Merkle trees',
                            'without a network fee. Merkle trees without network fees are not',
                            'forested by light foresters. The variable is not used in the account',
                            'compression program but the registry program. The registry program',
                            'implements access control to prevent contention during forester. The',
                            'forester pubkey specified in this struct can bypass contention checks.',
                        ],
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'AccountState',
            type: {
                kind: 'enum',
                variants: [
                    {
                        name: 'Initialized',
                    },
                    {
                        name: 'Frozen',
                    },
                ],
            },
        },
        {
            name: 'CompressedAccount',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'owner',
                        type: 'publicKey',
                    },
                    {
                        name: 'lamports',
                        type: 'u64',
                    },
                    {
                        name: 'address',
                        type: {
                            option: {
                                array: ['u8', 32],
                            },
                        },
                    },
                    {
                        name: 'data',
                        type: {
                            option: {
                                defined: 'CompressedAccountData',
                            },
                        },
                    },
                ],
            },
        },
        {
            name: 'CompressedAccountData',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'discriminator',
                        type: {
                            array: ['u8', 8],
                        },
                    },
                    {
                        name: 'data',
                        type: 'bytes',
                    },
                    {
                        name: 'dataHash',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                ],
            },
        },
        {
            name: 'CompressedCpiContext',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'setContext',
                        docs: [
                            'Is set by the program that is invoking the CPI to signal that is should',
                            'set the cpi context.',
                        ],
                        type: 'bool',
                    },
                    {
                        name: 'firstSetContext',
                        docs: [
                            'Is set to wipe the cpi context since someone could have set it before',
                            'with unrelated data.',
                        ],
                        type: 'bool',
                    },
                    {
                        name: 'cpiContextAccountIndex',
                        docs: [
                            'Index of cpi context account in remaining accounts.',
                        ],
                        type: 'u8',
                    },
                ],
            },
        },
        {
            name: 'CompressedProof',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'a',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'b',
                        type: {
                            array: ['u8', 64],
                        },
                    },
                    {
                        name: 'c',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                ],
            },
        },
        {
            name: 'CompressedTokenInstructionDataTransfer',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'proof',
                        type: {
                            option: {
                                defined: 'CompressedProof',
                            },
                        },
                    },
                    {
                        name: 'mint',
                        type: 'publicKey',
                    },
                    {
                        name: 'delegatedTransfer',
                        docs: [
                            'Is required if the signer is delegate,',
                            '-> delegate is authority account,',
                            'owner = Some(owner) is the owner of the token account.',
                        ],
                        type: {
                            option: {
                                defined: 'DelegatedTransfer',
                            },
                        },
                    },
                    {
                        name: 'inputTokenDataWithContext',
                        type: {
                            vec: {
                                defined: 'InputTokenDataWithContext',
                            },
                        },
                    },
                    {
                        name: 'outputCompressedAccounts',
                        type: {
                            vec: {
                                defined: 'PackedTokenTransferOutputData',
                            },
                        },
                    },
                    {
                        name: 'isCompress',
                        type: 'bool',
                    },
                    {
                        name: 'compressOrDecompressAmount',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'cpiContext',
                        type: {
                            option: {
                                defined: 'CompressedCpiContext',
                            },
                        },
                    },
                    {
                        name: 'lamportsChangeAccountMerkleTreeIndex',
                        type: {
                            option: 'u8',
                        },
                    },
                ],
            },
        },
        {
            name: 'DelegatedTransfer',
            docs: [
                'Struct to provide the owner when the delegate is signer of the transaction.',
            ],
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'owner',
                        type: 'publicKey',
                    },
                    {
                        name: 'delegateChangeAccountIndex',
                        docs: [
                            'Index of change compressed account in output compressed accounts. In',
                            "case that the delegate didn't spend the complete delegated compressed",
                            'account balance the change compressed account will be delegated to her',
                            'as well.',
                        ],
                        type: {
                            option: 'u8',
                        },
                    },
                ],
            },
        },
        {
            name: 'InputTokenDataWithContext',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'amount',
                        type: 'u64',
                    },
                    {
                        name: 'delegateIndex',
                        type: {
                            option: 'u8',
                        },
                    },
                    {
                        name: 'merkleContext',
                        type: {
                            defined: 'PackedMerkleContext',
                        },
                    },
                    {
                        name: 'rootIndex',
                        type: 'u16',
                    },
                    {
                        name: 'lamports',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'tlv',
                        docs: [
                            'Placeholder for TokenExtension tlv data (unimplemented)',
                        ],
                        type: {
                            option: 'bytes',
                        },
                    },
                ],
            },
        },
        {
            name: 'InstructionDataInvoke',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'proof',
                        type: {
                            option: {
                                defined: 'CompressedProof',
                            },
                        },
                    },
                    {
                        name: 'inputCompressedAccountsWithMerkleContext',
                        type: {
                            vec: {
                                defined:
                                    'PackedCompressedAccountWithMerkleContext',
                            },
                        },
                    },
                    {
                        name: 'outputCompressedAccounts',
                        type: {
                            vec: {
                                defined:
                                    'OutputCompressedAccountWithPackedContext',
                            },
                        },
                    },
                    {
                        name: 'relayFee',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'newAddressParams',
                        type: {
                            vec: {
                                defined: 'NewAddressParamsPacked',
                            },
                        },
                    },
                    {
                        name: 'compressOrDecompressLamports',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'isCompress',
                        type: 'bool',
                    },
                ],
            },
        },
        {
            name: 'InstructionDataInvokeCpi',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'proof',
                        type: {
                            option: {
                                defined: 'CompressedProof',
                            },
                        },
                    },
                    {
                        name: 'newAddressParams',
                        type: {
                            vec: {
                                defined: 'NewAddressParamsPacked',
                            },
                        },
                    },
                    {
                        name: 'inputCompressedAccountsWithMerkleContext',
                        type: {
                            vec: {
                                defined:
                                    'PackedCompressedAccountWithMerkleContext',
                            },
                        },
                    },
                    {
                        name: 'outputCompressedAccounts',
                        type: {
                            vec: {
                                defined:
                                    'OutputCompressedAccountWithPackedContext',
                            },
                        },
                    },
                    {
                        name: 'relayFee',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'compressOrDecompressLamports',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'isCompress',
                        type: 'bool',
                    },
                    {
                        name: 'cpiContext',
                        type: {
                            option: {
                                defined: 'CompressedCpiContext',
                            },
                        },
                    },
                ],
            },
        },
        {
            name: 'MerkleTreeMetadata',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'accessMetadata',
                        type: {
                            defined: 'AccessMetadata',
                        },
                    },
                    {
                        name: 'rolloverMetadata',
                        type: {
                            defined: 'RolloverMetadata',
                        },
                    },
                    {
                        name: 'associatedQueue',
                        type: 'publicKey',
                    },
                    {
                        name: 'nextMerkleTree',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'MerkleTreeSequenceNumber',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'pubkey',
                        type: 'publicKey',
                    },
                    {
                        name: 'seq',
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'NewAddressParamsPacked',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'seed',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'addressQueueAccountIndex',
                        type: 'u8',
                    },
                    {
                        name: 'addressMerkleTreeAccountIndex',
                        type: 'u8',
                    },
                    {
                        name: 'addressMerkleTreeRootIndex',
                        type: 'u16',
                    },
                ],
            },
        },
        {
            name: 'OutputCompressedAccountWithPackedContext',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'compressedAccount',
                        type: {
                            defined: 'CompressedAccount',
                        },
                    },
                    {
                        name: 'merkleTreeIndex',
                        type: 'u8',
                    },
                ],
            },
        },
        {
            name: 'PackedCompressedAccountWithMerkleContext',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'compressedAccount',
                        type: {
                            defined: 'CompressedAccount',
                        },
                    },
                    {
                        name: 'merkleContext',
                        type: {
                            defined: 'PackedMerkleContext',
                        },
                    },
                    {
                        name: 'rootIndex',
                        docs: [
                            'Index of root used in inclusion validity proof.',
                        ],
                        type: 'u16',
                    },
                    {
                        name: 'readOnly',
                        docs: [
                            'Placeholder to mark accounts read-only unimplemented set to false.',
                        ],
                        type: 'bool',
                    },
                ],
            },
        },
        {
            name: 'PackedMerkleContext',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'merkleTreePubkeyIndex',
                        type: 'u8',
                    },
                    {
                        name: 'nullifierQueuePubkeyIndex',
                        type: 'u8',
                    },
                    {
                        name: 'leafIndex',
                        type: 'u32',
                    },
                    {
                        name: 'queueIndex',
                        docs: [
                            'Index of leaf in queue. Placeholder of batched Merkle tree updates',
                            'currently unimplemented.',
                        ],
                        type: {
                            option: {
                                defined: 'QueueIndex',
                            },
                        },
                    },
                ],
            },
        },
        {
            name: 'PackedTokenTransferOutputData',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'owner',
                        type: 'publicKey',
                    },
                    {
                        name: 'amount',
                        type: 'u64',
                    },
                    {
                        name: 'lamports',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'merkleTreeIndex',
                        type: 'u8',
                    },
                    {
                        name: 'tlv',
                        docs: [
                            'Placeholder for TokenExtension tlv data (unimplemented)',
                        ],
                        type: {
                            option: 'bytes',
                        },
                    },
                ],
            },
        },
        {
            name: 'PublicTransactionEvent',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'inputCompressedAccountHashes',
                        type: {
                            vec: {
                                array: ['u8', 32],
                            },
                        },
                    },
                    {
                        name: 'outputCompressedAccountHashes',
                        type: {
                            vec: {
                                array: ['u8', 32],
                            },
                        },
                    },
                    {
                        name: 'outputCompressedAccounts',
                        type: {
                            vec: {
                                defined:
                                    'OutputCompressedAccountWithPackedContext',
                            },
                        },
                    },
                    {
                        name: 'outputLeafIndices',
                        type: {
                            vec: 'u32',
                        },
                    },
                    {
                        name: 'sequenceNumbers',
                        type: {
                            vec: {
                                defined: 'MerkleTreeSequenceNumber',
                            },
                        },
                    },
                    {
                        name: 'relayFee',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'isCompress',
                        type: 'bool',
                    },
                    {
                        name: 'compressOrDecompressLamports',
                        type: {
                            option: 'u64',
                        },
                    },
                    {
                        name: 'pubkeyArray',
                        type: {
                            vec: 'publicKey',
                        },
                    },
                    {
                        name: 'message',
                        type: {
                            option: 'bytes',
                        },
                    },
                ],
            },
        },
        {
            name: 'QueueIndex',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'queueId',
                        docs: ['Id of queue in queue account.'],
                        type: 'u8',
                    },
                    {
                        name: 'index',
                        docs: ['Index of compressed account hash in queue.'],
                        type: 'u16',
                    },
                ],
            },
        },
        {
            name: 'RolloverMetadata',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'index',
                        docs: ['Unique index.'],
                        type: 'u64',
                    },
                    {
                        name: 'rolloverFee',
                        docs: [
                            'This fee is used for rent for the next account.',
                            'It accumulates in the account so that once the corresponding Merkle tree account is full it can be rolled over',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'rolloverThreshold',
                        docs: [
                            'The threshold in percentage points when the account should be rolled over (95 corresponds to 95% filled).',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'networkFee',
                        docs: ['Tip for maintaining the account.'],
                        type: 'u64',
                    },
                    {
                        name: 'rolledoverSlot',
                        docs: [
                            'The slot when the account was rolled over, a rolled over account should not be written to.',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'closeThreshold',
                        docs: [
                            'If current slot is greater than rolledover_slot + close_threshold and',
                            "the account is empty it can be closed. No 'close' functionality has been",
                            'implemented yet.',
                        ],
                        type: 'u64',
                    },
                    {
                        name: 'additionalBytes',
                        docs: [
                            'Placeholder for bytes of additional accounts which are tied to the',
                            'Merkle trees operation and need to be rolled over as well.',
                        ],
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'TokenData',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'mint',
                        docs: ['The mint associated with this account'],
                        type: 'publicKey',
                    },
                    {
                        name: 'owner',
                        docs: ['The owner of this account.'],
                        type: 'publicKey',
                    },
                    {
                        name: 'amount',
                        docs: ['The amount of tokens this account holds.'],
                        type: 'u64',
                    },
                    {
                        name: 'delegate',
                        docs: [
                            'If `delegate` is `Some` then `delegated_amount` represents',
                            'the amount authorized by the delegate',
                        ],
                        type: {
                            option: 'publicKey',
                        },
                    },
                    {
                        name: 'state',
                        docs: ["The account's state"],
                        type: {
                            defined: 'AccountState',
                        },
                    },
                    {
                        name: 'tlv',
                        docs: [
                            'Placeholder for TokenExtension tlv data (unimplemented)',
                        ],
                        type: {
                            option: 'bytes',
                        },
                    },
                ],
            },
        },
    ],
    errors: [
        {
            code: 6000,
            name: 'SignerCheckFailed',
            msg: 'Signer check failed',
        },
        {
            code: 6001,
            name: 'CreateTransferInstructionFailed',
            msg: 'Create transfer instruction failed',
        },
        {
            code: 6002,
            name: 'AccountNotFound',
            msg: 'Account not found',
        },
        {
            code: 6003,
            name: 'SerializationError',
            msg: 'Serialization error',
        },
    ],
};

// TODO: Clean up
exports.UtxoErrorCode = void 0;
(function (UtxoErrorCode) {
    UtxoErrorCode['NEGATIVE_LAMPORTS'] = 'NEGATIVE_LAMPORTS';
    UtxoErrorCode['NOT_U64'] = 'NOT_U64';
    UtxoErrorCode['BLINDING_EXCEEDS_FIELD_SIZE'] =
        'BLINDING_EXCEEDS_FIELD_SIZE';
})(exports.UtxoErrorCode || (exports.UtxoErrorCode = {}));
exports.SelectInUtxosErrorCode = void 0;
(function (SelectInUtxosErrorCode) {
    SelectInUtxosErrorCode['FAILED_TO_FIND_UTXO_COMBINATION'] =
        'FAILED_TO_FIND_UTXO_COMBINATION';
    SelectInUtxosErrorCode['INVALID_NUMBER_OF_IN_UTXOS'] =
        'INVALID_NUMBER_OF_IN_UTXOS';
})(exports.SelectInUtxosErrorCode || (exports.SelectInUtxosErrorCode = {}));
exports.CreateUtxoErrorCode = void 0;
(function (CreateUtxoErrorCode) {
    CreateUtxoErrorCode['OWNER_UNDEFINED'] = 'OWNER_UNDEFINED';
    CreateUtxoErrorCode['INVALID_OUTPUT_UTXO_LENGTH'] =
        'INVALID_OUTPUT_UTXO_LENGTH';
    CreateUtxoErrorCode['UTXO_DATA_UNDEFINED'] = 'UTXO_DATA_UNDEFINED';
})(exports.CreateUtxoErrorCode || (exports.CreateUtxoErrorCode = {}));
exports.RpcErrorCode = void 0;
(function (RpcErrorCode) {
    RpcErrorCode['CONNECTION_UNDEFINED'] = 'CONNECTION_UNDEFINED';
    RpcErrorCode['RPC_PUBKEY_UNDEFINED'] = 'RPC_PUBKEY_UNDEFINED';
    RpcErrorCode['RPC_METHOD_NOT_IMPLEMENTED'] = 'RPC_METHOD_NOT_IMPLEMENTED';
    RpcErrorCode['RPC_INVALID'] = 'RPC_INVALID';
})(exports.RpcErrorCode || (exports.RpcErrorCode = {}));
exports.LookupTableErrorCode = void 0;
(function (LookupTableErrorCode) {
    LookupTableErrorCode['LOOK_UP_TABLE_UNDEFINED'] = 'LOOK_UP_TABLE_UNDEFINED';
    LookupTableErrorCode['LOOK_UP_TABLE_NOT_INITIALIZED'] =
        'LOOK_UP_TABLE_NOT_INITIALIZED';
})(exports.LookupTableErrorCode || (exports.LookupTableErrorCode = {}));
exports.HashErrorCode = void 0;
(function (HashErrorCode) {
    HashErrorCode['NO_POSEIDON_HASHER_PROVIDED'] =
        'NO_POSEIDON_HASHER_PROVIDED';
})(exports.HashErrorCode || (exports.HashErrorCode = {}));
exports.ProofErrorCode = void 0;
(function (ProofErrorCode) {
    ProofErrorCode['INVALID_PROOF'] = 'INVALID_PROOF';
    ProofErrorCode['PROOF_INPUT_UNDEFINED'] = 'PROOF_INPUT_UNDEFINED';
    ProofErrorCode['PROOF_GENERATION_FAILED'] = 'PROOF_GENERATION_FAILED';
})(exports.ProofErrorCode || (exports.ProofErrorCode = {}));
exports.MerkleTreeErrorCode = void 0;
(function (MerkleTreeErrorCode) {
    MerkleTreeErrorCode['MERKLE_TREE_NOT_INITIALIZED'] =
        'MERKLE_TREE_NOT_INITIALIZED';
    MerkleTreeErrorCode['SOL_MERKLE_TREE_UNDEFINED'] =
        'SOL_MERKLE_TREE_UNDEFINED';
    MerkleTreeErrorCode['MERKLE_TREE_UNDEFINED'] = 'MERKLE_TREE_UNDEFINED';
    MerkleTreeErrorCode['INPUT_UTXO_NOT_INSERTED_IN_MERKLE_TREE'] =
        'INPUT_UTXO_NOT_INSERTED_IN_MERKLE_TREE';
    MerkleTreeErrorCode['MERKLE_TREE_INDEX_UNDEFINED'] =
        'MERKLE_TREE_INDEX_UNDEFINED';
    MerkleTreeErrorCode['MERKLE_TREE_SET_SPACE_UNDEFINED'] =
        'MERKLE_TREE_SET_SPACE_UNDEFINED';
})(exports.MerkleTreeErrorCode || (exports.MerkleTreeErrorCode = {}));
exports.UtilsErrorCode = void 0;
(function (UtilsErrorCode) {
    UtilsErrorCode['ACCOUNT_NAME_UNDEFINED_IN_IDL'] =
        'ACCOUNT_NAME_UNDEFINED_IN_IDL';
    UtilsErrorCode['PROPERTY_UNDEFINED'] = 'PROPERTY_UNDEFINED';
    UtilsErrorCode['LOOK_UP_TABLE_CREATION_FAILED'] =
        'LOOK_UP_TABLE_CREATION_FAILED';
    UtilsErrorCode['UNSUPPORTED_ARCHITECTURE'] = 'UNSUPPORTED_ARCHITECTURE';
    UtilsErrorCode['UNSUPPORTED_PLATFORM'] = 'UNSUPPORTED_PLATFORM';
    UtilsErrorCode['ACCOUNTS_UNDEFINED'] = 'ACCOUNTS_UNDEFINED';
    UtilsErrorCode['INVALID_NUMBER'] = 'INVALID_NUMBER';
})(exports.UtilsErrorCode || (exports.UtilsErrorCode = {}));
class MetaError extends Error {
    constructor(code, functionName, codeMessage) {
        super(`${code}: ${codeMessage}`);
        this.code = code;
        this.functionName = functionName;
        this.codeMessage = codeMessage;
    }
}
class UtxoError extends MetaError {}
class SelectInUtxosError extends MetaError {}
class CreateUtxoError extends MetaError {}
class RpcError extends MetaError {}
class LookupTableError extends MetaError {}
class HashError extends MetaError {}
class ProofError extends MetaError {}
class MerkleTreeError extends MetaError {}
class UtilsError extends MetaError {}

/**
 * A `StructFailure` represents a single specific failure in validation.
 */
/**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */
class StructError extends TypeError {
    constructor(failure, failures) {
        let cached;
        const { message, explanation, ...rest } = failure;
        const { path } = failure;
        const msg =
            path.length === 0
                ? message
                : `At path: ${path.join('.')} -- ${message}`;
        super(explanation ?? msg);
        if (explanation != null) this.cause = msg;
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = () => {
            return cached ?? (cached = [failure, ...failures()]);
        };
    }
}

/**
 * Check if a value is an iterator.
 */
function isIterable(x) {
    return isObject$1(x) && typeof x[Symbol.iterator] === 'function';
}
/**
 * Check if a value is a plain object.
 */
function isObject$1(x) {
    return typeof x === 'object' && x != null;
}
/**
 * Check if a value is a non-array object.
 */
function isNonArrayObject(x) {
    return isObject$1(x) && !Array.isArray(x);
}
/**
 * Return a value as a printable string.
 */
function print(value) {
    if (typeof value === 'symbol') {
        return value.toString();
    }
    return typeof value === 'string' ? JSON.stringify(value) : `${value}`;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */
function shiftIterator(input) {
    const { done, value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */
function toFailure(result, context, struct, value) {
    if (result === true) {
        return;
    } else if (result === false) {
        result = {};
    } else if (typeof result === 'string') {
        result = { message: result };
    }
    const { path, branch } = context;
    const { type } = struct;
    const {
        refinement,
        message = `Expected a value of type \`${type}\`${refinement ? ` with refinement \`${refinement}\`` : ''}, but received: \`${print(value)}\``,
    } = result;
    return {
        value,
        type,
        refinement,
        key: path[path.length - 1],
        path,
        branch,
        ...result,
        message,
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */
function* toFailures(result, context, struct, value) {
    if (!isIterable(result)) {
        result = [result];
    }
    for (const r of result) {
        const failure = toFailure(r, context, struct, value);
        if (failure) {
            yield failure;
        }
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */
function* run(value, struct, options = {}) {
    const {
        path = [],
        branch = [value],
        coerce = false,
        mask = false,
    } = options;
    const ctx = { path, branch, mask };
    if (coerce) {
        value = struct.coercer(value, ctx);
    }
    let status = 'valid';
    for (const failure of struct.validator(value, ctx)) {
        failure.explanation = options.message;
        status = 'not_valid';
        yield [failure, undefined];
    }
    for (let [k, v, s] of struct.entries(value, ctx)) {
        const ts = run(v, s, {
            path: k === undefined ? path : [...path, k],
            branch: k === undefined ? branch : [...branch, v],
            coerce,
            mask,
            message: options.message,
        });
        for (const t of ts) {
            if (t[0]) {
                status = t[0].refinement != null ? 'not_refined' : 'not_valid';
                yield [t[0], undefined];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) {
                    value = v;
                } else if (value instanceof Map) {
                    value.set(k, v);
                } else if (value instanceof Set) {
                    value.add(v);
                } else if (isObject$1(value)) {
                    if (v !== undefined || k in value) value[k] = v;
                }
            }
        }
    }
    if (status !== 'not_valid') {
        for (const failure of struct.refiner(value, ctx)) {
            failure.explanation = options.message;
            status = 'not_refined';
            yield [failure, undefined];
        }
    }
    if (status === 'valid') {
        yield [undefined, value];
    }
}

/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */
class Struct {
    constructor(props) {
        const {
            type,
            schema,
            validator,
            refiner,
            coercer = value => value,
            entries = function* () {},
        } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) {
            this.validator = (value, context) => {
                const result = validator(value, context);
                return toFailures(result, context, this, value);
            };
        } else {
            this.validator = () => [];
        }
        if (refiner) {
            this.refiner = (value, context) => {
                const result = refiner(value, context);
                return toFailures(result, context, this, value);
            };
        } else {
            this.refiner = () => [];
        }
    }
    /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */
    assert(value, message) {
        return assert$1(value, this, message);
    }
    /**
     * Create a value with the struct's coercion logic, then validate it.
     */
    create(value, message) {
        return create(value, this, message);
    }
    /**
     * Check if a value passes the struct's validation.
     */
    is(value) {
        return is(value, this);
    }
    /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema. Masking applies recursively to
     * props of `object` structs only.
     */
    mask(value, message) {
        return mask(value, this, message);
    }
    /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `coerce` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful. Also, `mask` will turn on
     * masking of the unknown `object` props recursively if passed.
     */
    validate(value, options = {}) {
        return validate(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */
function assert$1(value, struct, message) {
    const result = validate(value, struct, { message });
    if (result[0]) {
        throw result[0];
    }
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */
function create(value, struct, message) {
    const result = validate(value, struct, { coerce: true, message });
    if (result[0]) {
        throw result[0];
    } else {
        return result[1];
    }
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */
function mask(value, struct, message) {
    const result = validate(value, struct, {
        coerce: true,
        mask: true,
        message,
    });
    if (result[0]) {
        throw result[0];
    } else {
        return result[1];
    }
}
/**
 * Check if a value passes a struct.
 */
function is(value, struct) {
    const result = validate(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */
function validate(value, struct, options = {}) {
    const tuples = run(value, struct, options);
    const tuple = shiftIterator(tuples);
    if (tuple[0]) {
        const error = new StructError(tuple[0], function* () {
            for (const t of tuples) {
                if (t[0]) {
                    yield t[0];
                }
            }
        });
        return [error, undefined];
    } else {
        const v = tuple[1];
        return [undefined, v];
    }
}
/**
 * Define a new struct type with a custom validation function.
 */
function define(name, validator) {
    return new Struct({ type: name, schema: null, validator });
}

/**
 * Ensure that any value passes validation.
 */
function any() {
    return define('any', () => true);
}
function array(Element) {
    return new Struct({
        type: 'array',
        schema: Element,
        *entries(value) {
            if (Element && Array.isArray(value)) {
                for (const [i, v] of value.entries()) {
                    yield [i, v, Element];
                }
            }
        },
        coercer(value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator(value) {
            return (
                Array.isArray(value) ||
                `Expected an array value, but received: ${print(value)}`
            );
        },
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */
function instance(Class) {
    return define('instance', value => {
        return (
            value instanceof Class ||
            `Expected a \`${Class.name}\` instance, but received: ${print(value)}`
        );
    });
}
function literal(constant) {
    const description = print(constant);
    return new Struct({
        type: 'literal',
        schema: constant,
        validator(value) {
            return (
                value === constant ||
                `Expected the literal \`${description}\`, but received: ${print(value)}`
            );
        },
    });
}
/**
 * Augment an existing struct to allow `null` values.
 */
function nullable(struct) {
    return new Struct({
        ...struct,
        validator: (value, ctx) =>
            value === null || struct.validator(value, ctx),
        refiner: (value, ctx) => value === null || struct.refiner(value, ctx),
    });
}
/**
 * Ensure that a value is a number.
 */
function number() {
    return define('number', value => {
        return (
            (typeof value === 'number' && !isNaN(value)) ||
            `Expected a number, but received: ${print(value)}`
        );
    });
}
/**
 * Ensure that a value is a string.
 */
function string() {
    return define('string', value => {
        return (
            typeof value === 'string' ||
            `Expected a string, but received: ${print(value)}`
        );
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */
function type(schema) {
    const keys = Object.keys(schema);
    return new Struct({
        type: 'type',
        schema,
        *entries(value) {
            if (isObject$1(value)) {
                for (const k of keys) {
                    yield [k, value[k], schema[k]];
                }
            }
        },
        validator(value) {
            return (
                isNonArrayObject(value) ||
                `Expected an object, but received: ${print(value)}`
            );
        },
        coercer(value) {
            return isNonArrayObject(value) ? { ...value } : value;
        },
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */
function union(Structs) {
    const description = Structs.map(s => s.type).join(' | ');
    return new Struct({
        type: 'union',
        schema: null,
        coercer(value, ctx) {
            for (const S of Structs) {
                const [error, coerced] = S.validate(value, {
                    coerce: true,
                    mask: ctx.mask,
                });
                if (!error) {
                    return coerced;
                }
            }
            return value;
        },
        validator(value, ctx) {
            const failures = [];
            for (const S of Structs) {
                const [...tuples] = run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) {
                    return [];
                } else {
                    for (const [failure] of tuples) {
                        if (failure) {
                            failures.push(failure);
                        }
                    }
                }
            }
            return [
                `Expected the value to satisfy a union of \`${description}\`, but received: ${print(value)}`,
                ...failures,
            ];
        },
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */
function unknown() {
    return define('unknown', () => true);
}

/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */
function coerce(struct, condition, coercer) {
    return new Struct({
        ...struct,
        coercer: (value, ctx) => {
            return is(value, condition)
                ? struct.coercer(coercer(value, ctx), ctx)
                : struct.coercer(value, ctx);
        },
    });
}

/**
 * @internal
 */
const PublicKeyFromString = coerce(
    instance(web3_js.PublicKey),
    string(),
    value => new web3_js.PublicKey(value),
);
/**
 * @internal
 */
const ArrayFromString = coerce(instance(Array), string(), value =>
    Array.from(new web3_js.PublicKey(value).toBytes()),
);
/**
 * @internal
 */
const BN254FromString = coerce(instance(anchor.BN), string(), value => {
    return createBN254(value, 'base58');
});
const BNFromInt = coerce(instance(anchor.BN), number(), value => {
    // Check if the number is safe
    if (Number.isSafeInteger(value)) {
        return bn(value);
    } else {
        // Convert to string if the number is unsafe
        return bn(value.toString(), 10);
    }
});
/**
 * @internal
 */
const Base64EncodedCompressedAccountDataResult = coerce(
    string(),
    string(),
    value => (value === '' ? null : value),
);
/**
 * @internal
 */
function createRpcResult(result) {
    return union([
        type({
            jsonrpc: literal('2.0'),
            id: string(),
            result,
        }),
        type({
            jsonrpc: literal('2.0'),
            id: string(),
            error: type({
                code: unknown(),
                message: string(),
                data: nullable(any()),
            }),
        }),
    ]);
}
/**
 * @internal
 */
const UnknownRpcResult = createRpcResult(unknown());
/**
 * @internal
 */
function jsonRpcResult(schema) {
    return coerce(createRpcResult(schema), UnknownRpcResult, value => {
        if ('error' in value) {
            return value;
        } else {
            return Object.assign(Object.assign({}, value), {
                result: create(value.result, schema),
            });
        }
    });
}
/**
 * @internal
 */
function jsonRpcResultAndContext(value) {
    return jsonRpcResult(
        type({
            context: type({
                slot: number(),
            }),
            value,
        }),
    );
}
/**
 * @internal
 */
const CompressedAccountResult = type({
    address: nullable(ArrayFromString),
    hash: BN254FromString,
    data: nullable(
        type({
            data: Base64EncodedCompressedAccountDataResult,
            dataHash: BN254FromString,
            discriminator: BNFromInt,
        }),
    ),
    lamports: BNFromInt,
    owner: PublicKeyFromString,
    leafIndex: number(),
    tree: PublicKeyFromString,
    seq: nullable(BNFromInt),
    slotCreated: BNFromInt,
});
const TokenDataResult = type({
    mint: PublicKeyFromString,
    owner: PublicKeyFromString,
    amount: BNFromInt,
    delegate: nullable(PublicKeyFromString),
    state: string(),
});
/**
 * @internal
 */
const CompressedTokenAccountResult = type({
    tokenData: TokenDataResult,
    account: CompressedAccountResult,
});
/**
 * @internal
 */
const MultipleCompressedAccountsResult = type({
    items: array(CompressedAccountResult),
});
/**
 * @internal
 */
const CompressedAccountsByOwnerResult = type({
    items: array(CompressedAccountResult),
    cursor: nullable(string()),
});
/**
 * @internal
 */
const CompressedTokenAccountsByOwnerOrDelegateResult = type({
    items: array(CompressedTokenAccountResult),
    cursor: nullable(string()),
});
/**
 * @internal
 */
const SlotResult = number();
/**
 * @internal
 */
const HealthResult = string();
/**
 * @internal
 */
const LatestNonVotingSignaturesResult = type({
    items: array(
        type({
            signature: string(),
            slot: number(),
            blockTime: number(),
            error: nullable(string()),
        }),
    ),
});
/**
 * @internal
 */
const LatestNonVotingSignaturesResultPaginated = type({
    items: array(
        type({
            signature: string(),
            slot: number(),
            blockTime: number(),
        }),
    ),
    cursor: nullable(string()),
});
/**
 * @internal
 */
const MerkeProofResult = type({
    hash: BN254FromString,
    leafIndex: number(),
    merkleTree: PublicKeyFromString,
    proof: array(BN254FromString),
    rootSeq: number(),
    root: BN254FromString,
});
/**
 * @internal
 */
const NewAddressProofResult = type({
    address: BN254FromString,
    nextIndex: number(),
    merkleTree: PublicKeyFromString,
    proof: array(BN254FromString), // this is: merkleProofHashedIndexedElementLeaf
    rootSeq: number(),
    root: BN254FromString,
    lowerRangeAddress: BN254FromString, // this is: leafLowerRangeValue.
    higherRangeAddress: BN254FromString, // this is: leafHigherRangeValue
    lowElementLeafIndex: number(), // this is: indexHashedIndexedElementLeaf
});
/**
 * @internal
 */
const CompressedProofResult = type({
    a: array(number()),
    b: array(number()),
    c: array(number()),
});
/**
 * @internal
 */
const ValidityProofResult = type({
    compressedProof: CompressedProofResult,
    leafIndices: array(number()),
    leaves: array(BN254FromString),
    rootIndices: array(number()),
    roots: array(BN254FromString),
    merkleTrees: array(PublicKeyFromString),
    // TODO: enable nullifierQueues
    // nullifierQueues: array(PublicKeyFromString),
});
/**
 * @internal
 */
const MultipleMerkleProofsResult = array(MerkeProofResult);
/**
 * @internal
 */
const BalanceResult = type({
    amount: BNFromInt,
});
const NativeBalanceResult = BNFromInt;
const TokenBalanceResult = type({
    balance: BNFromInt,
    mint: PublicKeyFromString,
});
const TokenBalanceListResult = type({
    tokenBalances: array(TokenBalanceResult),
    cursor: nullable(string()),
});
const AccountProofResult = type({
    hash: array(number()),
    root: array(number()),
    proof: array(array(number())),
});
const toUnixTimestamp = blockTime => {
    return new Date(blockTime).getTime();
};
const SignatureListResult = type({
    items: array(
        type({
            blockTime: number(),
            signature: string(),
            slot: number(),
        }),
    ),
});
const SignatureListWithCursorResult = type({
    items: array(
        type({
            blockTime: number(),
            signature: string(),
            slot: number(),
        }),
    ),
    cursor: nullable(string()),
});
const CompressedTransactionResult = type({
    compressionInfo: type({
        closedAccounts: array(
            type({
                account: CompressedAccountResult,
                optionalTokenData: nullable(TokenDataResult),
            }),
        ),
        openedAccounts: array(
            type({
                account: CompressedAccountResult,
                optionalTokenData: nullable(TokenDataResult),
            }),
        ),
    }),
    /// TODO: add transaction struct
    /// https://github.com/solana-labs/solana/blob/27eff8408b7223bb3c4ab70523f8a8dca3ca6645/transaction-status/src/lib.rs#L1061
    transaction: any(),
});

/** @internal */
function parseAccountData({ discriminator, data, dataHash }) {
    return {
        discriminator: discriminator.toArray('le', 8),
        data: require$$0$1.Buffer.from(data, 'base64'),
        dataHash: dataHash.toArray('le', 32),
    };
}
/** @internal */
async function getCompressedTokenAccountsByOwnerOrDelegate(
    rpc,
    ownerOrDelegate,
    options,
    filterByDelegate = false,
) {
    var _a;
    const endpoint = filterByDelegate
        ? 'getCompressedTokenAccountsByDelegate'
        : 'getCompressedTokenAccountsByOwner';
    const propertyToCheck = filterByDelegate ? 'delegate' : 'owner';
    const unsafeRes = await rpcRequest(rpc.compressionApiEndpoint, endpoint, {
        [propertyToCheck]: ownerOrDelegate.toBase58(),
        mint:
            (_a = options.mint) === null || _a === void 0
                ? void 0
                : _a.toBase58(),
        limit: options.limit,
        cursor: options.cursor,
    });
    const res = create(
        unsafeRes,
        jsonRpcResultAndContext(CompressedTokenAccountsByOwnerOrDelegateResult),
    );
    if ('error' in res) {
        throw new web3_js.SolanaJSONRPCError(
            res.error,
            `failed to get info for compressed accounts by ${propertyToCheck} ${ownerOrDelegate.toBase58()}`,
        );
    }
    if (res.result.value === null) {
        throw new Error('not implemented: NULL result');
    }
    const accounts = [];
    res.result.value.items.map(item => {
        var _a;
        const _account = item.account;
        const _tokenData = item.tokenData;
        const compressedAccount = createCompressedAccountWithMerkleContext(
            createMerkleContext(
                _account.tree,
                mockNullifierQueue,
                _account.hash.toArray('be', 32),
                _account.leafIndex,
            ),
            new web3_js.PublicKey(
                'cTokenmWW8bLPjZEBAUgYy3zKxQZW6VKi7bqNFEVv3m',
            ),
            bn(_account.lamports),
            _account.data ? parseAccountData(_account.data) : undefined,
            _account.address || undefined,
        );
        const parsed = {
            mint: _tokenData.mint,
            owner: _tokenData.owner,
            amount: _tokenData.amount,
            delegate: _tokenData.delegate,
            state: ['uninitialized', 'initialized', 'frozen'].indexOf(
                _tokenData.state,
            ),
            tlv: null,
        };
        if (
            ((_a = parsed[propertyToCheck]) === null || _a === void 0
                ? void 0
                : _a.toBase58()) !== ownerOrDelegate.toBase58()
        ) {
            throw new Error(
                `RPC returned token account with ${propertyToCheck} different from requested ${propertyToCheck}`,
            );
        }
        accounts.push({
            compressedAccount,
            parsed,
        });
    });
    /// TODO: consider custom or different sort. Most recent here.
    return {
        items: accounts.sort(
            (a, b) =>
                b.compressedAccount.leafIndex - a.compressedAccount.leafIndex,
        ),
        cursor: res.result.value.cursor,
    };
}
/** @internal */
function buildCompressedAccountWithMaybeTokenData(
    accountStructWithOptionalTokenData,
) {
    const compressedAccountResult = accountStructWithOptionalTokenData.account;
    const tokenDataResult =
        accountStructWithOptionalTokenData.optionalTokenData;
    const compressedAccount = createCompressedAccountWithMerkleContext(
        createMerkleContext(
            compressedAccountResult.merkleTree,
            mockNullifierQueue,
            compressedAccountResult.hash.toArray('be', 32),
            compressedAccountResult.leafIndex,
        ),
        compressedAccountResult.owner,
        bn(compressedAccountResult.lamports),
        compressedAccountResult.data
            ? parseAccountData(compressedAccountResult.data)
            : undefined,
        compressedAccountResult.address || undefined,
    );
    if (tokenDataResult === null) {
        return { account: compressedAccount, maybeTokenData: null };
    }
    const parsed = {
        mint: tokenDataResult.mint,
        owner: tokenDataResult.owner,
        amount: tokenDataResult.amount,
        delegate: tokenDataResult.delegate,
        state: ['uninitialized', 'initialized', 'frozen'].indexOf(
            tokenDataResult.state,
        ),
        tlv: null,
    };
    return { account: compressedAccount, maybeTokenData: parsed };
}
/**
 * Establish a Compression-compatible JSON RPC connection
 *
 * @param endpointOrWeb3JsConnection    endpoint to the solana cluster or
 *                                      Connection object
 * @param compressionApiEndpoint        Endpoint to the compression server
 * @param proverEndpoint                Endpoint to the prover server. defaults
 *                                      to endpoint
 * @param connectionConfig              Optional connection config
 */
function createRpc(
    endpointOrWeb3JsConnection = 'http://127.0.0.1:8899',
    compressionApiEndpoint = 'http://127.0.0.1:8784',
    proverEndpoint = 'http://127.0.0.1:3001',
    config,
) {
    const endpoint =
        typeof endpointOrWeb3JsConnection === 'string'
            ? endpointOrWeb3JsConnection
            : endpointOrWeb3JsConnection.rpcEndpoint;
    return new Rpc(endpoint, compressionApiEndpoint, proverEndpoint, config);
}
/** @internal */
const rpcRequest = async (
    rpcEndpoint,
    method,
    params = [],
    convertToCamelCase = true,
    debug = false,
) => {
    const body = JSON.stringify({
        jsonrpc: '2.0',
        id: 'test-account',
        method: method,
        params: params,
    });
    if (debug) {
        const generateCurlSnippet = () => {
            const escapedBody = body.replace(/"/g, '\\"');
            return `curl -X POST ${rpcEndpoint} \\
     -H "Content-Type: application/json" \\
     -d "${escapedBody}"`;
        };
        console.log('Debug: Stack trace:');
        console.log(new Error().stack);
        console.log('\nDebug: curl:');
        console.log(generateCurlSnippet());
        console.log('\n');
    }
    const response = await fetch(rpcEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    if (convertToCamelCase) {
        const res = await response.json();
        return toCamelCase(res);
    }
    return await response.json();
};
/** @internal */
const proverRequest = async (
    proverEndpoint,
    method,
    params = [],
    log = false,
) => {
    let logMsg = '';
    if (log) {
        logMsg = `Proof generation for method:${method}`;
        console.time(logMsg);
    }
    let body;
    if (method === 'inclusion') {
        body = JSON.stringify({ 'input-compressed-accounts': params });
    } else if (method === 'new-address') {
        body = JSON.stringify({ 'new-addresses': params });
    } else if (method === 'combined') {
        body = JSON.stringify({
            'input-compressed-accounts': params[0],
            'new-addresses': params[1],
        });
    }
    const response = await fetch(`${proverEndpoint}/prove`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
    });
    if (!response.ok) {
        throw new Error(`Error fetching proof: ${response.statusText}`);
    }
    const data = await response.json();
    const parsed = proofFromJsonStruct(data);
    const compressedProof = negateAndCompressProof(parsed);
    if (log) console.timeEnd(logMsg);
    return compressedProof;
};
function convertMerkleProofsWithContextToHex(merkleProofsWithContext) {
    const inputs = [];
    for (let i = 0; i < merkleProofsWithContext.length; i++) {
        const input = {
            root: toHex(merkleProofsWithContext[i].root),
            pathIndex: merkleProofsWithContext[i].leafIndex,
            pathElements: merkleProofsWithContext[i].merkleProof.map(hex =>
                toHex(hex),
            ),
            leaf: toHex(bn(merkleProofsWithContext[i].hash)),
        };
        inputs.push(input);
    }
    return inputs;
}
function convertNonInclusionMerkleProofInputsToHex(
    nonInclusionMerkleProofInputs,
) {
    const inputs = [];
    for (let i = 0; i < nonInclusionMerkleProofInputs.length; i++) {
        const input = {
            root: toHex(nonInclusionMerkleProofInputs[i].root),
            value: toHex(nonInclusionMerkleProofInputs[i].value),
            pathIndex:
                nonInclusionMerkleProofInputs[
                    i
                ].indexHashedIndexedElementLeaf.toNumber(),
            pathElements: nonInclusionMerkleProofInputs[
                i
            ].merkleProofHashedIndexedElementLeaf.map(hex => toHex(hex)),
            nextIndex: nonInclusionMerkleProofInputs[i].nextIndex.toNumber(),
            leafLowerRangeValue: toHex(
                nonInclusionMerkleProofInputs[i].leafLowerRangeValue,
            ),
            leafHigherRangeValue: toHex(
                nonInclusionMerkleProofInputs[i].leafHigherRangeValue,
            ),
        };
        inputs.push(input);
    }
    return inputs;
}
/// TODO: replace with dynamic nullifierQueue
const mockNullifierQueue = defaultTestStateTreeAccounts().nullifierQueue;
const mockAddressQueue = defaultTestStateTreeAccounts().addressQueue;
/**
 *
 */
class Rpc extends web3_js.Connection {
    /**
     * Establish a Compression-compatible JSON RPC connection
     *
     * @param endpoint                      Endpoint to the solana cluster
     * @param compressionApiEndpoint        Endpoint to the compression server
     * @param proverEndpoint                Endpoint to the prover server.
     * @param connectionConfig              Optional connection config
     */
    constructor(endpoint, compressionApiEndpoint, proverEndpoint, config) {
        super(endpoint, config || 'confirmed');
        this.compressionApiEndpoint = compressionApiEndpoint;
        this.proverEndpoint = proverEndpoint;
    }
    /**
     * Fetch the compressed account for the specified account address or hash
     */
    async getCompressedAccount(address, hash) {
        if (!hash && !address) {
            throw new Error('Either hash or address must be provided');
        }
        if (hash && address) {
            throw new Error('Only one of hash or address must be provided');
        }
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressedAccount',
            {
                hash: hash ? encodeBN254toBase58(hash) : undefined,
                address: address ? encodeBN254toBase58(address) : undefined,
            },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(nullable(CompressedAccountResult)),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get info for compressed account ${hash ? hash.toString() : address ? address.toString() : ''}`,
            );
        }
        if (res.result.value === null) {
            return null;
        }
        const item = res.result.value;
        const account = createCompressedAccountWithMerkleContext(
            createMerkleContext(
                item.tree,
                mockNullifierQueue,
                item.hash.toArray('be', 32),
                item.leafIndex,
            ),
            item.owner,
            bn(item.lamports),
            item.data ? parseAccountData(item.data) : undefined,
            item.address || undefined,
        );
        return account;
    }
    /**
     * Fetch the compressed balance for the specified account address or hash
     */
    async getCompressedBalance(address, hash) {
        if (!hash && !address) {
            throw new Error('Either hash or address must be provided');
        }
        if (hash && address) {
            throw new Error('Only one of hash or address must be provided');
        }
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressedBalance',
            {
                hash: hash ? encodeBN254toBase58(hash) : undefined,
                address: address ? encodeBN254toBase58(address) : undefined,
            },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(NativeBalanceResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get balance for compressed account ${hash ? hash.toString() : address ? address.toString() : ''}`,
            );
        }
        if (res.result.value === null) {
            return bn(0);
        }
        return bn(res.result.value);
    }
    /// TODO: validate that this is just for sol accounts
    /**
     * Fetch the total compressed balance for the specified owner public key
     */
    async getCompressedBalanceByOwner(owner) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressedBalanceByOwner',
            { owner: owner.toBase58() },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(NativeBalanceResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get balance for compressed account ${owner.toBase58()}`,
            );
        }
        if (res.result.value === null) {
            return bn(0);
        }
        return bn(res.result.value);
    }
    /**
     * Fetch the latest merkle proof for the specified account hash from the
     * cluster
     */
    async getCompressedAccountProof(hash) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressedAccountProof',
            { hash: encodeBN254toBase58(hash) },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(MerkeProofResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get proof for compressed account ${hash.toString()}`,
            );
        }
        if (res.result.value === null) {
            throw new Error(
                `failed to get proof for compressed account ${hash.toString()}`,
            );
        }
        const value = {
            hash: res.result.value.hash.toArray('be', 32),
            merkleTree: res.result.value.merkleTree,
            leafIndex: res.result.value.leafIndex,
            merkleProof: res.result.value.proof,
            nullifierQueue: mockNullifierQueue, // TODO(photon): support nullifierQueue in response.
            rootIndex: res.result.value.rootSeq % 2400,
            root: res.result.value.root,
        };
        return value;
    }
    /**
     * Fetch all the account info for multiple compressed accounts specified by
     * an array of account hashes
     */
    async getMultipleCompressedAccounts(hashes) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getMultipleCompressedAccounts',
            { hashes: hashes.map(hash => encodeBN254toBase58(hash)) },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(MultipleCompressedAccountsResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get info for compressed accounts ${hashes.map(hash => encodeBN254toBase58(hash)).join(', ')}`,
            );
        }
        if (res.result.value === null) {
            throw new Error(
                `failed to get info for compressed accounts ${hashes.map(hash => encodeBN254toBase58(hash)).join(', ')}`,
            );
        }
        const accounts = [];
        res.result.value.items.map(item => {
            const account = createCompressedAccountWithMerkleContext(
                createMerkleContext(
                    item.tree,
                    mockNullifierQueue,
                    item.hash.toArray('be', 32),
                    item.leafIndex,
                ),
                item.owner,
                bn(item.lamports),
                item.data ? parseAccountData(item.data) : undefined,
                item.address || undefined,
            );
            accounts.push(account);
        });
        return accounts.sort((a, b) => b.leafIndex - a.leafIndex);
    }
    /**
     * Fetch the latest merkle proofs for multiple compressed accounts specified
     * by an array account hashes
     */
    async getMultipleCompressedAccountProofs(hashes) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getMultipleCompressedAccountProofs',
            hashes.map(hash => encodeBN254toBase58(hash)),
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(array(MerkeProofResult)),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get proofs for compressed accounts ${hashes.map(hash => encodeBN254toBase58(hash)).join(', ')}`,
            );
        }
        if (res.result.value === null) {
            throw new Error(
                `failed to get proofs for compressed accounts ${hashes.map(hash => encodeBN254toBase58(hash)).join(', ')}`,
            );
        }
        const merkleProofs = [];
        for (const proof of res.result.value) {
            const value = {
                hash: proof.hash.toArray('be', 32),
                merkleTree: proof.merkleTree,
                leafIndex: proof.leafIndex,
                merkleProof: proof.proof,
                nullifierQueue: mockAddressQueue, // TODO(photon): support nullifierQueue in response.
                rootIndex: proof.rootSeq % 2400,
                root: proof.root,
            };
            merkleProofs.push(value);
        }
        return merkleProofs;
    }
    /**
     * Fetch all the compressed accounts owned by the specified public key.
     * Owner can be a program or user account
     */
    async getCompressedAccountsByOwner(owner, config) {
        var _a;
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressedAccountsByOwner',
            {
                owner: owner.toBase58(),
                filters:
                    (config === null || config === void 0
                        ? void 0
                        : config.filters) || [],
                dataSlice:
                    config === null || config === void 0
                        ? void 0
                        : config.dataSlice,
                cursor:
                    config === null || config === void 0
                        ? void 0
                        : config.cursor,
                limit:
                    (_a =
                        config === null || config === void 0
                            ? void 0
                            : config.limit) === null || _a === void 0
                        ? void 0
                        : _a.toNumber(),
            },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(CompressedAccountsByOwnerResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get info for compressed accounts owned by ${owner.toBase58()}`,
            );
        }
        if (res.result.value === null) {
            return {
                items: [],
                cursor: null,
            };
        }
        const accounts = [];
        res.result.value.items.map(item => {
            const account = createCompressedAccountWithMerkleContext(
                createMerkleContext(
                    item.tree,
                    mockNullifierQueue,
                    item.hash.toArray('be', 32),
                    item.leafIndex,
                ),
                item.owner,
                bn(item.lamports),
                item.data ? parseAccountData(item.data) : undefined,
                item.address || undefined,
            );
            accounts.push(account);
        });
        return {
            items: accounts.sort((a, b) => b.leafIndex - a.leafIndex),
            cursor: res.result.value.cursor,
        };
    }
    /**
     * Fetch all the compressed token accounts owned by the specified public
     * key. Owner can be a program or user account
     */
    async getCompressedTokenAccountsByOwner(owner, options) {
        if (!options) options = {};
        return await getCompressedTokenAccountsByOwnerOrDelegate(
            this,
            owner,
            options,
            false,
        );
    }
    /**
     * Fetch all the compressed accounts delegated to the specified public key.
     */
    async getCompressedTokenAccountsByDelegate(delegate, options) {
        if (!options) options = {};
        return getCompressedTokenAccountsByOwnerOrDelegate(
            this,
            delegate,
            options,
            true,
        );
    }
    /**
     * Fetch the compressed token balance for the specified account hash
     */
    async getCompressedTokenAccountBalance(hash) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressedTokenAccountBalance',
            { hash: encodeBN254toBase58(hash) },
        );
        const res = create(unsafeRes, jsonRpcResultAndContext(BalanceResult));
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get balance for compressed token account ${hash.toString()}`,
            );
        }
        if (res.result.value === null) {
            throw new Error(
                `failed to get balance for compressed token account ${hash.toString()}`,
            );
        }
        return { amount: bn(res.result.value.amount) };
    }
    /**
     * Fetch all the compressed token balances owned by the specified public
     * key. Can filter by mint
     */
    async getCompressedTokenBalancesByOwner(owner, options) {
        var _a;
        if (!options) options = {};
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressedTokenBalancesByOwner',
            {
                owner: owner.toBase58(),
                mint:
                    (_a = options.mint) === null || _a === void 0
                        ? void 0
                        : _a.toBase58(),
                limit: options.limit,
                cursor: options.cursor,
            },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(TokenBalanceListResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get compressed token balances for owner ${owner.toBase58()}`,
            );
        }
        if (res.result.value === null) {
            throw new Error(
                `failed to get compressed token balances for owner ${owner.toBase58()}`,
            );
        }
        const maybeFiltered = options.mint
            ? res.result.value.tokenBalances.filter(
                  tokenBalance =>
                      tokenBalance.mint.toBase58() === options.mint.toBase58(),
              )
            : res.result.value.tokenBalances;
        return {
            items: maybeFiltered,
            cursor: res.result.value.cursor,
        };
    }
    /**
     * Returns confirmed compression signatures for transactions involving the specified
     * account hash forward in time from genesis to the most recent confirmed
     * block
     *
     * @param hash queried account hash
     */
    async getCompressionSignaturesForAccount(hash) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressionSignaturesForAccount',
            { hash: encodeBN254toBase58(hash) },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(SignatureListResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get signatures for compressed account ${hash.toString()}`,
            );
        }
        return res.result.value.items;
    }
    /**
     * Fetch a confirmed or finalized transaction from the cluster. Return with
     * CompressionInfo
     */
    async getTransactionWithCompressionInfo(signature) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getTransactionWithCompressionInfo',
            { signature },
        );
        const res = create(
            unsafeRes,
            jsonRpcResult(CompressedTransactionResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                'failed to get slot',
            );
        }
        if (res.result.transaction === null) return null;
        const closedAccounts = [];
        const openedAccounts = [];
        res.result.compressionInfo.closedAccounts.map(item => {
            closedAccounts.push(buildCompressedAccountWithMaybeTokenData(item));
        });
        res.result.compressionInfo.openedAccounts.map(item => {
            openedAccounts.push(buildCompressedAccountWithMaybeTokenData(item));
        });
        const calculateTokenBalances = accounts => {
            const balances = Object.values(
                accounts.reduce((acc, { maybeTokenData }) => {
                    if (maybeTokenData) {
                        const { owner, mint, amount } = maybeTokenData;
                        const key = `${owner.toBase58()}_${mint.toBase58()}`;
                        if (key in acc) {
                            acc[key].amount = acc[key].amount.add(amount);
                        } else {
                            acc[key] = { owner, mint, amount };
                        }
                    }
                    return acc;
                }, {}),
            );
            return balances.length > 0 ? balances : undefined;
        };
        const preTokenBalances = calculateTokenBalances(closedAccounts);
        const postTokenBalances = calculateTokenBalances(openedAccounts);
        return {
            compressionInfo: {
                closedAccounts,
                openedAccounts,
                preTokenBalances,
                postTokenBalances,
            },
            transaction: res.result.transaction,
        };
    }
    /**
     * Returns confirmed signatures for transactions involving the specified
     * address forward in time from genesis to the most recent confirmed block
     *
     * @param address queried compressed account address
     */
    async getCompressionSignaturesForAddress(address) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressionSignaturesForAddress',
            { address: address.toBase58() },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(SignatureListWithCursorResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get signatures for address ${address.toBase58()}`,
            );
        }
        if (res.result.value === null) {
            throw new Error(
                `failed to get signatures for address ${address.toBase58()}`,
            );
        }
        return res.result.value;
    }
    /**
     * Returns confirmed signatures for compression transactions involving the
     * specified account owner forward in time from genesis to the
     * most recent confirmed block
     *
     * @param owner queried owner public key
     */
    async getCompressionSignaturesForOwner(owner) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressionSignaturesForOwner',
            { owner: owner.toBase58() },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(SignatureListWithCursorResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get signatures for owner ${owner.toBase58()}`,
            );
        }
        if (res.result.value === null) {
            throw new Error(
                `failed to get signatures for owner ${owner.toBase58()}`,
            );
        }
        return res.result.value;
    }
    /// TODO(photon): needs mint
    /**
     * Returns confirmed signatures for compression transactions involving the
     * specified token account owner forward in time from genesis to the most
     * recent confirmed block
     */
    async getCompressionSignaturesForTokenOwner(owner) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getCompressionSignaturesForTokenOwner',
            { owner: owner.toBase58() },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(SignatureListWithCursorResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get signatures for owner ${owner.toBase58()}`,
            );
        }
        if (res.result.value === null) {
            throw new Error(
                `failed to get signatures for owner ${owner.toBase58()}`,
            );
        }
        return res.result.value;
    }
    /**
     * Fetch the current indexer health status
     */
    async getIndexerHealth() {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getIndexerHealth',
        );
        const res = create(unsafeRes, jsonRpcResult(HealthResult));
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                'failed to get health',
            );
        }
        return res.result;
    }
    /**
     * Ensure that the Compression Indexer has already indexed the transaction
     */
    async confirmTransactionIndexed(slot) {
        const startTime = Date.now();
        // eslint-disable-next-line no-constant-condition
        while (true) {
            const indexerSlot = await this.getIndexerSlot();
            if (indexerSlot >= slot) {
                return true;
            }
            if (Date.now() - startTime > 20000) {
                // 20 seconds
                throw new Error(
                    'Timeout: Indexer slot did not reach the required slot within 20 seconds',
                );
            }
            await new Promise(resolve => setTimeout(resolve, 200));
        }
    }
    /**
     * Fetch the current slot that the node is processing
     */
    async getIndexerSlot() {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getIndexerSlot',
        );
        const res = create(unsafeRes, jsonRpcResult(SlotResult));
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                'failed to get slot',
            );
        }
        return res.result;
    }
    /**
     * Fetch the latest compression signatures on the cluster. Results are
     * paginated.
     */
    async getLatestCompressionSignatures(cursor, limit) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getLatestCompressionSignatures',
            { limit, cursor },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(LatestNonVotingSignaturesResultPaginated),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                'failed to get latest non-voting signatures',
            );
        }
        return res.result;
    }
    /**
     * Fetch all non-voting signatures
     */
    async getLatestNonVotingSignatures(limit) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getLatestNonVotingSignatures',
            { limit },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(LatestNonVotingSignaturesResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                'failed to get latest non-voting signatures',
            );
        }
        return res.result;
    }
    /**
     * Fetch the latest address proofs for new unique addresses specified by an
     * array of addresses.
     *
     * the proof states that said address have not yet been created in
     * respective address tree.
     * @param addresses Array of BN254 new addresses
     * @returns Array of validity proofs for new addresses
     */
    async getMultipleNewAddressProofs(addresses) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getMultipleNewAddressProofs',
            addresses.map(address => encodeBN254toBase58(address)),
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(array(NewAddressProofResult)),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get proofs for new addresses ${addresses.map(address => encodeBN254toBase58(address)).join(', ')}`,
            );
        }
        if (res.result.value === null) {
            throw new Error(
                `failed to get proofs for new addresses ${addresses.map(address => encodeBN254toBase58(address)).join(', ')}`,
            );
        }
        /// Creates proof for each address
        const newAddressProofs = [];
        for (const proof of res.result.value) {
            const _proof = {
                root: proof.root,
                rootIndex: proof.rootSeq % 2400,
                value: proof.address,
                leafLowerRangeValue: proof.lowerRangeAddress,
                leafHigherRangeValue: proof.higherRangeAddress,
                nextIndex: bn(proof.nextIndex),
                merkleProofHashedIndexedElementLeaf: proof.proof,
                indexHashedIndexedElementLeaf: bn(proof.lowElementLeafIndex),
                merkleTree: proof.merkleTree,
                nullifierQueue: mockAddressQueue,
            };
            newAddressProofs.push(_proof);
        }
        return newAddressProofs;
    }
    /**
     * Advanced usage of getValidityProof: fetches ZKP directly from a custom
     * non-rpcprover. Note: This uses the proverEndpoint specified in the
     * constructor. For normal usage, please use {@link getValidityProof}
     * instead.
     *
     * Fetch the latest validity proof for (1) compressed accounts specified by
     * an array of account hashes. (2) new unique addresses specified by an
     * array of addresses.
     *
     * Validity proofs prove the presence of compressed accounts in state trees
     * and the non-existence of addresses in address trees, respectively. They
     * enable verification without recomputing the merkle proof path, thus
     * lowering verification and data costs.
     *
     * @param hashes        Array of BN254 hashes.
     * @param newAddresses  Array of BN254 new addresses.
     * @returns             validity proof with context
     */
    async getValidityProofDirect(hashes = [], newAddresses = []) {
        let validityProof;
        if (hashes.length === 0 && newAddresses.length === 0) {
            throw new Error(
                'Empty input. Provide hashes and/or new addresses.',
            );
        } else if (hashes.length > 0 && newAddresses.length === 0) {
            /// inclusion
            const merkleProofsWithContext =
                await this.getMultipleCompressedAccountProofs(hashes);
            const inputs = convertMerkleProofsWithContextToHex(
                merkleProofsWithContext,
            );
            const compressedProof = await proverRequest(
                this.proverEndpoint,
                'inclusion',
                inputs,
                false,
            );
            validityProof = {
                compressedProof,
                roots: merkleProofsWithContext.map(proof => proof.root),
                rootIndices: merkleProofsWithContext.map(
                    proof => proof.rootIndex,
                ),
                leafIndices: merkleProofsWithContext.map(
                    proof => proof.leafIndex,
                ),
                leaves: merkleProofsWithContext.map(proof => bn(proof.hash)),
                merkleTrees: merkleProofsWithContext.map(
                    proof => proof.merkleTree,
                ),
                nullifierQueues: merkleProofsWithContext.map(
                    proof => proof.nullifierQueue,
                ),
            };
        } else if (hashes.length === 0 && newAddresses.length > 0) {
            /// new-address
            const newAddressProofs =
                await this.getMultipleNewAddressProofs(newAddresses);
            const inputs =
                convertNonInclusionMerkleProofInputsToHex(newAddressProofs);
            const compressedProof = await proverRequest(
                this.proverEndpoint,
                'new-address',
                inputs,
                false,
            );
            validityProof = {
                compressedProof,
                roots: newAddressProofs.map(proof => proof.root),
                rootIndices: newAddressProofs.map(proof => proof.rootIndex),
                leafIndices: newAddressProofs.map(proof =>
                    proof.nextIndex.toNumber(),
                ),
                leaves: newAddressProofs.map(proof => bn(proof.value)),
                merkleTrees: newAddressProofs.map(proof => proof.merkleTree),
                nullifierQueues: newAddressProofs.map(
                    proof => proof.nullifierQueue,
                ),
            };
        } else if (hashes.length > 0 && newAddresses.length > 0) {
            /// combined
            const merkleProofsWithContext =
                await this.getMultipleCompressedAccountProofs(hashes);
            const inputs = convertMerkleProofsWithContextToHex(
                merkleProofsWithContext,
            );
            const newAddressProofs =
                await this.getMultipleNewAddressProofs(newAddresses);
            const newAddressInputs =
                convertNonInclusionMerkleProofInputsToHex(newAddressProofs);
            const compressedProof = await proverRequest(
                this.proverEndpoint,
                'combined',
                [inputs, newAddressInputs],
                false,
            );
            validityProof = {
                compressedProof,
                roots: merkleProofsWithContext
                    .map(proof => proof.root)
                    .concat(newAddressProofs.map(proof => proof.root)),
                rootIndices: merkleProofsWithContext
                    .map(proof => proof.rootIndex)
                    .concat(newAddressProofs.map(proof => proof.rootIndex)),
                leafIndices: merkleProofsWithContext
                    .map(proof => proof.leafIndex)
                    .concat(
                        newAddressProofs.map(proof =>
                            proof.nextIndex.toNumber(),
                        ),
                    ),
                leaves: merkleProofsWithContext
                    .map(proof => bn(proof.hash))
                    .concat(newAddressProofs.map(proof => bn(proof.value))),
                merkleTrees: merkleProofsWithContext
                    .map(proof => proof.merkleTree)
                    .concat(newAddressProofs.map(proof => proof.merkleTree)),
                nullifierQueues: merkleProofsWithContext
                    .map(proof => proof.nullifierQueue)
                    .concat(
                        newAddressProofs.map(proof => proof.nullifierQueue),
                    ),
            };
        } else throw new Error('Invalid input');
        return validityProof;
    }
    /**
     * Fetch the latest validity proof for (1) compressed accounts specified by
     * an array of account hashes. (2) new unique addresses specified by an
     * array of addresses.
     *
     * Validity proofs prove the presence of compressed accounts in state trees
     * and the non-existence of addresses in address trees, respectively. They
     * enable verification without recomputing the merkle proof path, thus
     * lowering verification and data costs.
     *
     * @param hashes        Array of BN254 hashes.
     * @param newAddresses  Array of BN254 new addresses.
     * @returns             validity proof with context
     */
    async getValidityProof(hashes = [], newAddresses = []) {
        const defaultAddressTreePublicKey =
            defaultTestStateTreeAccounts().addressTree;
        const defaultAddressQueuePublicKey =
            defaultTestStateTreeAccounts().addressQueue;
        const defaultStateTreePublicKey =
            defaultTestStateTreeAccounts().merkleTree;
        const defaultStateQueuePublicKey =
            defaultTestStateTreeAccounts().nullifierQueue;
        const formattedHashes = hashes.map(item => {
            if (item instanceof anchor.BN) {
                return {
                    hash: item,
                    tree: defaultStateTreePublicKey,
                    queue: defaultStateQueuePublicKey,
                };
            }
            return item;
        });
        const formattedNewAddresses = newAddresses.map(item => {
            if (item instanceof anchor.BN) {
                return {
                    address: item,
                    tree: defaultAddressTreePublicKey,
                    queue: defaultAddressQueuePublicKey,
                };
            }
            return item;
        });
        return this.getValidityProofV0(formattedHashes, formattedNewAddresses);
    }
    /**
     * Fetch the latest validity proof for (1) compressed accounts specified by
     * an array of account hashes. (2) new unique addresses specified by an
     * array of addresses.
     *
     * Validity proofs prove the presence of compressed accounts in state trees
     * and the non-existence of addresses in address trees, respectively. They
     * enable verification without recomputing the merkle proof path, thus
     * lowering verification and data costs.
     *
     * @param hashes        Array of { hash: BN254, tree: PublicKey, queue: PublicKey }.
     * @param newAddresses  Array of { address: BN254, tree: PublicKey, queue: PublicKey }.
     * @returns             validity proof with context
     */
    async getValidityProofV0(hashes = [], newAddresses = []) {
        const { value } = await this.getValidityProofAndRpcContext(
            hashes,
            newAddresses,
        );
        return value;
    }
    /**
     * Fetch the latest validity proof for (1) compressed accounts specified by
     * an array of account hashes. (2) new unique addresses specified by an
     * array of addresses. Returns with context slot.
     *
     * Validity proofs prove the presence of compressed accounts in state trees
     * and the non-existence of addresses in address trees, respectively. They
     * enable verification without recomputing the merkle proof path, thus
     * lowering verification and data costs.
     *
     * @param hashes        Array of BN254 hashes.
     * @param newAddresses  Array of BN254 new addresses. Optionally specify the
     *                      tree and queue for each address. Default to public
     *                      state tree/queue.
     * @returns             validity proof with context
     */
    async getValidityProofAndRpcContext(hashes = [], newAddresses = []) {
        const unsafeRes = await rpcRequest(
            this.compressionApiEndpoint,
            'getValidityProof',
            {
                hashes: hashes.map(({ hash }) => encodeBN254toBase58(hash)),
                newAddressesWithTrees: newAddresses.map(
                    ({ address, tree }) => ({
                        address: encodeBN254toBase58(address),
                        tree: tree.toBase58(),
                    }),
                ),
            },
        );
        const res = create(
            unsafeRes,
            jsonRpcResultAndContext(ValidityProofResult),
        );
        if ('error' in res) {
            throw new web3_js.SolanaJSONRPCError(
                res.error,
                `failed to get ValidityProof for compressed accounts ${hashes.map(hash => hash.toString())}`,
            );
        }
        const result = res.result.value;
        if (result === null) {
            throw new Error(
                `failed to get ValidityProof for compressed accounts ${hashes.map(hash => hash.toString())}`,
            );
        }
        const value = {
            compressedProof: result.compressedProof,
            merkleTrees: result.merkleTrees,
            leafIndices: result.leafIndices,
            nullifierQueues: [
                ...hashes.map(({ queue }) => queue),
                ...newAddresses.map(({ queue }) => queue),
            ],
            rootIndices: result.rootIndices,
            roots: result.roots,
            leaves: result.leaves,
        };
        return { value, context: res.result.context };
    }
}

const DEFAULT_ZERO = '0';
/**
 * @callback hashFunction
 * @param left Left leaf
 * @param right Right leaf
 */
/**
 * Merkle tree
 */
class MerkleTree {
    constructor(
        levels,
        lightWasm,
        elements = [],
        { zeroElement = DEFAULT_ZERO } = {},
    ) {
        this.levels = levels;
        this.capacity = 2 ** levels;
        this.zeroElement = zeroElement;
        this._lightWasm = lightWasm;
        if (elements.length > this.capacity) {
            throw new Error('Tree is full');
        }
        this._zeros = [];
        this._layers = [];
        this._layers[0] = elements;
        this._zeros[0] = this.zeroElement;
        for (let i = 1; i <= levels; i++) {
            this._zeros[i] = this._lightWasm.poseidonHashString([
                this._zeros[i - 1],
                this._zeros[i - 1],
            ]);
        }
        this._rebuild();
    }
    _rebuild() {
        for (let level = 1; level <= this.levels; level++) {
            this._layers[level] = [];
            for (
                let i = 0;
                i < Math.ceil(this._layers[level - 1].length / 2);
                i++
            ) {
                this._layers[level][i] = this._lightWasm.poseidonHashString([
                    this._layers[level - 1][i * 2],
                    i * 2 + 1 < this._layers[level - 1].length
                        ? this._layers[level - 1][i * 2 + 1]
                        : this._zeros[level - 1],
                ]);
            }
        }
    }
    /**
     * Get tree root
     * @returns {*}
     */
    root() {
        return this._layers[this.levels].length > 0
            ? this._layers[this.levels][0]
            : this._zeros[this.levels];
    }
    /**
     * Insert new element into the tree
     * @param element Element to insert
     */
    insert(element) {
        if (this._layers[0].length >= this.capacity) {
            throw new Error('Tree is full');
        }
        this.update(this._layers[0].length, element);
    }
    /**
     * Insert multiple elements into the tree. Tree will be fully rebuilt during this operation.
     * @param {Array} elements Elements to insert
     */
    bulkInsert(elements) {
        if (this._layers[0].length + elements.length > this.capacity) {
            throw new Error('Tree is full');
        }
        this._layers[0].push(...elements);
        this._rebuild();
    }
    // TODO: update does not work debug
    /**
     * Change an element in the tree
     * @param {number} index Index of element to change
     * @param element Updated element value
     */
    update(index, element) {
        // index 0 and 1 and element is the commitment hash
        if (
            isNaN(Number(index)) ||
            index < 0 ||
            index > this._layers[0].length ||
            index >= this.capacity
        ) {
            throw new Error('Insert index out of bounds: ' + index);
        }
        this._layers[0][index] = element;
        for (let level = 1; level <= this.levels; level++) {
            index >>= 1;
            this._layers[level][index] = this._lightWasm.poseidonHashString([
                this._layers[level - 1][index * 2],
                index * 2 + 1 < this._layers[level - 1].length
                    ? this._layers[level - 1][index * 2 + 1]
                    : this._zeros[level - 1],
            ]);
        }
    }
    /**
     * Get merkle path to a leaf
     * @param {number} index Leaf index to generate path for
     * @returns {{pathElements: number[], pathIndex: number[]}} An object containing adjacent elements and left-right index
     */
    path(index) {
        if (
            isNaN(Number(index)) ||
            index < 0 ||
            index >= this._layers[0].length
        ) {
            throw new Error('Index out of bounds: ' + index);
        }
        const pathElements = [];
        const pathIndices = [];
        for (let level = 0; level < this.levels; level++) {
            pathIndices[level] = index % 2;
            pathElements[level] =
                (index ^ 1) < this._layers[level].length
                    ? this._layers[level][index ^ 1]
                    : this._zeros[level];
            index >>= 1;
        }
        return {
            pathElements,
            pathIndices,
        };
    }
    /**
     * Find an element in the tree
     * @param element An element to find
     * @param comparator A function that checks leaf value equality
     * @returns {number} Index if element is found, otherwise -1
     */
    indexOf(element, comparator = null) {
        if (comparator) {
            return this._layers[0].findIndex(el => comparator(element, el));
        } else {
            return this._layers[0].indexOf(element);
        }
    }
    /**
     * Returns a copy of non-zero tree elements
     * @returns {Object[]}
     */
    elements() {
        return this._layers[0].slice();
    }
    /**
     * Serialize entire tree state including intermediate layers into a plain object
     * Deserializing it back will not require to recompute any hashes
     * Elements are not converted to a plain type, this is responsibility of the caller
     */
    serialize() {
        return {
            levels: this.levels,
            _zeros: this._zeros,
            _layers: this._layers,
        };
    }
    /**
     * Deserialize data into a MerkleTree instance
     * Make sure to provide the same hashFunction as was used in the source tree,
     * otherwise the tree state will be invalid
     *
     * @param data
     * @param hashFunction
     * @returns {MerkleTree}
     */
    static deserialize(data, hashFunction) {
        const instance = Object.assign(Object.create(this.prototype), data);
        instance._hash = hashFunction;
        instance.capacity = 2 ** instance.levels;
        instance.zeroElement = instance._zeros[0];
        return instance;
    }
}

function toArray(array) {
    if (array === null || array === void 0) {
        array = [];
    }
    if (Array.isArray(array)) {
        return array;
    }
    return [array];
}
function isObject(item) {
    return item != null && typeof item === 'object' && !Array.isArray(item);
}
function objectAttr(source, path, defaultValue = void 0) {
    const paths = path.replace(/\[(\d+)\]/g, '.$1').split('.');
    let result = source;
    for (const p of paths) {
        result = new Object(result)[p];
        if (result === void 0) {
            return defaultValue;
        }
    }
    return result;
}
function createDefer() {
    let resolve = null;
    let reject = null;
    const p = new Promise((_resolve, _reject) => {
        resolve = _resolve;
        reject = _reject;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}
function isNegativeNaN(val) {
    if (!Number.isNaN(val)) {
        return false;
    }
    const f64 = new Float64Array(1);
    f64[0] = val;
    const u32 = new Uint32Array(f64.buffer);
    const isNegative = u32[1] >>> 31 === 1;
    return isNegative;
}

const ansiColors = {
    bold: ['1', '22'],
    dim: ['2', '22'],
    italic: ['3', '23'],
    underline: ['4', '24'],
    // 5 & 6 are blinking
    inverse: ['7', '27'],
    hidden: ['8', '28'],
    strike: ['9', '29'],
    // 10-20 are fonts
    // 21-29 are resets for 1-9
    black: ['30', '39'],
    red: ['31', '39'],
    green: ['32', '39'],
    yellow: ['33', '39'],
    blue: ['34', '39'],
    magenta: ['35', '39'],
    cyan: ['36', '39'],
    white: ['37', '39'],
    brightblack: ['30;1', '39'],
    brightred: ['31;1', '39'],
    brightgreen: ['32;1', '39'],
    brightyellow: ['33;1', '39'],
    brightblue: ['34;1', '39'],
    brightmagenta: ['35;1', '39'],
    brightcyan: ['36;1', '39'],
    brightwhite: ['37;1', '39'],
    grey: ['90', '39'],
};
const styles = {
    special: 'cyan',
    number: 'yellow',
    bigint: 'yellow',
    boolean: 'yellow',
    undefined: 'grey',
    null: 'bold',
    string: 'green',
    symbol: 'green',
    date: 'magenta',
    regexp: 'red',
};
const truncator = '…';
function colorise(value, styleType) {
    const color = ansiColors[styles[styleType]] || ansiColors[styleType] || '';
    if (!color) {
        return String(value);
    }
    return `\u001b[${color[0]}m${String(value)}\u001b[${color[1]}m`;
}
function normaliseOptions(
    {
        showHidden = false,
        depth = 2,
        colors = false,
        customInspect = true,
        showProxy = false,
        maxArrayLength = Infinity,
        breakLength = Infinity,
        seen = [],
        // eslint-disable-next-line no-shadow
        truncate = Infinity,
        stylize = String,
    } = {},
    inspect,
) {
    const options = {
        showHidden: Boolean(showHidden),
        depth: Number(depth),
        colors: Boolean(colors),
        customInspect: Boolean(customInspect),
        showProxy: Boolean(showProxy),
        maxArrayLength: Number(maxArrayLength),
        breakLength: Number(breakLength),
        truncate: Number(truncate),
        seen,
        inspect,
        stylize,
    };
    if (options.colors) {
        options.stylize = colorise;
    }
    return options;
}
function isHighSurrogate(char) {
    return char >= '\ud800' && char <= '\udbff';
}
function truncate(string, length, tail = truncator) {
    string = String(string);
    const tailLength = tail.length;
    const stringLength = string.length;
    if (tailLength > length && stringLength > tailLength) {
        return tail;
    }
    if (stringLength > length && stringLength > tailLength) {
        let end = length - tailLength;
        if (end > 0 && isHighSurrogate(string[end - 1])) {
            end = end - 1;
        }
        return `${string.slice(0, end)}${tail}`;
    }
    return string;
}
// eslint-disable-next-line complexity
function inspectList(list, options, inspectItem, separator = ', ') {
    inspectItem = inspectItem || options.inspect;
    const size = list.length;
    if (size === 0) return '';
    const originalLength = options.truncate;
    let output = '';
    let peek = '';
    let truncated = '';
    for (let i = 0; i < size; i += 1) {
        const last = i + 1 === list.length;
        const secondToLast = i + 2 === list.length;
        truncated = `${truncator}(${list.length - i})`;
        const value = list[i];
        // If there is more than one remaining we need to account for a separator of `, `
        options.truncate =
            originalLength - output.length - (last ? 0 : separator.length);
        const string =
            peek || inspectItem(value, options) + (last ? '' : separator);
        const nextLength = output.length + string.length;
        const truncatedLength = nextLength + truncated.length;
        // If this is the last element, and adding it would
        // take us over length, but adding the truncator wouldn't - then break now
        if (
            last &&
            nextLength > originalLength &&
            output.length + truncated.length <= originalLength
        ) {
            break;
        }
        // If this isn't the last or second to last element to scan,
        // but the string is already over length then break here
        if (!last && !secondToLast && truncatedLength > originalLength) {
            break;
        }
        // Peek at the next string to determine if we should
        // break early before adding this item to the output
        peek = last
            ? ''
            : inspectItem(list[i + 1], options) +
              (secondToLast ? '' : separator);
        // If we have one element left, but this element and
        // the next takes over length, the break early
        if (
            !last &&
            secondToLast &&
            truncatedLength > originalLength &&
            nextLength + peek.length > originalLength
        ) {
            break;
        }
        output += string;
        // If the next element takes us to length -
        // but there are more after that, then we should truncate now
        if (
            !last &&
            !secondToLast &&
            nextLength + peek.length >= originalLength
        ) {
            truncated = `${truncator}(${list.length - i - 1})`;
            break;
        }
        truncated = '';
    }
    return `${output}${truncated}`;
}
function quoteComplexKey(key) {
    if (key.match(/^[a-zA-Z_][a-zA-Z_0-9]*$/)) {
        return key;
    }
    return JSON.stringify(key)
        .replace(/'/g, "\\'")
        .replace(/\\"/g, '"')
        .replace(/(^"|"$)/g, "'");
}
function inspectProperty([key, value], options) {
    options.truncate -= 2;
    if (typeof key === 'string') {
        key = quoteComplexKey(key);
    } else if (typeof key !== 'number') {
        key = `[${options.inspect(key, options)}]`;
    }
    options.truncate -= key.length;
    value = options.inspect(value, options);
    return `${key}: ${value}`;
}

function inspectArray(array, options) {
    // Object.keys will always output the Array indices first, so we can slice by
    // `array.length` to get non-index properties
    const nonIndexProperties = Object.keys(array).slice(array.length);
    if (!array.length && !nonIndexProperties.length) return '[]';
    options.truncate -= 4;
    const listContents = inspectList(array, options);
    options.truncate -= listContents.length;
    let propertyContents = '';
    if (nonIndexProperties.length) {
        propertyContents = inspectList(
            nonIndexProperties.map(key => [key, array[key]]),
            options,
            inspectProperty,
        );
    }
    return `[ ${listContents}${propertyContents ? `, ${propertyContents}` : ''} ]`;
}

const getArrayName = array => {
    // We need to special case Node.js' Buffers, which report to be Uint8Array
    // @ts-ignore
    if (typeof Buffer === 'function' && array instanceof Buffer) {
        return 'Buffer';
    }
    if (array[Symbol.toStringTag]) {
        return array[Symbol.toStringTag];
    }
    return array.constructor.name;
};
function inspectTypedArray(array, options) {
    const name = getArrayName(array);
    options.truncate -= name.length + 4;
    // Object.keys will always output the Array indices first, so we can slice by
    // `array.length` to get non-index properties
    const nonIndexProperties = Object.keys(array).slice(array.length);
    if (!array.length && !nonIndexProperties.length) return `${name}[]`;
    // As we know TypedArrays only contain Unsigned Integers, we can skip inspecting each one and simply
    // stylise the toString() value of them
    let output = '';
    for (let i = 0; i < array.length; i++) {
        const string = `${options.stylize(truncate(array[i], options.truncate), 'number')}${i === array.length - 1 ? '' : ', '}`;
        options.truncate -= string.length;
        if (array[i] !== array.length && options.truncate <= 3) {
            output += `${truncator}(${array.length - array[i] + 1})`;
            break;
        }
        output += string;
    }
    let propertyContents = '';
    if (nonIndexProperties.length) {
        propertyContents = inspectList(
            nonIndexProperties.map(key => [key, array[key]]),
            options,
            inspectProperty,
        );
    }
    return `${name}[ ${output}${propertyContents ? `, ${propertyContents}` : ''} ]`;
}

function inspectDate(dateObject, options) {
    const stringRepresentation = dateObject.toJSON();
    if (stringRepresentation === null) {
        return 'Invalid Date';
    }
    const split = stringRepresentation.split('T');
    const date = split[0];
    // If we need to - truncate the time portion, but never the date
    return options.stylize(
        `${date}T${truncate(split[1], options.truncate - date.length - 1)}`,
        'date',
    );
}

function inspectFunction(func, options) {
    const functionType = func[Symbol.toStringTag] || 'Function';
    const name = func.name;
    if (!name) {
        return options.stylize(`[${functionType}]`, 'special');
    }
    return options.stylize(
        `[${functionType} ${truncate(name, options.truncate - 11)}]`,
        'special',
    );
}

function inspectMapEntry([key, value], options) {
    options.truncate -= 4;
    key = options.inspect(key, options);
    options.truncate -= key.length;
    value = options.inspect(value, options);
    return `${key} => ${value}`;
}
// IE11 doesn't support `map.entries()`
function mapToEntries(map) {
    const entries = [];
    map.forEach((value, key) => {
        entries.push([key, value]);
    });
    return entries;
}
function inspectMap(map, options) {
    const size = map.size - 1;
    if (size <= 0) {
        return 'Map{}';
    }
    options.truncate -= 7;
    return `Map{ ${inspectList(mapToEntries(map), options, inspectMapEntry)} }`;
}

const isNaN$1 = Number.isNaN || (i => i !== i); // eslint-disable-line no-self-compare
function inspectNumber(number, options) {
    if (isNaN$1(number)) {
        return options.stylize('NaN', 'number');
    }
    if (number === Infinity) {
        return options.stylize('Infinity', 'number');
    }
    if (number === -Infinity) {
        return options.stylize('-Infinity', 'number');
    }
    if (number === 0) {
        return options.stylize(1 / number === Infinity ? '+0' : '-0', 'number');
    }
    return options.stylize(
        truncate(String(number), options.truncate),
        'number',
    );
}

function inspectBigInt(number, options) {
    let nums = truncate(number.toString(), options.truncate - 1);
    if (nums !== truncator) nums += 'n';
    return options.stylize(nums, 'bigint');
}

function inspectRegExp(value, options) {
    const flags = value.toString().split('/')[2];
    const sourceLength = options.truncate - (2 + flags.length);
    const source = value.source;
    return options.stylize(
        `/${truncate(source, sourceLength)}/${flags}`,
        'regexp',
    );
}

// IE11 doesn't support `Array.from(set)`
function arrayFromSet(set) {
    const values = [];
    set.forEach(value => {
        values.push(value);
    });
    return values;
}
function inspectSet(set, options) {
    if (set.size === 0) return 'Set{}';
    options.truncate -= 7;
    return `Set{ ${inspectList(arrayFromSet(set), options)} }`;
}

const stringEscapeChars = new RegExp(
    "['\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5" +
        '\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]',
    'g',
);
const escapeCharacters = {
    '\b': '\\b',
    '\t': '\\t',
    '\n': '\\n',
    '\f': '\\f',
    '\r': '\\r',
    "'": "\\'",
    '\\': '\\\\',
};
const hex$1 = 16;
const unicodeLength = 4;
function escape(char) {
    return (
        escapeCharacters[char] ||
        `\\u${`0000${char.charCodeAt(0).toString(hex$1)}`.slice(-unicodeLength)}`
    );
}
function inspectString(string, options) {
    if (stringEscapeChars.test(string)) {
        string = string.replace(stringEscapeChars, escape);
    }
    return options.stylize(
        `'${truncate(string, options.truncate - 2)}'`,
        'string',
    );
}

function inspectSymbol(value) {
    if ('description' in Symbol.prototype) {
        return value.description ? `Symbol(${value.description})` : 'Symbol()';
    }
    return value.toString();
}

let getPromiseValue = () => 'Promise{…}';
try {
    // @ts-ignore
    const { getPromiseDetails, kPending, kRejected } = process.binding('util');
    if (Array.isArray(getPromiseDetails(Promise.resolve()))) {
        getPromiseValue = (value, options) => {
            const [state, innerValue] = getPromiseDetails(value);
            if (state === kPending) {
                return 'Promise{<pending>}';
            }
            return `Promise${state === kRejected ? '!' : ''}{${options.inspect(innerValue, options)}}`;
        };
    }
} catch (notNode) {
    /* ignore */
}
var inspectPromise = getPromiseValue;

function inspectObject$1(object, options) {
    const properties = Object.getOwnPropertyNames(object);
    const symbols = Object.getOwnPropertySymbols
        ? Object.getOwnPropertySymbols(object)
        : [];
    if (properties.length === 0 && symbols.length === 0) {
        return '{}';
    }
    options.truncate -= 4;
    options.seen = options.seen || [];
    if (options.seen.indexOf(object) >= 0) {
        return '[Circular]';
    }
    options.seen.push(object);
    const propertyContents = inspectList(
        properties.map(key => [key, object[key]]),
        options,
        inspectProperty,
    );
    const symbolContents = inspectList(
        symbols.map(key => [key, object[key]]),
        options,
        inspectProperty,
    );
    options.seen.pop();
    let sep = '';
    if (propertyContents && symbolContents) {
        sep = ', ';
    }
    return `{ ${propertyContents}${sep}${symbolContents} }`;
}

const toStringTag =
    typeof Symbol !== 'undefined' && Symbol.toStringTag
        ? Symbol.toStringTag
        : false;
function inspectClass(value, options) {
    let name = '';
    if (toStringTag && toStringTag in value) {
        name = value[toStringTag];
    }
    name = name || value.constructor.name;
    // Babel transforms anonymous classes to the name `_class`
    if (!name || name === '_class') {
        name = '<Anonymous Class>';
    }
    options.truncate -= name.length;
    return `${name}${inspectObject$1(value, options)}`;
}

function inspectArguments(args, options) {
    if (args.length === 0) return 'Arguments[]';
    options.truncate -= 13;
    return `Arguments[ ${inspectList(args, options)} ]`;
}

const errorKeys = [
    'stack',
    'line',
    'column',
    'name',
    'message',
    'fileName',
    'lineNumber',
    'columnNumber',
    'number',
    'description',
];
function inspectObject(error, options) {
    const properties = Object.getOwnPropertyNames(error).filter(
        key => errorKeys.indexOf(key) === -1,
    );
    const name = error.name;
    options.truncate -= name.length;
    let message = '';
    if (typeof error.message === 'string') {
        message = truncate(error.message, options.truncate);
    } else {
        properties.unshift('message');
    }
    message = message ? `: ${message}` : '';
    options.truncate -= message.length + 5;
    const propertyContents = inspectList(
        properties.map(key => [key, error[key]]),
        options,
        inspectProperty,
    );
    return `${name}${message}${propertyContents ? ` { ${propertyContents} }` : ''}`;
}

function inspectAttribute([key, value], options) {
    options.truncate -= 3;
    if (!value) {
        return `${options.stylize(String(key), 'yellow')}`;
    }
    return `${options.stylize(String(key), 'yellow')}=${options.stylize(`"${value}"`, 'string')}`;
}
// @ts-ignore (Deno doesn't have Element)
function inspectHTMLCollection(collection, options) {
    // eslint-disable-next-line no-use-before-define
    return inspectList(collection, options, inspectHTML, '\n');
}
// @ts-ignore (Deno doesn't have Element)
function inspectHTML(element, options) {
    const properties = element.getAttributeNames();
    const name = element.tagName.toLowerCase();
    const head = options.stylize(`<${name}`, 'special');
    const headClose = options.stylize(`>`, 'special');
    const tail = options.stylize(`</${name}>`, 'special');
    options.truncate -= name.length * 2 + 5;
    let propertyContents = '';
    if (properties.length > 0) {
        propertyContents += ' ';
        propertyContents += inspectList(
            properties.map(key => [key, element.getAttribute(key)]),
            options,
            inspectAttribute,
            ' ',
        );
    }
    options.truncate -= propertyContents.length;
    const truncate = options.truncate;
    let children = inspectHTMLCollection(element.children, options);
    if (children && children.length > truncate) {
        children = `${truncator}(${element.children.length})`;
    }
    return `${head}${propertyContents}${headClose}${children}${tail}`;
}

/* !
 * loupe
 * Copyright(c) 2013 Jake Luer <jake@alogicalparadox.com>
 * MIT Licensed
 */
const symbolsSupported =
    typeof Symbol === 'function' && typeof Symbol.for === 'function';
const chaiInspect = symbolsSupported
    ? Symbol.for('chai/inspect')
    : '@@chai/inspect';
let nodeInspect = false;
try {
    // eslint-disable-next-line global-require
    // @ts-ignore
    const nodeUtil = require('util');
    nodeInspect = nodeUtil.inspect ? nodeUtil.inspect.custom : false;
} catch (noNodeInspect) {
    nodeInspect = false;
}
const constructorMap = new WeakMap();
const stringTagMap = {};
const baseTypesMap = {
    undefined: (value, options) => options.stylize('undefined', 'undefined'),
    null: (value, options) => options.stylize('null', 'null'),
    boolean: (value, options) => options.stylize(String(value), 'boolean'),
    Boolean: (value, options) => options.stylize(String(value), 'boolean'),
    number: inspectNumber,
    Number: inspectNumber,
    bigint: inspectBigInt,
    BigInt: inspectBigInt,
    string: inspectString,
    String: inspectString,
    function: inspectFunction,
    Function: inspectFunction,
    symbol: inspectSymbol,
    // A Symbol polyfill will return `Symbol` not `symbol` from typedetect
    Symbol: inspectSymbol,
    Array: inspectArray,
    Date: inspectDate,
    Map: inspectMap,
    Set: inspectSet,
    RegExp: inspectRegExp,
    Promise: inspectPromise,
    // WeakSet, WeakMap are totally opaque to us
    WeakSet: (value, options) => options.stylize('WeakSet{…}', 'special'),
    WeakMap: (value, options) => options.stylize('WeakMap{…}', 'special'),
    Arguments: inspectArguments,
    Int8Array: inspectTypedArray,
    Uint8Array: inspectTypedArray,
    Uint8ClampedArray: inspectTypedArray,
    Int16Array: inspectTypedArray,
    Uint16Array: inspectTypedArray,
    Int32Array: inspectTypedArray,
    Uint32Array: inspectTypedArray,
    Float32Array: inspectTypedArray,
    Float64Array: inspectTypedArray,
    Generator: () => '',
    DataView: () => '',
    ArrayBuffer: () => '',
    Error: inspectObject,
    HTMLCollection: inspectHTMLCollection,
    NodeList: inspectHTMLCollection,
};
// eslint-disable-next-line complexity
const inspectCustom = (value, options, type) => {
    if (chaiInspect in value && typeof value[chaiInspect] === 'function') {
        return value[chaiInspect](options);
    }
    if (
        nodeInspect &&
        nodeInspect in value &&
        typeof value[nodeInspect] === 'function'
    ) {
        return value[nodeInspect](options.depth, options);
    }
    if ('inspect' in value && typeof value.inspect === 'function') {
        return value.inspect(options.depth, options);
    }
    if ('constructor' in value && constructorMap.has(value.constructor)) {
        return constructorMap.get(value.constructor)(value, options);
    }
    if (stringTagMap[type]) {
        return stringTagMap[type](value, options);
    }
    return '';
};
const toString = Object.prototype.toString;
// eslint-disable-next-line complexity
function inspect$1(value, opts = {}) {
    const options = normaliseOptions(opts, inspect$1);
    const { customInspect } = options;
    let type = value === null ? 'null' : typeof value;
    if (type === 'object') {
        type = toString.call(value).slice(8, -1);
    }
    // If it is a base value that we already support, then use Loupe's inspector
    if (type in baseTypesMap) {
        return baseTypesMap[type](value, options);
    }
    // If `options.customInspect` is set to true then try to use the custom inspector
    if (customInspect && value) {
        const output = inspectCustom(value, options, type);
        if (output) {
            if (typeof output === 'string') return output;
            return inspect$1(output, options);
        }
    }
    const proto = value ? Object.getPrototypeOf(value) : false;
    // If it's a plain Object then use Loupe's inspector
    if (proto === Object.prototype || proto === null) {
        return inspectObject$1(value, options);
    }
    // Specifically account for HTMLElements
    // @ts-ignore
    if (
        value &&
        typeof HTMLElement === 'function' &&
        value instanceof HTMLElement
    ) {
        return inspectHTML(value, options);
    }
    if ('constructor' in value) {
        // If it is a class, inspect it like an object but add the constructor name
        if (value.constructor !== Object) {
            return inspectClass(value, options);
        }
        // If it is an object with an anonymous prototype, display it as an object.
        return inspectObject$1(value, options);
    }
    // last chance to check if it's an object
    if (value === Object(value)) {
        return inspectObject$1(value, options);
    }
    // We have run out of options! Just stringify the value
    return options.stylize(String(value), type);
}

// src/index.ts
var f = {
        reset: [0, 0],
        bold: [1, 22, '\x1B[22m\x1B[1m'],
        dim: [2, 22, '\x1B[22m\x1B[2m'],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        hidden: [8, 28],
        strikethrough: [9, 29],
        black: [30, 39],
        red: [31, 39],
        green: [32, 39],
        yellow: [33, 39],
        blue: [34, 39],
        magenta: [35, 39],
        cyan: [36, 39],
        white: [37, 39],
        gray: [90, 39],
        bgBlack: [40, 49],
        bgRed: [41, 49],
        bgGreen: [42, 49],
        bgYellow: [43, 49],
        bgBlue: [44, 49],
        bgMagenta: [45, 49],
        bgCyan: [46, 49],
        bgWhite: [47, 49],
        blackBright: [90, 39],
        redBright: [91, 39],
        greenBright: [92, 39],
        yellowBright: [93, 39],
        blueBright: [94, 39],
        magentaBright: [95, 39],
        cyanBright: [96, 39],
        whiteBright: [97, 39],
        bgBlackBright: [100, 49],
        bgRedBright: [101, 49],
        bgGreenBright: [102, 49],
        bgYellowBright: [103, 49],
        bgBlueBright: [104, 49],
        bgMagentaBright: [105, 49],
        bgCyanBright: [106, 49],
        bgWhiteBright: [107, 49],
    },
    h = Object.entries(f);
function a(n) {
    return String(n);
}
a.open = '';
a.close = '';
function C(n = !1) {
    let e = typeof process != 'undefined' ? process : void 0,
        i = (e == null ? void 0 : e.env) || {},
        g = (e == null ? void 0 : e.argv) || [];
    return (
        (!('NO_COLOR' in i || g.includes('--no-color')) &&
            ('FORCE_COLOR' in i ||
                g.includes('--color') ||
                (e == null ? void 0 : e.platform) === 'win32' ||
                (n && i.TERM !== 'dumb') ||
                'CI' in i)) ||
        (typeof window != 'undefined' && !!window.chrome)
    );
}
function p(n = !1) {
    let e = C(n),
        i = (r, t, c, o) => {
            let l = '',
                s = 0;
            do
                (l += r.substring(s, o) + c),
                    (s = o + t.length),
                    (o = r.indexOf(t, s));
            while (~o);
            return l + r.substring(s);
        },
        g = (r, t, c = r) => {
            let o = l => {
                let s = String(l),
                    b = s.indexOf(t, r.length);
                return ~b ? r + i(s, t, c, b) + t : r + s + t;
            };
            return (o.open = r), (o.close = t), o;
        },
        u = {
            isColorSupported: e,
        },
        d = r => `\x1B[${r}m`;
    for (let [r, t] of h) u[r] = e ? g(d(t[0]), d(t[1]), t[2]) : a;
    return u;
}

// src/browser.ts
p(!1);

const formatRegExp = /%[sdjifoOc%]/g;
function format(...args) {
    if (typeof args[0] !== 'string') {
        const objects = [];
        for (let i2 = 0; i2 < args.length; i2++) {
            objects.push(inspect(args[i2], { depth: 0, colors: false }));
        }
        return objects.join(' ');
    }
    const len = args.length;
    let i = 1;
    const template = args[0];
    let str = String(template).replace(formatRegExp, x => {
        if (x === '%%') {
            return '%';
        }
        if (i >= len) {
            return x;
        }
        switch (x) {
            case '%s': {
                const value = args[i++];
                if (typeof value === 'bigint') {
                    return `${value.toString()}n`;
                }
                if (typeof value === 'number' && value === 0 && 1 / value < 0) {
                    return '-0';
                }
                if (typeof value === 'object' && value !== null) {
                    return inspect(value, { depth: 0, colors: false });
                }
                return String(value);
            }
            case '%d': {
                const value = args[i++];
                if (typeof value === 'bigint') {
                    return `${value.toString()}n`;
                }
                return Number(value).toString();
            }
            case '%i': {
                const value = args[i++];
                if (typeof value === 'bigint') {
                    return `${value.toString()}n`;
                }
                return Number.parseInt(String(value)).toString();
            }
            case '%f':
                return Number.parseFloat(String(args[i++])).toString();
            case '%o':
                return inspect(args[i++], {
                    showHidden: true,
                    showProxy: true,
                });
            case '%O':
                return inspect(args[i++]);
            case '%c': {
                i++;
                return '';
            }
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (err) {
                    const m = err.message;
                    if (
                        // chromium
                        m.includes('circular structure') ||
                        m.includes('cyclic structures') ||
                        m.includes('cyclic object')
                    ) {
                        return '[Circular]';
                    }
                    throw err;
                }
            default:
                return x;
        }
    });
    for (let x = args[i]; i < len; x = args[++i]) {
        if (x === null || typeof x !== 'object') {
            str += ` ${x}`;
        } else {
            str += ` ${inspect(x)}`;
        }
    }
    return str;
}
function inspect(obj, options = {}) {
    if (options.truncate === 0) {
        options.truncate = Number.POSITIVE_INFINITY;
    }
    return inspect$1(obj, options);
}
function objDisplay(obj, options = {}) {
    if (typeof options.truncate === 'undefined') {
        options.truncate = 40;
    }
    const str = inspect(obj, options);
    const type = Object.prototype.toString.call(obj);
    if (options.truncate && str.length >= options.truncate) {
        if (type === '[object Function]') {
            const fn = obj;
            return !fn.name ? '[Function]' : `[Function: ${fn.name}]`;
        } else if (type === '[object Array]') {
            return `[ Array(${obj.length}) ]`;
        } else if (type === '[object Object]') {
            const keys = Object.keys(obj);
            const kstr =
                keys.length > 2
                    ? `${keys.splice(0, 2).join(', ')}, ...`
                    : keys.join(', ');
            return `{ Object (${kstr}) }`;
        } else {
            return str;
        }
    }
    return str;
}

const SAFE_TIMERS_SYMBOL = Symbol('vitest:SAFE_TIMERS');
function getSafeTimers() {
    const {
        setTimeout: safeSetTimeout,
        setInterval: safeSetInterval,
        clearInterval: safeClearInterval,
        clearTimeout: safeClearTimeout,
        setImmediate: safeSetImmediate,
        clearImmediate: safeClearImmediate,
    } = globalThis[SAFE_TIMERS_SYMBOL] || globalThis;
    const { nextTick: safeNextTick } = globalThis[SAFE_TIMERS_SYMBOL] ||
        globalThis.process || { nextTick: cb => cb() };
    return {
        nextTick: safeNextTick,
        setTimeout: safeSetTimeout,
        setInterval: safeSetInterval,
        clearInterval: safeClearInterval,
        clearTimeout: safeClearTimeout,
        setImmediate: safeSetImmediate,
        clearImmediate: safeClearImmediate,
    };
}

// Copyright 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023 Simon Lydell
// License: MIT.
var LineTerminatorSequence;
LineTerminatorSequence = /\r?\n|[\r\u2028\u2029]/y;
RegExp(LineTerminatorSequence.source);

// src/index.ts
var reservedWords = {
    keyword: [
        'break',
        'case',
        'catch',
        'continue',
        'debugger',
        'default',
        'do',
        'else',
        'finally',
        'for',
        'function',
        'if',
        'return',
        'switch',
        'throw',
        'try',
        'var',
        'const',
        'while',
        'with',
        'new',
        'this',
        'super',
        'class',
        'extends',
        'export',
        'import',
        'null',
        'true',
        'false',
        'in',
        'instanceof',
        'typeof',
        'void',
        'delete',
    ],
    strict: [
        'implements',
        'interface',
        'let',
        'package',
        'private',
        'protected',
        'public',
        'static',
        'yield',
    ],
};
new Set(reservedWords.keyword);
new Set(reservedWords.strict);

function createChainable(keys, fn) {
    function create(context) {
        const chain2 = function (...args) {
            return fn.apply(context, args);
        };
        Object.assign(chain2, fn);
        chain2.withContext = () => chain2.bind(context);
        chain2.setContext = (key, value) => {
            context[key] = value;
        };
        chain2.mergeContext = ctx => {
            Object.assign(context, ctx);
        };
        for (const key of keys) {
            Object.defineProperty(chain2, key, {
                get() {
                    return create({ ...context, [key]: true });
                },
            });
        }
        return chain2;
    }
    const chain = create({});
    chain.fn = fn;
    return chain;
}

const fnMap = /* @__PURE__ */ new WeakMap();
const fixtureMap = /* @__PURE__ */ new WeakMap();
const hooksMap = /* @__PURE__ */ new WeakMap();
function setFn(key, fn) {
    fnMap.set(key, fn);
}
function setFixture(key, fixture) {
    fixtureMap.set(key, fixture);
}
function getFixture(key) {
    return fixtureMap.get(key);
}
function setHooks(key, hooks) {
    hooksMap.set(key, hooks);
}
function getHooks(key) {
    return hooksMap.get(key);
}

class PendingError extends Error {
    constructor(message, task) {
        super(message);
        this.message = message;
        this.taskId = task.id;
    }
    code = 'VITEST_PENDING';
    taskId;
}

const collectorContext = {
    tasks: [],
    currentSuite: null,
};
function collectTask(task) {
    var _a;
    (_a = collectorContext.currentSuite) == null ? void 0 : _a.tasks.push(task);
}
async function runWithSuite(suite, fn) {
    const prev = collectorContext.currentSuite;
    collectorContext.currentSuite = suite;
    await fn();
    collectorContext.currentSuite = prev;
}
function withTimeout(fn, timeout, isHook = false) {
    if (timeout <= 0 || timeout === Number.POSITIVE_INFINITY) {
        return fn;
    }
    const { setTimeout, clearTimeout } = getSafeTimers();
    return function runWithTimeout(...args) {
        return Promise.race([
            fn(...args),
            new Promise((resolve, reject) => {
                var _a;
                const timer = setTimeout(() => {
                    clearTimeout(timer);
                    reject(new Error(makeTimeoutMsg(isHook, timeout)));
                }, timeout);
                (_a = timer.unref) == null ? void 0 : _a.call(timer);
            }),
        ]);
    };
}
function createTestContext(test, runner) {
    var _a;
    const context = function () {
        throw new Error('done() callback is deprecated, use promise instead');
    };
    context.task = test;
    context.skip = () => {
        test.pending = true;
        throw new PendingError('test is skipped; abort execution', test);
    };
    context.onTestFailed = fn => {
        test.onFailed || (test.onFailed = []);
        test.onFailed.push(fn);
    };
    context.onTestFinished = fn => {
        test.onFinished || (test.onFinished = []);
        test.onFinished.push(fn);
    };
    return (
        ((_a = runner.extendTaskContext) == null
            ? void 0
            : _a.call(runner, context)) || context
    );
}
function makeTimeoutMsg(isHook, timeout) {
    return `${isHook ? 'Hook' : 'Test'} timed out in ${timeout}ms.
If this is a long-running ${isHook ? 'hook' : 'test'}, pass a timeout value as the last argument or configure it globally with "${isHook ? 'hookTimeout' : 'testTimeout'}".`;
}

function mergeContextFixtures(fixtures, context = {}) {
    const fixtureOptionKeys = ['auto'];
    const fixtureArray = Object.entries(fixtures).map(([prop, value]) => {
        const fixtureItem = { value };
        if (
            Array.isArray(value) &&
            value.length >= 2 &&
            isObject(value[1]) &&
            Object.keys(value[1]).some(key => fixtureOptionKeys.includes(key))
        ) {
            Object.assign(fixtureItem, value[1]);
            fixtureItem.value = value[0];
        }
        fixtureItem.prop = prop;
        fixtureItem.isFn = typeof fixtureItem.value === 'function';
        return fixtureItem;
    });
    if (Array.isArray(context.fixtures)) {
        context.fixtures = context.fixtures.concat(fixtureArray);
    } else {
        context.fixtures = fixtureArray;
    }
    fixtureArray.forEach(fixture => {
        if (fixture.isFn) {
            const usedProps = getUsedProps(fixture.value);
            if (usedProps.length) {
                fixture.deps = context.fixtures.filter(
                    ({ prop }) =>
                        prop !== fixture.prop && usedProps.includes(prop),
                );
            }
        }
    });
    return context;
}
const fixtureValueMaps = /* @__PURE__ */ new Map();
const cleanupFnArrayMap = /* @__PURE__ */ new Map();
function withFixtures(fn, testContext) {
    return hookContext => {
        const context = hookContext || testContext;
        if (!context) {
            return fn({});
        }
        const fixtures = getFixture(context);
        if (!(fixtures == null ? void 0 : fixtures.length)) {
            return fn(context);
        }
        const usedProps = getUsedProps(fn);
        const hasAutoFixture = fixtures.some(({ auto }) => auto);
        if (!usedProps.length && !hasAutoFixture) {
            return fn(context);
        }
        if (!fixtureValueMaps.get(context)) {
            fixtureValueMaps.set(context, /* @__PURE__ */ new Map());
        }
        const fixtureValueMap = fixtureValueMaps.get(context);
        if (!cleanupFnArrayMap.has(context)) {
            cleanupFnArrayMap.set(context, []);
        }
        const cleanupFnArray = cleanupFnArrayMap.get(context);
        const usedFixtures = fixtures.filter(
            ({ prop, auto }) => auto || usedProps.includes(prop),
        );
        const pendingFixtures = resolveDeps(usedFixtures);
        if (!pendingFixtures.length) {
            return fn(context);
        }
        async function resolveFixtures() {
            for (const fixture of pendingFixtures) {
                if (fixtureValueMap.has(fixture)) {
                    continue;
                }
                const resolvedValue = fixture.isFn
                    ? await resolveFixtureFunction(
                          fixture.value,
                          context,
                          cleanupFnArray,
                      )
                    : fixture.value;
                context[fixture.prop] = resolvedValue;
                fixtureValueMap.set(fixture, resolvedValue);
                cleanupFnArray.unshift(() => {
                    fixtureValueMap.delete(fixture);
                });
            }
        }
        return resolveFixtures().then(() => fn(context));
    };
}
async function resolveFixtureFunction(fixtureFn, context, cleanupFnArray) {
    const useFnArgPromise = createDefer();
    let isUseFnArgResolved = false;
    const fixtureReturn = fixtureFn(context, async useFnArg => {
        isUseFnArgResolved = true;
        useFnArgPromise.resolve(useFnArg);
        const useReturnPromise = createDefer();
        cleanupFnArray.push(async () => {
            useReturnPromise.resolve();
            await fixtureReturn;
        });
        await useReturnPromise;
    }).catch(e => {
        if (!isUseFnArgResolved) {
            useFnArgPromise.reject(e);
            return;
        }
        throw e;
    });
    return useFnArgPromise;
}
function resolveDeps(
    fixtures,
    depSet = /* @__PURE__ */ new Set(),
    pendingFixtures = [],
) {
    fixtures.forEach(fixture => {
        if (pendingFixtures.includes(fixture)) {
            return;
        }
        if (!fixture.isFn || !fixture.deps) {
            pendingFixtures.push(fixture);
            return;
        }
        if (depSet.has(fixture)) {
            throw new Error(
                `Circular fixture dependency detected: ${fixture.prop} <- ${[
                    ...depSet,
                ]
                    .reverse()
                    .map(d => d.prop)
                    .join(' <- ')}`,
            );
        }
        depSet.add(fixture);
        resolveDeps(fixture.deps, depSet, pendingFixtures);
        pendingFixtures.push(fixture);
        depSet.clear();
    });
    return pendingFixtures;
}
function getUsedProps(fn) {
    const match = fn.toString().match(/[^(]*\(([^)]*)/);
    if (!match) {
        return [];
    }
    const args = splitByComma(match[1]);
    if (!args.length) {
        return [];
    }
    let first = args[0];
    if ('__VITEST_FIXTURE_INDEX__' in fn) {
        first = args[fn.__VITEST_FIXTURE_INDEX__];
        if (!first) {
            return [];
        }
    }
    if (!(first.startsWith('{') && first.endsWith('}'))) {
        throw new Error(
            `The first argument inside a fixture must use object destructuring pattern, e.g. ({ test } => {}). Instead, received "${first}".`,
        );
    }
    const _first = first.slice(1, -1).replace(/\s/g, '');
    const props = splitByComma(_first).map(prop => {
        return prop.replace(/:.*|=.*/g, '');
    });
    const last = props.at(-1);
    if (last && last.startsWith('...')) {
        throw new Error(
            `Rest parameters are not supported in fixtures, received "${last}".`,
        );
    }
    return props;
}
function splitByComma(s) {
    const result = [];
    const stack = [];
    let start = 0;
    for (let i = 0; i < s.length; i++) {
        if (s[i] === '{' || s[i] === '[') {
            stack.push(s[i] === '{' ? '}' : ']');
        } else if (s[i] === stack[stack.length - 1]) {
            stack.pop();
        } else if (!stack.length && s[i] === ',') {
            const token = s.substring(start, i).trim();
            if (token) {
                result.push(token);
            }
            start = i + 1;
        }
    }
    const lastToken = s.substring(start).trim();
    if (lastToken) {
        result.push(lastToken);
    }
    return result;
}

const suite = createSuite();
createTest(function (name, optionsOrFn, optionsOrTest) {
    getCurrentSuite().test.fn.call(
        this,
        formatName(name),
        optionsOrFn,
        optionsOrTest,
    );
});
let runner;
let defaultSuite;
function assert(condition, message) {
    if (!condition) {
        throw new Error(
            `Vitest failed to find ${message}. This is a bug in Vitest. Please, open an issue with reproduction.`,
        );
    }
}
function getRunner() {
    assert(runner, 'the runner');
    return runner;
}
function getCurrentSuite() {
    const currentSuite = collectorContext.currentSuite || defaultSuite;
    assert(currentSuite, 'the current suite');
    return currentSuite;
}
function createSuiteHooks() {
    return {
        beforeAll: [],
        afterAll: [],
        beforeEach: [],
        afterEach: [],
    };
}
function parseArguments(optionsOrFn, optionsOrTest) {
    let options = {};
    let fn = () => {};
    if (typeof optionsOrTest === 'object') {
        if (typeof optionsOrFn === 'object') {
            throw new TypeError(
                'Cannot use two objects as arguments. Please provide options and a function callback in that order.',
            );
        }
        options = optionsOrTest;
    } else if (typeof optionsOrTest === 'number') {
        options = { timeout: optionsOrTest };
    } else if (typeof optionsOrFn === 'object') {
        options = optionsOrFn;
    }
    if (typeof optionsOrFn === 'function') {
        if (typeof optionsOrTest === 'function') {
            throw new TypeError(
                'Cannot use two functions as arguments. Please use the second argument for options.',
            );
        }
        fn = optionsOrFn;
    } else if (typeof optionsOrTest === 'function') {
        fn = optionsOrTest;
    }
    return {
        options,
        handler: fn,
    };
}
function createSuiteCollector(
    name,
    factory = () => {},
    mode,
    shuffle,
    each,
    suiteOptions,
) {
    const tasks = [];
    const factoryQueue = [];
    let suite2;
    initSuite();
    const task = function (name2 = '', options = {}) {
        const task2 = {
            id: '',
            name: name2,
            suite: void 0,
            each: options.each,
            fails: options.fails,
            context: void 0,
            type: 'custom',
            file: void 0,
            retry: options.retry ?? runner.config.retry,
            repeats: options.repeats,
            mode: options.only
                ? 'only'
                : options.skip
                  ? 'skip'
                  : options.todo
                    ? 'todo'
                    : 'run',
            meta: options.meta ?? /* @__PURE__ */ Object.create(null),
        };
        const handler = options.handler;
        if (
            options.concurrent ||
            (!options.sequential && runner.config.sequence.concurrent)
        ) {
            task2.concurrent = true;
        }
        if (shuffle) {
            task2.shuffle = true;
        }
        const context = createTestContext(task2, runner);
        Object.defineProperty(task2, 'context', {
            value: context,
            enumerable: false,
        });
        setFixture(context, options.fixtures);
        if (handler) {
            setFn(
                task2,
                withTimeout(
                    withAwaitAsyncAssetions(
                        withFixtures(handler, context),
                        task2,
                    ),
                    (options == null ? void 0 : options.timeout) ??
                        runner.config.testTimeout,
                ),
            );
        }
        if (runner.config.includeTaskLocation);
        tasks.push(task2);
        return task2;
    };
    const test2 = createTest(function (name2, optionsOrFn, optionsOrTest) {
        let { options, handler } = parseArguments(optionsOrFn, optionsOrTest);
        if (typeof suiteOptions === 'object') {
            options = Object.assign({}, suiteOptions, options);
        }
        options.concurrent =
            this.concurrent ||
            (!this.sequential &&
                (options == null ? void 0 : options.concurrent));
        options.sequential =
            this.sequential ||
            (!this.concurrent &&
                (options == null ? void 0 : options.sequential));
        const test3 = task(formatName(name2), {
            ...this,
            ...options,
            handler,
        });
        test3.type = 'test';
    });
    const collector = {
        type: 'collector',
        name,
        mode,
        options: suiteOptions,
        test: test2,
        tasks,
        collect,
        task,
        clear,
        on: addHook,
    };
    function addHook(name2, ...fn) {
        getHooks(suite2)[name2].push(...fn);
    }
    function initSuite(includeLocation) {
        if (typeof suiteOptions === 'number') {
            suiteOptions = { timeout: suiteOptions };
        }
        suite2 = {
            id: '',
            type: 'suite',
            name,
            mode,
            each,
            file: void 0,
            shuffle,
            tasks: [],
            meta: /* @__PURE__ */ Object.create(null),
            concurrent: suiteOptions == null ? void 0 : suiteOptions.concurrent,
        };
        setHooks(suite2, createSuiteHooks());
    }
    function clear() {
        tasks.length = 0;
        factoryQueue.length = 0;
        initSuite();
    }
    async function collect(file) {
        if (!file) {
            throw new TypeError('File is required to collect tasks.');
        }
        factoryQueue.length = 0;
        if (factory) {
            await runWithSuite(collector, () => factory(test2));
        }
        const allChildren = [];
        for (const i of [...factoryQueue, ...tasks]) {
            allChildren.push(
                i.type === 'collector' ? await i.collect(file) : i,
            );
        }
        suite2.file = file;
        suite2.tasks = allChildren;
        allChildren.forEach(task2 => {
            task2.suite = suite2;
            task2.file = file;
        });
        return suite2;
    }
    collectTask(collector);
    return collector;
}
function withAwaitAsyncAssetions(fn, task) {
    return async (...args) => {
        await fn(...args);
        if (task.promises) {
            const result = await Promise.allSettled(task.promises);
            const errors = result
                .map(r => (r.status === 'rejected' ? r.reason : void 0))
                .filter(Boolean);
            if (errors.length) {
                throw errors;
            }
        }
    };
}
function createSuite() {
    function suiteFn(name, factoryOrOptions, optionsOrFactory = {}) {
        const mode = this.only
            ? 'only'
            : this.skip
              ? 'skip'
              : this.todo
                ? 'todo'
                : 'run';
        const currentSuite = collectorContext.currentSuite || defaultSuite;
        let { options, handler: factory } = parseArguments(
            factoryOrOptions,
            optionsOrFactory,
        );
        if (currentSuite == null ? void 0 : currentSuite.options) {
            options = { ...currentSuite.options, ...options };
        }
        const isConcurrent =
            options.concurrent || (this.concurrent && !this.sequential);
        const isSequential =
            options.sequential || (this.sequential && !this.concurrent);
        options.concurrent = isConcurrent && !isSequential;
        options.sequential = isSequential && !isConcurrent;
        return createSuiteCollector(
            formatName(name),
            factory,
            mode,
            this.shuffle,
            this.each,
            options,
        );
    }
    suiteFn.each = function (cases, ...args) {
        const suite2 = this.withContext();
        this.setContext('each', true);
        if (Array.isArray(cases) && args.length) {
            cases = formatTemplateString(cases, args);
        }
        return (name, optionsOrFn, fnOrOptions) => {
            const _name = formatName(name);
            const arrayOnlyCases = cases.every(Array.isArray);
            const { options, handler } = parseArguments(
                optionsOrFn,
                fnOrOptions,
            );
            const fnFirst = typeof optionsOrFn === 'function';
            cases.forEach((i, idx) => {
                const items = Array.isArray(i) ? i : [i];
                if (fnFirst) {
                    if (arrayOnlyCases) {
                        suite2(
                            formatTitle(_name, items, idx),
                            () => handler(...items),
                            options,
                        );
                    } else {
                        suite2(
                            formatTitle(_name, items, idx),
                            () => handler(i),
                            options,
                        );
                    }
                } else {
                    if (arrayOnlyCases) {
                        suite2(formatTitle(_name, items, idx), options, () =>
                            handler(...items),
                        );
                    } else {
                        suite2(formatTitle(_name, items, idx), options, () =>
                            handler(i),
                        );
                    }
                }
            });
            this.setContext('each', void 0);
        };
    };
    suiteFn.skipIf = condition => (condition ? suite.skip : suite);
    suiteFn.runIf = condition => (condition ? suite : suite.skip);
    return createChainable(
        ['concurrent', 'sequential', 'shuffle', 'skip', 'only', 'todo'],
        suiteFn,
    );
}
function createTaskCollector(fn, context) {
    const taskFn = fn;
    taskFn.each = function (cases, ...args) {
        const test2 = this.withContext();
        this.setContext('each', true);
        if (Array.isArray(cases) && args.length) {
            cases = formatTemplateString(cases, args);
        }
        return (name, optionsOrFn, fnOrOptions) => {
            const _name = formatName(name);
            const arrayOnlyCases = cases.every(Array.isArray);
            const { options, handler } = parseArguments(
                optionsOrFn,
                fnOrOptions,
            );
            const fnFirst = typeof optionsOrFn === 'function';
            cases.forEach((i, idx) => {
                const items = Array.isArray(i) ? i : [i];
                if (fnFirst) {
                    if (arrayOnlyCases) {
                        test2(
                            formatTitle(_name, items, idx),
                            () => handler(...items),
                            options,
                        );
                    } else {
                        test2(
                            formatTitle(_name, items, idx),
                            () => handler(i),
                            options,
                        );
                    }
                } else {
                    if (arrayOnlyCases) {
                        test2(formatTitle(_name, items, idx), options, () =>
                            handler(...items),
                        );
                    } else {
                        test2(formatTitle(_name, items, idx), options, () =>
                            handler(i),
                        );
                    }
                }
            });
            this.setContext('each', void 0);
        };
    };
    taskFn.for = function (cases, ...args) {
        const test2 = this.withContext();
        if (Array.isArray(cases) && args.length) {
            cases = formatTemplateString(cases, args);
        }
        return (name, optionsOrFn, fnOrOptions) => {
            const _name = formatName(name);
            const { options, handler } = parseArguments(
                optionsOrFn,
                fnOrOptions,
            );
            cases.forEach((item, idx) => {
                const handlerWrapper = ctx => handler(item, ctx);
                handlerWrapper.__VITEST_FIXTURE_INDEX__ = 1;
                handlerWrapper.toString = () => handler.toString();
                test2(
                    formatTitle(_name, toArray(item), idx),
                    options,
                    handlerWrapper,
                );
            });
        };
    };
    taskFn.skipIf = function (condition) {
        return condition ? this.skip : this;
    };
    taskFn.runIf = function (condition) {
        return condition ? this : this.skip;
    };
    taskFn.extend = function (fixtures) {
        const _context = mergeContextFixtures(fixtures, context);
        return createTest(function fn2(name, optionsOrFn, optionsOrTest) {
            getCurrentSuite().test.fn.call(
                this,
                formatName(name),
                optionsOrFn,
                optionsOrTest,
            );
        }, _context);
    };
    const _test = createChainable(
        ['concurrent', 'sequential', 'skip', 'only', 'todo', 'fails'],
        taskFn,
    );
    if (context) {
        _test.mergeContext(context);
    }
    return _test;
}
function createTest(fn, context) {
    return createTaskCollector(fn, context);
}
function formatName(name) {
    return typeof name === 'string'
        ? name
        : name instanceof Function
          ? name.name || '<anonymous>'
          : String(name);
}
function formatTitle(template, items, idx) {
    if (template.includes('%#')) {
        template = template
            .replace(/%%/g, '__vitest_escaped_%__')
            .replace(/%#/g, `${idx}`)
            .replace(/__vitest_escaped_%__/g, '%%');
    }
    const count = template.split('%').length - 1;
    if (template.includes('%f')) {
        const placeholders = template.match(/%f/g) || [];
        placeholders.forEach((_, i) => {
            if (isNegativeNaN(items[i]) || Object.is(items[i], -0)) {
                let occurrence = 0;
                template = template.replace(/%f/g, match => {
                    occurrence++;
                    return occurrence === i + 1 ? '-%f' : match;
                });
            }
        });
    }
    let formatted = format(template, ...items.slice(0, count));
    if (isObject(items[0])) {
        formatted = formatted.replace(
            /\$([$\w.]+)/g,
            // https://github.com/chaijs/chai/pull/1490
            (_, key) => {
                var _a, _b;
                return objDisplay(objectAttr(items[0], key), {
                    truncate:
                        (_b = (_a = void 0) == null ? void 0 : _a.chaiConfig) ==
                        null
                            ? void 0
                            : _b.truncateThreshold,
                });
            },
        );
    }
    return formatted;
}
function formatTemplateString(cases, args) {
    const header = cases
        .join('')
        .trim()
        .replace(/ /g, '')
        .split('\n')
        .map(i => i.split('|'))[0];
    const res = [];
    for (let i = 0; i < Math.floor(args.length / header.length); i++) {
        const oneCase = {};
        for (let j = 0; j < header.length; j++) {
            oneCase[header[j]] = args[i * header.length + j];
        }
        res.push(oneCase);
    }
    return res;
}

globalThis.performance
    ? globalThis.performance.now.bind(globalThis.performance)
    : Date.now;

globalThis.performance
    ? globalThis.performance.now.bind(globalThis.performance)
    : Date.now;

function getDefaultHookTimeout() {
    return getRunner().config.hookTimeout;
}
function beforeAll(fn, timeout) {
    return getCurrentSuite().on(
        'beforeAll',
        withTimeout(fn, getDefaultHookTimeout(), true),
    );
}

class IndexedElement {
    constructor(index, value, nextIndex) {
        this.index = index;
        this.value = value;
        this.nextIndex = nextIndex;
    }
    equals(other) {
        return this.value.eq(other.value);
    }
    compareTo(other) {
        return this.value.cmp(other.value);
    }
    hash(lightWasm, nextValue) {
        try {
            const hash = lightWasm.poseidonHash([
                bn(this.value.toArray('be', 32)).toString(),
                bn(this.nextIndex).toString(),
                bn(nextValue.toArray('be', 32)).toString(),
            ]);
            return hash;
        } catch (error) {
            throw new Error('Hashing failed');
        }
    }
}
class IndexedElementBundle {
    constructor(newLowElement, newElement, newElementNextValue) {
        this.newLowElement = newLowElement;
        this.newElement = newElement;
        this.newElementNextValue = newElementNextValue;
    }
}
/**
 * This indexed array implementation mirrors the rust implementation of the
 * indexed merkle tree. It stores the elements of the indexed merkle tree.
 */
class IndexedArray {
    constructor(elements, currentNodeIndex, highestElementIndex) {
        this.elements = elements;
        this.currentNodeIndex = currentNodeIndex;
        this.highestElementIndex = highestElementIndex;
    }
    static default() {
        return new IndexedArray([new IndexedElement(0, bn(0), 0)], 0, 0);
    }
    get(index) {
        return this.elements[index];
    }
    length() {
        return Number(this.currentNodeIndex);
    }
    isEmpty() {
        return this.currentNodeIndex === 0;
    }
    findElement(value) {
        return this.elements
            .slice(0, this.length() + 1)
            .find(node => node.value === value);
    }
    init() {
        try {
            const init_value = HIGHEST_ADDRESS_PLUS_ONE;
            return this.append(init_value);
        } catch (error) {
            throw new Error(`Failed to initialize IndexedArray: ${error}`);
        }
    }
    /**
     * Finds the index of the low element for the given `value` which should not be part of the array.
     * Low element is the greatest element which still has a lower value than the provided one.
     * Low elements are used in non-membership proofs.
     */
    findLowElementIndex(value) {
        // Try to find element whose next element is higher than the provided value.
        for (let i = 0; i <= this.length(); i++) {
            const node = this.elements[i];
            if (
                this.elements[node.nextIndex].value.gt(value) &&
                node.value.lt(value)
            ) {
                return i;
            } else if (node.value.eq(value)) {
                throw new Error('Element already exists in the array');
            }
        }
        // If no such element was found, it means that our value is going to be the greatest in the array.
        // This means that the currently greatest element is going to be the low element of our value.
        return this.highestElementIndex;
    }
    /**
     * Returns the low element for the given value and the next value for that low element.
     * Low element is the greatest element which still has lower value than the provided one.
     * Low elements are used in non-membership proofs.
     */
    findLowElement(value) {
        const lowElementIndex = this.findLowElementIndex(value);
        if (lowElementIndex === undefined) return [undefined, undefined];
        const lowElement = this.elements[lowElementIndex];
        return [lowElement, this.elements[lowElement.nextIndex].value];
    }
    // /**
    //  * Returns the index of the low element for the given `value`, which should be the part of the array.
    //  * Low element is the greatest element which still has lower value than the provided one.
    //  * Low elements are used in non-membership proofs.
    //  */
    // public findLowElementIndexForExistingElement(
    //     value: BN,
    // ): number | undefined {
    //     for (let i = 0; i <= this.length(); i++) {
    //         const node = this.elements[i];
    //         if (this.elements[node.nextIndex].value === value) {
    //             return i;
    //         }
    //     }
    //     return undefined;
    // }
    /**
     * Returns the hash of the given element. That hash consists of:
     * - The value of the given element.
     * - The `nextIndex` of the given element.
     * - The value of the element pointed by `nextIndex`.
     */
    hashElement(lightWasm, index) {
        const element = this.elements[index];
        if (!element) return undefined;
        const nextElement = this.elements[element.nextIndex];
        if (!nextElement) return undefined;
        const hash = lightWasm.poseidonHash([
            bn(element.value.toArray('be', 32)).toString(),
            bn(element.nextIndex).toString(),
            bn(nextElement.value.toArray('be', 32)).toString(),
        ]);
        return hash;
    }
    /**
     * Appends a new element with the given value to the indexed array.
     * It finds the low element index and uses it to append the new element correctly.
     * @param value The value of the new element to append.
     * @returns The new element and its low element after insertion.
     */
    append(value) {
        const lowElementIndex = this.findLowElementIndex(value);
        if (lowElementIndex === undefined) {
            throw new Error('Low element index not found.');
        }
        return this.appendWithLowElementIndex(lowElementIndex, value);
    }
    /**
     * Appends a new element with the given value to the indexed array using a specific low element index.
     * This method ensures the new element is placed correctly relative to the low element.
     * @param lowElementIndex The index of the low element.
     * @param value The value of the new element to append.
     * @returns The new element and its updated low element.
     */
    appendWithLowElementIndex(lowElementIndex, value) {
        const lowElement = this.elements[lowElementIndex];
        if (lowElement.nextIndex === 0) {
            if (value.lte(lowElement.value)) {
                throw new Error(
                    'New element value must be greater than the low element value.',
                );
            }
        } else {
            const nextElement = this.elements[lowElement.nextIndex];
            if (value.lte(lowElement.value)) {
                throw new Error(
                    'New element value must be greater than the low element value.',
                );
            }
            if (value.gte(nextElement.value)) {
                throw new Error(
                    'New element value must be less than the next element value.',
                );
            }
        }
        const newElementBundle = this.newElementWithLowElementIndex(
            lowElementIndex,
            value,
        );
        // If the old low element wasn't pointing to any element, it means that:
        //
        // * It used to be the highest element.
        // * Our new element, which we are appending, is going the be the
        //   highest element.
        //
        // Therefore, we need to save the new element index as the highest
        // index.
        if (lowElement.nextIndex === 0) {
            this.highestElementIndex = newElementBundle.newElement.index;
        }
        // Insert new node.
        this.currentNodeIndex = newElementBundle.newElement.index;
        this.elements[this.length()] = newElementBundle.newElement;
        // Update low element.
        this.elements[lowElementIndex] = newElementBundle.newLowElement;
        return newElementBundle;
    }
    /**
     * Finds the lowest element in the array.
     * @returns The lowest element or undefined if the array is empty.
     */
    lowest() {
        return this.elements.length > 0 ? this.elements[0] : undefined;
    }
    /**
     * Creates a new element with the specified value and updates the low element index accordingly.
     * @param lowElementIndex The index of the low element.
     * @param value The value for the new element.
     * @returns A bundle containing the new element, the updated low element, and the value of the next element.
     */
    newElementWithLowElementIndex(lowElementIndex, value) {
        const newLowElement = this.elements[lowElementIndex];
        const newElementIndex = this.currentNodeIndex + 1;
        const newElement = new IndexedElement(
            newElementIndex,
            value,
            newLowElement.nextIndex,
        );
        newLowElement.nextIndex = newElementIndex;
        const newElementNextValue = this.elements[newElement.nextIndex].value;
        return new IndexedElementBundle(
            newLowElement,
            newElement,
            newElementNextValue,
        );
    }
    /**
     * Creates a new element with the specified value by first finding the appropriate low element index.
     * @param value The value for the new element.
     * @returns A bundle containing the new element, the updated low element, and the value of the next element.
     */
    newElement(value) {
        const lowElementIndex = this.findLowElementIndex(value);
        if (lowElementIndex === undefined) {
            throw new Error('Low element index not found.');
        }
        return this.newElementWithLowElementIndex(lowElementIndex, value);
    }
}
if (undefined) {
    const { it, expect, describe } = undefined;
    let WasmFactory;
    const refIndexedMerkleTreeInitedRoot = [
        33, 133, 56, 184, 142, 166, 110, 161, 4, 140, 169, 247, 115, 33, 15,
        181, 76, 89, 48, 126, 58, 86, 204, 81, 16, 121, 185, 77, 75, 152, 43,
        15,
    ];
    const refIndexedMerkleTreeRootWithOneAppend = [
        31, 159, 196, 171, 68, 16, 213, 28, 158, 200, 223, 91, 244, 193, 188,
        162, 50, 68, 54, 244, 116, 44, 153, 65, 209, 9, 47, 98, 126, 89, 131,
        158,
    ];
    const refIndexedMerkleTreeRootWithTwoAppends = [
        1, 185, 99, 233, 59, 202, 51, 222, 224, 31, 119, 180, 76, 104, 72, 27,
        152, 12, 236, 78, 81, 60, 87, 158, 237, 1, 176, 9, 155, 166, 108, 89,
    ];
    const refIndexedMerkleTreeRootWithThreeAppends = [
        41, 143, 181, 2, 66, 117, 37, 226, 134, 212, 45, 95, 114, 60, 189, 18,
        44, 155, 132, 148, 41, 54, 131, 106, 61, 120, 237, 168, 118, 198, 63,
        116,
    ];
    const refIndexedArrayElem0 = new IndexedElement(0, bn(0), 2);
    const refIndexedArrayElem1 = new IndexedElement(
        1,
        HIGHEST_ADDRESS_PLUS_ONE,
        0,
    );
    const refIndexedArrayElem2 = new IndexedElement(2, bn(30), 1);
    describe('IndexedArray', () => {
        beforeAll(async () => {
            WasmFactory = (
                await Promise.resolve().then(function () {
                    return require('./index_browser_fat-CeFmPS7H.js');
                })
            ).WasmFactory;
        });
        it('should findLowElementIndex', () => {
            const indexedArray = new IndexedArray(
                [
                    refIndexedArrayElem0,
                    refIndexedArrayElem1,
                    refIndexedArrayElem2,
                ],
                2,
                1,
            );
            expect(indexedArray.findLowElementIndex(bn(29))).toEqual(0);
            expect(() => indexedArray.findLowElementIndex(bn(30))).toThrow();
            expect(indexedArray.findLowElementIndex(bn(31))).toEqual(2);
        });
        it('should findLowElement', () => {
            const indexedArray = new IndexedArray(
                [
                    refIndexedArrayElem0,
                    refIndexedArrayElem1,
                    refIndexedArrayElem2,
                ],
                2,
                1,
            );
            const [lowElement, nextValue] = indexedArray.findLowElement(bn(29));
            expect(lowElement).toEqual(refIndexedArrayElem0);
            expect(nextValue).toEqual(bn(30));
            expect(() => indexedArray.findLowElement(bn(30))).toThrow();
            const [lowElement2, nextValue2] = indexedArray.findLowElement(
                bn(31),
            );
            expect(lowElement2).toEqual(refIndexedArrayElem2);
            expect(nextValue2).toEqual(HIGHEST_ADDRESS_PLUS_ONE);
        });
        it('should appendWithLowElementIndex', () => {
            const indexedArray = new IndexedArray(
                [
                    new IndexedElement(0, bn(0), 1),
                    new IndexedElement(1, HIGHEST_ADDRESS_PLUS_ONE, 0),
                ],
                1,
                1,
            );
            const newElement = indexedArray.appendWithLowElementIndex(
                0,
                bn(30),
            );
            expect(newElement.newElement).toEqual(refIndexedArrayElem2);
            expect(newElement.newLowElement).toEqual(refIndexedArrayElem0);
            expect(newElement.newElementNextValue).toEqual(
                HIGHEST_ADDRESS_PLUS_ONE,
            );
        });
        it('should append', () => {
            const indexedArray = new IndexedArray(
                [
                    new IndexedElement(0, bn(0), 1),
                    new IndexedElement(1, HIGHEST_ADDRESS_PLUS_ONE, 0),
                ],
                1,
                1,
            );
            const newElement = indexedArray.append(bn(30));
            expect(newElement.newElement).toEqual(refIndexedArrayElem2);
            expect(newElement.newLowElement).toEqual(refIndexedArrayElem0);
            expect(newElement.newElementNextValue).toEqual(
                HIGHEST_ADDRESS_PLUS_ONE,
            );
        });
        it('should append 3 times and match merkle trees', async () => {
            const lightWasm = await WasmFactory.getInstance();
            const indexedArray = IndexedArray.default();
            indexedArray.init();
            let hash0 = indexedArray.hashElement(lightWasm, 0);
            let hash1 = indexedArray.hashElement(lightWasm, 1);
            let leaves = [hash0, hash1].map(leaf => bn(leaf).toString());
            let tree = new MerkleTree(26, lightWasm, leaves);
            expect(tree.root()).toEqual(
                bn(refIndexedMerkleTreeInitedRoot).toString(),
            );
            // 1st
            const newElement = indexedArray.append(bn(30));
            expect(newElement.newElement).toEqual(refIndexedArrayElem2);
            expect(newElement.newLowElement).toEqual(refIndexedArrayElem0);
            expect(newElement.newElementNextValue).toEqual(
                HIGHEST_ADDRESS_PLUS_ONE,
            );
            hash0 = indexedArray.hashElement(lightWasm, 0);
            hash1 = indexedArray.hashElement(lightWasm, 1);
            let hash2 = indexedArray.hashElement(lightWasm, 2);
            leaves = [hash0, hash1, hash2].map(leaf => bn(leaf).toString());
            tree = new MerkleTree(26, lightWasm, leaves);
            expect(tree.root()).toEqual(
                bn(refIndexedMerkleTreeRootWithOneAppend).toString(),
            );
            // 2nd
            let refItems0 = new IndexedElement(0, bn(0), 2);
            let refItems1 = new IndexedElement(1, HIGHEST_ADDRESS_PLUS_ONE, 0);
            let refItems2 = new IndexedElement(2, bn(30), 3);
            let refItems3 = new IndexedElement(3, bn(42), 1);
            const newElement2 = indexedArray.append(bn(42));
            expect(newElement2.newElement).toEqual(refItems3);
            expect(newElement2.newLowElement).toEqual(refItems2);
            expect(newElement2.newElementNextValue).toEqual(
                HIGHEST_ADDRESS_PLUS_ONE,
            );
            expect(indexedArray.elements[0].equals(refItems0)).toBeTruthy();
            expect(indexedArray.elements[1].equals(refItems1)).toBeTruthy();
            expect(indexedArray.elements[2].equals(refItems2)).toBeTruthy();
            expect(indexedArray.elements[3].equals(refItems3)).toBeTruthy();
            hash0 = indexedArray.hashElement(lightWasm, 0);
            hash1 = indexedArray.hashElement(lightWasm, 1);
            hash2 = indexedArray.hashElement(lightWasm, 2);
            let hash3 = indexedArray.hashElement(lightWasm, 3);
            leaves = [hash0, hash1, hash2, hash3].map(leaf =>
                bn(leaf).toString(),
            );
            tree = new MerkleTree(26, lightWasm, leaves);
            expect(tree.root()).toEqual(
                bn(refIndexedMerkleTreeRootWithTwoAppends).toString(),
            );
            // 3rd
            refItems0 = new IndexedElement(0, bn(0), 4);
            refItems1 = new IndexedElement(1, HIGHEST_ADDRESS_PLUS_ONE, 0);
            refItems2 = new IndexedElement(2, bn(30), 3);
            refItems3 = new IndexedElement(3, bn(42), 1);
            const refItems4 = new IndexedElement(4, bn(12), 2);
            const newElement3 = indexedArray.append(bn(12));
            expect(newElement3.newElement).toEqual(refItems4);
            expect(newElement3.newLowElement).toEqual(refItems0);
            expect(newElement3.newElementNextValue).toEqual(bn(30));
            expect(indexedArray.elements[0].equals(refItems0)).toBeTruthy();
            expect(indexedArray.elements[1].equals(refItems1)).toBeTruthy();
            expect(indexedArray.elements[2].equals(refItems2)).toBeTruthy();
            expect(indexedArray.elements[3].equals(refItems3)).toBeTruthy();
            expect(indexedArray.elements[4].equals(refItems4)).toBeTruthy();
            hash0 = indexedArray.hashElement(lightWasm, 0);
            hash1 = indexedArray.hashElement(lightWasm, 1);
            hash2 = indexedArray.hashElement(lightWasm, 2);
            hash3 = indexedArray.hashElement(lightWasm, 3);
            const hash4 = indexedArray.hashElement(lightWasm, 4);
            leaves = [hash0, hash1, hash2, hash3, hash4].map(leaf =>
                bn(leaf).toString(),
            );
            tree = new MerkleTree(26, lightWasm, leaves);
            expect(tree.root()).toEqual(
                bn(refIndexedMerkleTreeRootWithThreeAppends).toString(),
            );
        });
    });
}

var bytes = {};

var hex = {};

Object.defineProperty(hex, '__esModule', { value: true });
hex.decode = hex.encode = void 0;
const buffer_1$1 = require$$0$1;
function encode$3(data) {
    return data.reduce(
        (str, byte) => str + byte.toString(16).padStart(2, '0'),
        '0x',
    );
}
hex.encode = encode$3;
function decode$3(data) {
    if (data.indexOf('0x') === 0) {
        data = data.substr(2);
    }
    if (data.length % 2 === 1) {
        data = '0' + data;
    }
    let key = data.match(/.{2}/g);
    if (key === null) {
        return buffer_1$1.Buffer.from([]);
    }
    return buffer_1$1.Buffer.from(key.map(byte => parseInt(byte, 16)));
}
hex.decode = decode$3;

var utf8 = {};

var common = {};

var _a;
Object.defineProperty(common, '__esModule', { value: true });
common.isVersionedTransaction = common.chunks = common.isBrowser = void 0;
/**
 * Returns true if being run inside a web browser,
 * false if in a Node process or electron app.
 */
common.isBrowser =
    process.env.ANCHOR_BROWSER ||
    (typeof window !== 'undefined' &&
        !((_a = window.process) === null || _a === void 0
            ? void 0
            : _a.hasOwnProperty('type')));
/**
 * Splits an array into chunks
 *
 * @param array Array of objects to chunk.
 * @param size The max size of a chunk.
 * @returns A two dimensional array where each T[] length is < the provided size.
 */
function chunks(array, size) {
    return Array.apply(0, new Array(Math.ceil(array.length / size))).map(
        (_, index) => array.slice(index * size, (index + 1) * size),
    );
}
common.chunks = chunks;
/**
 * Check if a transaction object is a VersionedTransaction or not
 *
 * @param tx
 * @returns bool
 */
const isVersionedTransaction = tx => {
    return 'version' in tx;
};
common.isVersionedTransaction = isVersionedTransaction;

Object.defineProperty(utf8, '__esModule', { value: true });
utf8.encode = utf8.decode = void 0;
const common_1 = common;
function decode$2(array) {
    const decoder = common_1.isBrowser
        ? new TextDecoder('utf-8') // Browser https://caniuse.com/textencoder.
        : new require$$1.TextDecoder('utf-8'); // Node.
    return decoder.decode(array);
}
utf8.decode = decode$2;
function encode$2(input) {
    const encoder = common_1.isBrowser
        ? new TextEncoder() // Browser.
        : new require$$1.TextEncoder('utf-8'); // Node.
    return encoder.encode(input);
}
utf8.encode = encode$2;

var bs58$1 = {};

var __importDefault =
    (commonjsGlobal && commonjsGlobal.__importDefault) ||
    function (mod) {
        return mod && mod.__esModule ? mod : { default: mod };
    };
Object.defineProperty(bs58$1, '__esModule', { value: true });
bs58$1.decode = bs58$1.encode = void 0;
const bs58_1 = __importDefault(bs58$2);
function encode$1(data) {
    return bs58_1.default.encode(data);
}
bs58$1.encode = encode$1;
function decode$1(data) {
    return bs58_1.default.decode(data);
}
bs58$1.decode = decode$1;

var base64 = {};

Object.defineProperty(base64, '__esModule', { value: true });
base64.decode = base64.encode = void 0;
const buffer_1 = require$$0$1;
function encode(data) {
    return data.toString('base64');
}
base64.encode = encode;
function decode(data) {
    return buffer_1.Buffer.from(data, 'base64');
}
base64.decode = decode;

var __createBinding =
    (commonjsGlobal && commonjsGlobal.__createBinding) ||
    (Object.create
        ? function (o, m, k, k2) {
              if (k2 === undefined) k2 = k;
              var desc = Object.getOwnPropertyDescriptor(m, k);
              if (
                  !desc ||
                  ('get' in desc
                      ? !m.__esModule
                      : desc.writable || desc.configurable)
              ) {
                  desc = {
                      enumerable: true,
                      get: function () {
                          return m[k];
                      },
                  };
              }
              Object.defineProperty(o, k2, desc);
          }
        : function (o, m, k, k2) {
              if (k2 === undefined) k2 = k;
              o[k2] = m[k];
          });
var __setModuleDefault =
    (commonjsGlobal && commonjsGlobal.__setModuleDefault) ||
    (Object.create
        ? function (o, v) {
              Object.defineProperty(o, 'default', {
                  enumerable: true,
                  value: v,
              });
          }
        : function (o, v) {
              o['default'] = v;
          });
var __importStar =
    (commonjsGlobal && commonjsGlobal.__importStar) ||
    function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null)
            for (var k in mod)
                if (
                    k !== 'default' &&
                    Object.prototype.hasOwnProperty.call(mod, k)
                )
                    __createBinding(result, mod, k);
        __setModuleDefault(result, mod);
        return result;
    };
Object.defineProperty(bytes, '__esModule', { value: true });
bytes.base64 = bs58 = bytes.bs58 = bytes.utf8 = bytes.hex = void 0;
bytes.hex = __importStar(hex);
bytes.utf8 = __importStar(utf8);
var bs58 = (bytes.bs58 = __importStar(bs58$1));
bytes.base64 = __importStar(base64);

/**
 * @internal
 * Returns newest first.
 *
 * */
async function getParsedEvents(rpc) {
    const { noopProgram, accountCompressionProgram } =
        defaultStaticAccountsStruct();
    /// Get raw transactions
    const signatures = (
        await rpc.getConfirmedSignaturesForAddress2(
            accountCompressionProgram,
            undefined,
            'confirmed',
        )
    ).map(s => s.signature);
    const txs = await rpc.getParsedTransactions(signatures, {
        maxSupportedTransactionVersion: 0,
        commitment: 'confirmed',
    });
    /// Filter by NOOP program
    const transactionEvents = txs.filter(tx => {
        if (!tx) {
            return false;
        }
        const accountKeys = tx.transaction.message.accountKeys;
        const hasSplNoopAddress = accountKeys.some(item => {
            const itemStr =
                typeof item === 'string' ? item : item.pubkey.toBase58();
            return itemStr === noopProgram.toBase58();
        });
        return hasSplNoopAddress;
    });
    /// Parse events
    const parsedEvents = parseEvents(
        transactionEvents,
        parsePublicTransactionEventWithIdl,
    );
    return parsedEvents;
}
const parseEvents = (indexerEventsTransactions, deserializeFn) => {
    const { noopProgram } = defaultStaticAccountsStruct();
    const transactions = [];
    indexerEventsTransactions.forEach(tx => {
        if (
            !tx ||
            !tx.meta ||
            tx.meta.err ||
            !tx.meta.innerInstructions ||
            tx.meta.innerInstructions.length <= 0
        ) {
            return;
        }
        /// We only care about the very last inner instruction as it contains the
        /// PublicTransactionEvent
        tx.meta.innerInstructions.forEach(ix => {
            if (ix.instructions.length > 0) {
                const ixInner = ix.instructions[ix.instructions.length - 1];
                // Type guard for partially parsed web3js types.
                if (
                    'data' in ixInner &&
                    ixInner.data &&
                    ixInner.programId.toBase58() === noopProgram.toBase58()
                ) {
                    const data = bs58.decode(ixInner.data);
                    const decodedEvent = deserializeFn(Buffer.from(data), tx);
                    if (decodedEvent !== null && decodedEvent !== undefined) {
                        transactions.push(decodedEvent);
                    }
                }
            }
        });
    });
    return transactions;
};
// TODO: make it type safe. have to reimplement the types from the IDL.
const parsePublicTransactionEventWithIdl = data => {
    const numericData = Buffer.from(data.map(byte => byte));
    try {
        return LightSystemProgram.program.coder.types.decode(
            'PublicTransactionEvent',
            numericData,
        );
    } catch (error) {
        console.error('Error deserializing event:', error);
        return null;
    }
};

async function getCompressedAccountsByOwnerTest(rpc, owner) {
    const unspentAccounts = await getCompressedAccountsForTest(rpc);
    const byOwner = unspentAccounts.filter(acc => acc.owner.equals(owner));
    return byOwner;
}
async function getCompressedAccountByHashTest(rpc, hash) {
    const unspentAccounts = await getCompressedAccountsForTest(rpc);
    return unspentAccounts.find(acc => bn(acc.hash).eq(hash));
}
async function getMultipleCompressedAccountsByHashTest(rpc, hashes) {
    const unspentAccounts = await getCompressedAccountsForTest(rpc);
    return unspentAccounts
        .filter(acc => hashes.some(hash => bn(acc.hash).eq(hash)))
        .sort((a, b) => b.leafIndex - a.leafIndex);
}
/// Returns all unspent compressed accounts
async function getCompressedAccountsForTest(rpc) {
    var _a, _b;
    const events = (await getParsedEvents(rpc)).reverse();
    const allOutputAccounts = [];
    const allInputAccountHashes = [];
    for (const event of events) {
        for (
            let index = 0;
            index < event.outputCompressedAccounts.length;
            index++
        ) {
            const account = event.outputCompressedAccounts[index];
            const merkleContext = {
                merkleTree: defaultTestStateTreeAccounts().merkleTree,
                nullifierQueue: defaultTestStateTreeAccounts().nullifierQueue,
                hash: event.outputCompressedAccountHashes[index],
                leafIndex: event.outputLeafIndices[index],
            };
            const withCtx = createCompressedAccountWithMerkleContext(
                merkleContext,
                account.compressedAccount.owner,
                account.compressedAccount.lamports,
                (_a = account.compressedAccount.data) !== null && _a !== void 0
                    ? _a
                    : undefined,
                (_b = account.compressedAccount.address) !== null &&
                    _b !== void 0
                    ? _b
                    : undefined,
            );
            allOutputAccounts.push(withCtx);
        }
        for (
            let index = 0;
            index < event.inputCompressedAccountHashes.length;
            index++
        ) {
            const hash = event.inputCompressedAccountHashes[index];
            allInputAccountHashes.push(bn(hash));
        }
    }
    const unspentAccounts = allOutputAccounts.filter(
        account =>
            !allInputAccountHashes.some(hash => hash.eq(bn(account.hash))),
    );
    unspentAccounts.sort((a, b) => b.leafIndex - a.leafIndex);
    return unspentAccounts;
}

const tokenProgramId = new web3_js.PublicKey(
    // TODO: can add check to ensure its consistent with the idl
    'cTokenmWW8bLPjZEBAUgYy3zKxQZW6VKi7bqNFEVv3m',
);
/** @internal */
function parseTokenLayoutWithIdl(compressedAccount) {
    if (compressedAccount.data === null) return null;
    const { data } = compressedAccount.data;
    if (data.length === 0) return null;
    if (compressedAccount.owner.toBase58() !== tokenProgramId.toBase58()) {
        throw new Error(
            `Invalid owner ${compressedAccount.owner.toBase58()} for token layout`,
        );
    }
    const decodedLayout = new anchor.BorshCoder(IDL).types.decode(
        'TokenData',
        Buffer.from(data),
    );
    return decodedLayout;
}
/**
 * parse compressed accounts of an event with token layout
 * @internal
 * TODO: refactor
 */
async function parseEventWithTokenTlvData(event) {
    const pubkeyArray = event.pubkeyArray;
    const outputHashes = event.outputCompressedAccountHashes;
    const outputCompressedAccountsWithParsedTokenData =
        event.outputCompressedAccounts.map((compressedAccount, i) => {
            var _a;
            const merkleContext = {
                merkleTree:
                    pubkeyArray[
                        event.outputCompressedAccounts[i].merkleTreeIndex
                    ],
                nullifierQueue:
                    // FIXME: fix make dynamic
                    defaultTestStateTreeAccounts().nullifierQueue,
                hash: outputHashes[i],
                leafIndex: event.outputLeafIndices[i],
            };
            if (!compressedAccount.compressedAccount.data)
                throw new Error('No data');
            const parsedData = parseTokenLayoutWithIdl(
                compressedAccount.compressedAccount,
            );
            if (!parsedData) throw new Error('Invalid token data');
            const withMerkleContext = createCompressedAccountWithMerkleContext(
                merkleContext,
                compressedAccount.compressedAccount.owner,
                compressedAccount.compressedAccount.lamports,
                compressedAccount.compressedAccount.data,
                (_a = compressedAccount.compressedAccount.address) !== null &&
                    _a !== void 0
                    ? _a
                    : undefined,
            );
            return {
                compressedAccount: withMerkleContext,
                parsed: parsedData,
            };
        });
    return {
        inputCompressedAccountHashes: event.inputCompressedAccountHashes,
        outputCompressedAccounts: outputCompressedAccountsWithParsedTokenData,
    };
}
/**
 * Retrieves all compressed token accounts for a given mint and owner.
 *
 * Note: This function is intended for testing purposes only. For production, use rpc.getCompressedTokenAccounts.
 *
 * @param events    Public transaction events
 * @param owner     PublicKey of the token owner
 * @param mint      PublicKey of the token mint
 */
async function getCompressedTokenAccounts(events) {
    const eventsWithParsedTokenTlvData = await Promise.all(
        events.map(event => parseEventWithTokenTlvData(event)),
    );
    /// strip spent compressed accounts if an output compressed account of tx n is
    /// an input compressed account of tx n+m, it is spent
    const allOutCompressedAccounts = eventsWithParsedTokenTlvData.flatMap(
        event => event.outputCompressedAccounts,
    );
    const allInCompressedAccountHashes = eventsWithParsedTokenTlvData.flatMap(
        event => event.inputCompressedAccountHashes,
    );
    const unspentCompressedAccounts = allOutCompressedAccounts.filter(
        outputCompressedAccount =>
            !allInCompressedAccountHashes.some(hash => {
                return (
                    JSON.stringify(hash) ===
                    JSON.stringify(
                        outputCompressedAccount.compressedAccount.hash,
                    )
                );
            }),
    );
    return unspentCompressedAccounts;
}
/** @internal */
async function getCompressedTokenAccountsByOwnerTest(rpc, owner, mint) {
    const events = await getParsedEvents(rpc);
    const compressedTokenAccounts = await getCompressedTokenAccounts(events);
    const accounts = compressedTokenAccounts.filter(
        acc => acc.parsed.owner.equals(owner) && acc.parsed.mint.equals(mint),
    );
    return {
        items: accounts.sort(
            (a, b) =>
                b.compressedAccount.leafIndex - a.compressedAccount.leafIndex,
        ),
        cursor: null,
    };
}
async function getCompressedTokenAccountsByDelegateTest(rpc, delegate, mint) {
    const events = await getParsedEvents(rpc);
    const compressedTokenAccounts = await getCompressedTokenAccounts(events);
    return {
        items: compressedTokenAccounts.filter(acc => {
            var _a;
            return (
                ((_a = acc.parsed.delegate) === null || _a === void 0
                    ? void 0
                    : _a.equals(delegate)) && acc.parsed.mint.equals(mint)
            );
        }),
        cursor: null,
    };
}
async function getCompressedTokenAccountByHashTest(rpc, hash) {
    const events = await getParsedEvents(rpc);
    const compressedTokenAccounts = await getCompressedTokenAccounts(events);
    const filtered = compressedTokenAccounts.filter(acc =>
        bn(acc.compressedAccount.hash).eq(hash),
    );
    if (filtered.length === 0) {
        throw new Error('No compressed account found');
    }
    return filtered[0];
}

/**
 * Returns a mock RPC instance for use in unit tests.
 *
 * @param lightWasm               Wasm hasher instance.
 * @param endpoint                RPC endpoint URL. Defaults to
 *                                'http://127.0.0.1:8899'.
 * @param proverEndpoint          Prover server endpoint URL. Defaults to
 *                                'http://localhost:3001'.
 * @param merkleTreeAddress       Address of the merkle tree to index. Defaults
 *                                to the public default test state tree.
 * @param nullifierQueueAddress   Optional address of the associated nullifier
 *                                queue.
 * @param depth                   Depth of the merkle tree.
 * @param log                     Log proof generation time.
 */
async function getTestRpc(
    lightWasm,
    endpoint = 'http://127.0.0.1:8899',
    compressionApiEndpoint = 'http://127.0.0.1:8784',
    proverEndpoint = 'http://127.0.0.1:3001',
    merkleTreeAddress,
    nullifierQueueAddress,
    depth,
    log = false,
) {
    const defaultAccounts = defaultTestStateTreeAccounts();
    return new TestRpc(
        endpoint,
        lightWasm,
        compressionApiEndpoint,
        proverEndpoint,
        undefined,
        {
            merkleTreeAddress: merkleTreeAddress || defaultAccounts.merkleTree,
            nullifierQueueAddress:
                nullifierQueueAddress || defaultAccounts.nullifierQueue,
            depth: depth || defaultAccounts.merkleTreeHeight,
            log,
        },
    );
}
/**
 * Simple mock rpc for unit tests that simulates the compression rpc interface.
 * Fetches, parses events and builds merkletree on-demand, i.e. it does not persist state.
 * Constraints:
 * - Can only index 1 merkletree
 * - Can only index up to 1000 transactions
 *
 * For advanced testing use photon: https://github.com/helius-labs/photon
 */
class TestRpc extends web3_js.Connection {
    /**
     * Establish a Compression-compatible JSON RPC mock-connection
     *
     * @param endpoint                  endpoint to the solana cluster (use for
     *                                  localnet only)
     * @param hasher                    light wasm hasher instance
     * @param compressionApiEndpoint    Endpoint to the compression server.
     * @param proverEndpoint            Endpoint to the prover server. defaults
     *                                  to endpoint
     * @param connectionConfig          Optional connection config
     * @param testRpcConfig             Config for the mock rpc
     */
    constructor(
        endpoint,
        hasher,
        compressionApiEndpoint,
        proverEndpoint,
        connectionConfig,
        testRpcConfig,
    ) {
        super(endpoint, connectionConfig || 'confirmed');
        this.log = false;
        this.compressionApiEndpoint = compressionApiEndpoint;
        this.proverEndpoint = proverEndpoint;
        const {
            merkleTreeAddress,
            nullifierQueueAddress,
            depth,
            log,
            addressTreeAddress,
            addressQueueAddress,
        } =
            testRpcConfig !== null && testRpcConfig !== void 0
                ? testRpcConfig
                : {};
        const {
            merkleTree,
            nullifierQueue,
            merkleTreeHeight,
            addressQueue,
            addressTree,
        } = defaultTestStateTreeAccounts();
        this.lightWasm = hasher;
        this.merkleTreeAddress =
            merkleTreeAddress !== null && merkleTreeAddress !== void 0
                ? merkleTreeAddress
                : merkleTree;
        this.nullifierQueueAddress =
            nullifierQueueAddress !== null && nullifierQueueAddress !== void 0
                ? nullifierQueueAddress
                : nullifierQueue;
        this.addressTreeAddress =
            addressTreeAddress !== null && addressTreeAddress !== void 0
                ? addressTreeAddress
                : addressTree;
        this.addressQueueAddress =
            addressQueueAddress !== null && addressQueueAddress !== void 0
                ? addressQueueAddress
                : addressQueue;
        this.depth =
            depth !== null && depth !== void 0 ? depth : merkleTreeHeight;
        this.log = log !== null && log !== void 0 ? log : false;
    }
    /**
     * Fetch the compressed account for the specified account hash
     */
    async getCompressedAccount(address, hash) {
        if (address) {
            throw new Error('address is not supported in test-rpc');
        }
        if (!hash) {
            throw new Error('hash is required');
        }
        const account = await getCompressedAccountByHashTest(this, hash);
        return account !== null && account !== void 0 ? account : null;
    }
    /**
     * Fetch the compressed balance for the specified account hash
     */
    async getCompressedBalance(address, hash) {
        if (address) {
            throw new Error('address is not supported in test-rpc');
        }
        if (!hash) {
            throw new Error('hash is required');
        }
        const account = await getCompressedAccountByHashTest(this, hash);
        if (!account) {
            throw new Error('Account not found');
        }
        return bn(account.lamports);
    }
    /**
     * Fetch the total compressed balance for the specified owner public key
     */
    async getCompressedBalanceByOwner(owner) {
        const accounts = await this.getCompressedAccountsByOwner(owner);
        return accounts.items.reduce(
            (acc, account) => acc.add(account.lamports),
            bn(0),
        );
    }
    /**
     * Fetch the latest merkle proof for the specified account hash from the
     * cluster
     */
    async getCompressedAccountProof(hash) {
        const proofs = await this.getMultipleCompressedAccountProofs([hash]);
        return proofs[0];
    }
    /**
     * Fetch all the account info for multiple compressed accounts specified by
     * an array of account hashes
     */
    async getMultipleCompressedAccounts(hashes) {
        return await getMultipleCompressedAccountsByHashTest(this, hashes);
    }
    /**
     * Ensure that the Compression Indexer has already indexed the transaction
     */
    async confirmTransactionIndexed(_slot) {
        return true;
    }
    /**
     * Fetch the latest merkle proofs for multiple compressed accounts specified
     * by an array account hashes
     */
    async getMultipleCompressedAccountProofs(hashes) {
        /// Build tree
        const events = await getParsedEvents(this).then(events =>
            events.reverse(),
        );
        const allLeaves = [];
        const allLeafIndices = [];
        for (const event of events) {
            for (
                let index = 0;
                index < event.outputCompressedAccounts.length;
                index++
            ) {
                const hash = event.outputCompressedAccountHashes[index];
                allLeaves.push(hash);
                allLeafIndices.push(event.outputLeafIndices[index]);
            }
        }
        const tree = new MerkleTree(
            this.depth,
            this.lightWasm,
            allLeaves.map(leaf => bn(leaf).toString()),
        );
        /// create merkle proofs and assemble return type
        const merkleProofs = [];
        for (let i = 0; i < hashes.length; i++) {
            const leafIndex = tree.indexOf(hashes[i].toString());
            const pathElements = tree.path(leafIndex).pathElements;
            const bnPathElements = pathElements.map(value => bn(value));
            const root = bn(tree.root());
            const merkleProof = {
                hash: hashes[i].toArray('be', 32),
                merkleTree: this.merkleTreeAddress,
                leafIndex: leafIndex,
                merkleProof: bnPathElements,
                nullifierQueue: this.nullifierQueueAddress,
                rootIndex: allLeaves.length,
                root: root,
            };
            merkleProofs.push(merkleProof);
        }
        /// Validate
        merkleProofs.forEach((proof, index) => {
            const leafIndex = proof.leafIndex;
            const computedHash = tree.elements()[leafIndex];
            const hashArr = bn(computedHash).toArray('be', 32);
            if (!hashArr.every((val, index) => val === proof.hash[index])) {
                throw new Error(
                    `Mismatch at index ${index}: expected ${proof.hash.toString()}, got ${hashArr.toString()}`,
                );
            }
        });
        return merkleProofs;
    }
    /**
     * Fetch all the compressed accounts owned by the specified public key.
     * Owner can be a program or user account
     */
    async getCompressedAccountsByOwner(owner, _config) {
        // TODO(swen): revisit
        // if (_config) {
        //     throw new Error(
        //         'dataSlice or filters are not supported in test-rpc. Please use rpc.ts instead.',
        //     );
        // }
        const accounts = await getCompressedAccountsByOwnerTest(this, owner);
        return {
            items: accounts,
            cursor: null,
        };
    }
    /**
     * Fetch the latest compression signatures on the cluster. Results are
     * paginated.
     */
    async getLatestCompressionSignatures(_cursor, _limit) {
        throw new Error(
            'getLatestNonVotingSignaturesWithContext not supported in test-rpc',
        );
    }
    /**
     * Fetch the latest non-voting signatures on the cluster. Results are
     * not paginated.
     */
    async getLatestNonVotingSignatures(_limit) {
        throw new Error(
            'getLatestNonVotingSignaturesWithContext not supported in test-rpc',
        );
    }
    /**
     * Fetch all the compressed token accounts owned by the specified public
     * key. Owner can be a program or user account
     */
    async getCompressedTokenAccountsByOwner(owner, options) {
        return await getCompressedTokenAccountsByOwnerTest(
            this,
            owner,
            options.mint,
        );
    }
    /**
     * Fetch all the compressed accounts delegated to the specified public key.
     */
    async getCompressedTokenAccountsByDelegate(delegate, options) {
        return await getCompressedTokenAccountsByDelegateTest(
            this,
            delegate,
            options.mint,
        );
    }
    /**
     * Fetch the compressed token balance for the specified account hash
     */
    async getCompressedTokenAccountBalance(hash) {
        const account = await getCompressedTokenAccountByHashTest(this, hash);
        return { amount: bn(account.parsed.amount) };
    }
    /**
     * Fetch all the compressed token balances owned by the specified public
     * key. Can filter by mint
     */
    async getCompressedTokenBalancesByOwner(publicKey, options) {
        const accounts = await getCompressedTokenAccountsByOwnerTest(
            this,
            publicKey,
            options.mint,
        );
        return {
            items: accounts.items.map(account => ({
                balance: bn(account.parsed.amount),
                mint: account.parsed.mint,
            })),
            cursor: null,
        };
    }
    /**
     * Returns confirmed signatures for transactions involving the specified
     * account hash forward in time from genesis to the most recent confirmed
     * block
     *
     * @param hash queried account hash
     */
    async getCompressionSignaturesForAccount(hash) {
        throw new Error(
            'getCompressionSignaturesForAccount not implemented in test-rpc',
        );
    }
    /**
     * Fetch a confirmed or finalized transaction from the cluster. Return with
     * CompressionInfo
     */
    async getTransactionWithCompressionInfo(signature) {
        throw new Error('getCompressedTransaction not implemented in test-rpc');
    }
    /**
     * Returns confirmed signatures for transactions involving the specified
     * address forward in time from genesis to the most recent confirmed
     * block
     *
     * @param address queried compressed account address
     */
    async getCompressionSignaturesForAddress(_address) {
        throw new Error('getSignaturesForAddress3 not implemented');
    }
    /**
     * Returns confirmed signatures for compression transactions involving the
     * specified account owner forward in time from genesis to the
     * most recent confirmed block
     *
     * @param owner queried owner public key
     */
    async getCompressionSignaturesForOwner(owner) {
        throw new Error('getSignaturesForOwner not implemented');
    }
    /**
     * Returns confirmed signatures for compression transactions involving the
     * specified token account owner forward in time from genesis to the most
     * recent confirmed block
     */
    async getCompressionSignaturesForTokenOwner(owner) {
        throw new Error('getSignaturesForTokenOwner not implemented');
    }
    /**
     * Fetch the current indexer health status
     */
    async getIndexerHealth() {
        return 'ok';
    }
    /**
     * Fetch the current slot that the node is processing
     */
    async getIndexerSlot() {
        return 1;
    }
    /**
     * Fetch the latest address proofs for new unique addresses specified by an
     * array of addresses.
     *
     * the proof states that said address have not yet been created in respective address tree.
     * @param addresses Array of BN254 new addresses
     * @returns Array of validity proofs for new addresses
     */
    async getMultipleNewAddressProofs(addresses) {
        /// Build tree
        const indexedArray = IndexedArray.default();
        const allAddresses = [];
        indexedArray.init();
        const hashes = [];
        // TODO(crank): add support for cranked address tree in 'allAddresses'.
        // The Merkle tree root doesnt actually advance beyond init() unless we
        // start emptying the address queue.
        for (let i = 0; i < allAddresses.length; i++) {
            indexedArray.append(bn(allAddresses[i]));
        }
        for (let i = 0; i < indexedArray.elements.length; i++) {
            const hash = indexedArray.hashElement(this.lightWasm, i);
            hashes.push(bn(hash));
        }
        const tree = new MerkleTree(
            this.depth,
            this.lightWasm,
            hashes.map(hash => bn(hash).toString()),
        );
        /// Creates proof for each address
        const newAddressProofs = [];
        for (let i = 0; i < addresses.length; i++) {
            const [lowElement] = indexedArray.findLowElement(addresses[i]);
            if (!lowElement) throw new Error('Address not found');
            const leafIndex = lowElement.index;
            const pathElements = tree.path(leafIndex).pathElements;
            const bnPathElements = pathElements.map(value => bn(value));
            const higherRangeValue = indexedArray.get(
                lowElement.nextIndex,
            ).value;
            const root = bn(tree.root());
            const proof = {
                root,
                rootIndex: 3,
                value: addresses[i],
                leafLowerRangeValue: lowElement.value,
                leafHigherRangeValue: higherRangeValue,
                nextIndex: bn(lowElement.nextIndex),
                merkleProofHashedIndexedElementLeaf: bnPathElements,
                indexHashedIndexedElementLeaf: bn(lowElement.index),
                merkleTree: this.addressTreeAddress,
                nullifierQueue: this.addressQueueAddress,
            };
            newAddressProofs.push(proof);
        }
        return newAddressProofs;
    }
    /**
     * Advanced usage of getValidityProof: fetches ZKP directly from a custom
     * non-rpcprover. Note: This uses the proverEndpoint specified in the
     * constructor. For normal usage, please use {@link getValidityProof}
     * instead.
     *
     * Note: Use RPC class for forested trees. TestRpc is only for custom
     * testing purposes.
     */
    async getValidityProofDirect(hashes = [], newAddresses = []) {
        return this.getValidityProof(hashes, newAddresses);
    }
    /**
     * @deprecated This method is not available for TestRpc. Please use
     * {@link getValidityProof} instead.
     */
    async getValidityProofAndRpcContext(hashes = [], newAddresses = []) {
        if (newAddresses.some(address => !(address instanceof anchor.BN))) {
            throw new Error('AddressWithTree is not supported in test-rpc');
        }
        return {
            value: await this.getValidityProofV0(hashes, newAddresses),
            context: { slot: 1 },
        };
    }
    /**
     * Fetch the latest validity proof for (1) compressed accounts specified by
     * an array of account hashes. (2) new unique addresses specified by an
     * array of addresses.
     *
     * Validity proofs prove the presence of compressed accounts in state trees
     * and the non-existence of addresses in address trees, respectively. They
     * enable verification without recomputing the merkle proof path, thus
     * lowering verification and data costs.
     *
     * @param hashes        Array of BN254 hashes.
     * @param newAddresses  Array of BN254 new addresses.
     * @returns             validity proof with context
     */
    async getValidityProof(hashes = [], newAddresses = []) {
        if (newAddresses.some(address => !(address instanceof anchor.BN))) {
            throw new Error('AddressWithTree is not supported in test-rpc');
        }
        let validityProof;
        if (hashes.length === 0 && newAddresses.length === 0) {
            throw new Error(
                'Empty input. Provide hashes and/or new addresses.',
            );
        } else if (hashes.length > 0 && newAddresses.length === 0) {
            /// inclusion
            const merkleProofsWithContext =
                await this.getMultipleCompressedAccountProofs(hashes);
            const inputs = convertMerkleProofsWithContextToHex(
                merkleProofsWithContext,
            );
            const compressedProof = await proverRequest(
                this.proverEndpoint,
                'inclusion',
                inputs,
                this.log,
            );
            validityProof = {
                compressedProof,
                roots: merkleProofsWithContext.map(proof => proof.root),
                rootIndices: merkleProofsWithContext.map(
                    proof => proof.rootIndex,
                ),
                leafIndices: merkleProofsWithContext.map(
                    proof => proof.leafIndex,
                ),
                leaves: merkleProofsWithContext.map(proof => bn(proof.hash)),
                merkleTrees: merkleProofsWithContext.map(
                    proof => proof.merkleTree,
                ),
                nullifierQueues: merkleProofsWithContext.map(
                    proof => proof.nullifierQueue,
                ),
            };
        } else if (hashes.length === 0 && newAddresses.length > 0) {
            /// new-address
            const newAddressProofs =
                await this.getMultipleNewAddressProofs(newAddresses);
            const inputs =
                convertNonInclusionMerkleProofInputsToHex(newAddressProofs);
            const compressedProof = await proverRequest(
                this.proverEndpoint,
                'new-address',
                inputs,
                this.log,
            );
            validityProof = {
                compressedProof,
                roots: newAddressProofs.map(proof => proof.root),
                // TODO(crank): make dynamic to enable forester support in
                // test-rpc.ts. Currently this is a static root because the
                // address tree doesn't advance.
                rootIndices: newAddressProofs.map(_ => 3),
                leafIndices: newAddressProofs.map(proof =>
                    proof.indexHashedIndexedElementLeaf.toNumber(),
                ),
                leaves: newAddressProofs.map(proof => bn(proof.value)),
                merkleTrees: newAddressProofs.map(proof => proof.merkleTree),
                nullifierQueues: newAddressProofs.map(
                    proof => proof.nullifierQueue,
                ),
            };
        } else if (hashes.length > 0 && newAddresses.length > 0) {
            /// combined
            const merkleProofsWithContext =
                await this.getMultipleCompressedAccountProofs(hashes);
            const inputs = convertMerkleProofsWithContextToHex(
                merkleProofsWithContext,
            );
            const newAddressProofs =
                await this.getMultipleNewAddressProofs(newAddresses);
            const newAddressInputs =
                convertNonInclusionMerkleProofInputsToHex(newAddressProofs);
            const compressedProof = await proverRequest(
                this.proverEndpoint,
                'combined',
                [inputs, newAddressInputs],
                this.log,
            );
            validityProof = {
                compressedProof,
                roots: merkleProofsWithContext
                    .map(proof => proof.root)
                    .concat(newAddressProofs.map(proof => proof.root)),
                rootIndices: merkleProofsWithContext
                    .map(proof => proof.rootIndex)
                    // TODO(crank): make dynamic to enable forester support in
                    // test-rpc.ts. Currently this is a static root because the
                    // address tree doesn't advance.
                    .concat(newAddressProofs.map(_ => 3)),
                leafIndices: merkleProofsWithContext
                    .map(proof => proof.leafIndex)
                    .concat(
                        newAddressProofs.map(proof =>
                            proof.indexHashedIndexedElementLeaf.toNumber(),
                        ),
                    ),
                leaves: merkleProofsWithContext
                    .map(proof => bn(proof.hash))
                    .concat(newAddressProofs.map(proof => bn(proof.value))),
                merkleTrees: merkleProofsWithContext
                    .map(proof => proof.merkleTree)
                    .concat(newAddressProofs.map(proof => proof.merkleTree)),
                nullifierQueues: merkleProofsWithContext
                    .map(proof => proof.nullifierQueue)
                    .concat(
                        newAddressProofs.map(proof => proof.nullifierQueue),
                    ),
            };
        } else throw new Error('Invalid input');
        return validityProof;
    }
    async getValidityProofV0(hashes = [], newAddresses = []) {
        /// TODO(swen): add support for custom trees
        return this.getValidityProof(
            hashes.map(hash => hash.hash),
            newAddresses.map(address => address.address),
        );
    }
}

exports.ADDRESS_QUEUE_ROLLOVER_FEE = ADDRESS_QUEUE_ROLLOVER_FEE;
exports.ADDRESS_TREE_NETWORK_FEE = ADDRESS_TREE_NETWORK_FEE;
exports.ALICE = ALICE;
exports.AccountCompressionIDL = IDL$2;
exports.AccountProofResult = AccountProofResult;
exports.BOB = BOB;
exports.BalanceResult = BalanceResult;
exports.CHARLIE = CHARLIE;
exports.CompressedAccountResult = CompressedAccountResult;
exports.CompressedAccountsByOwnerResult = CompressedAccountsByOwnerResult;
exports.CompressedTokenAccountResult = CompressedTokenAccountResult;
exports.CompressedTokenAccountsByOwnerOrDelegateResult =
    CompressedTokenAccountsByOwnerOrDelegateResult;
exports.CompressedTransactionResult = CompressedTransactionResult;
exports.CreateUtxoError = CreateUtxoError;
exports.DAVE = DAVE;
exports.DEFAULT_MERKLE_TREE_HEIGHT = DEFAULT_MERKLE_TREE_HEIGHT;
exports.DEFAULT_MERKLE_TREE_ROOTS = DEFAULT_MERKLE_TREE_ROOTS;
exports.DEFAULT_ZERO = DEFAULT_ZERO;
exports.FIELD_SIZE = FIELD_SIZE;
exports.HIGHEST_ADDRESS_PLUS_ONE = HIGHEST_ADDRESS_PLUS_ONE;
exports.HashError = HashError;
exports.HealthResult = HealthResult;
exports.IndexedArray = IndexedArray;
exports.IndexedElement = IndexedElement;
exports.IndexedElementBundle = IndexedElementBundle;
exports.LatestNonVotingSignaturesResult = LatestNonVotingSignaturesResult;
exports.LatestNonVotingSignaturesResultPaginated =
    LatestNonVotingSignaturesResultPaginated;
exports.LightCompressedTokenIDL = IDL;
exports.LightRegistryIDL = IDL$1;
exports.LightSystemIDL = IDL$3;
exports.LightSystemProgram = LightSystemProgram;
exports.LookupTableError = LookupTableError;
exports.MerkeProofResult = MerkeProofResult;
exports.MerkleTree = MerkleTree;
exports.MerkleTreeError = MerkleTreeError;
exports.MultipleCompressedAccountsResult = MultipleCompressedAccountsResult;
exports.MultipleMerkleProofsResult = MultipleMerkleProofsResult;
exports.NativeBalanceResult = NativeBalanceResult;
exports.NewAddressProofResult = NewAddressProofResult;
exports.ProofError = ProofError;
exports.Rpc = Rpc;
exports.RpcError = RpcError;
exports.STATE_MERKLE_TREE_NETWORK_FEE = STATE_MERKLE_TREE_NETWORK_FEE;
exports.STATE_MERKLE_TREE_ROLLOVER_FEE = STATE_MERKLE_TREE_ROLLOVER_FEE;
exports.SelectInUtxosError = SelectInUtxosError;
exports.SignatureListResult = SignatureListResult;
exports.SignatureListWithCursorResult = SignatureListWithCursorResult;
exports.SlotResult = SlotResult;
exports.TRANSACTION_MERKLE_TREE_ROLLOVER_THRESHOLD =
    TRANSACTION_MERKLE_TREE_ROLLOVER_THRESHOLD;
exports.TestRpc = TestRpc;
exports.TokenBalanceListResult = TokenBalanceListResult;
exports.TokenBalanceResult = TokenBalanceResult;
exports.TokenDataResult = TokenDataResult;
exports.UTXO_MERGE_MAXIMUM = UTXO_MERGE_MAXIMUM;
exports.UTXO_MERGE_THRESHOLD = UTXO_MERGE_THRESHOLD;
exports.UtilsError = UtilsError;
exports.UtxoError = UtxoError;
exports.ValidityProofResult = ValidityProofResult;
exports.accountCompressionProgram = accountCompressionProgram;
exports.addressQueue = addressQueue;
exports.addressTree = addressTree;
exports.airdropSol = airdropSol;
exports.bn = bn;
exports.bufToDecStr = bufToDecStr;
exports.buildAndSignTx = buildAndSignTx;
exports.buildTx = buildTx;
exports.byteArrayToKeypair = byteArrayToKeypair;
exports.checkValidityProofShape = checkValidityProofShape;
exports.compress = compress;
exports.confirmConfig = confirmConfig;
exports.confirmTransaction = confirmTransaction;
exports.confirmTx = confirmTx;
exports.convertMerkleProofsWithContextToHex =
    convertMerkleProofsWithContextToHex;
exports.convertNonInclusionMerkleProofInputsToHex =
    convertNonInclusionMerkleProofInputsToHex;
exports.createAccount = createAccount;
exports.createAccountWithLamports = createAccountWithLamports;
exports.createBN254 = createBN254;
exports.createCompressedAccount = createCompressedAccount;
exports.createCompressedAccountWithMerkleContext =
    createCompressedAccountWithMerkleContext;
exports.createMerkleContext = createMerkleContext;
exports.createRpc = createRpc;
exports.createRpcResult = createRpcResult;
exports.decompress = decompress;
exports.dedupeSigner = dedupeSigner;
exports.defaultStaticAccounts = defaultStaticAccounts;
exports.defaultStaticAccountsStruct = defaultStaticAccountsStruct;
exports.defaultTestStateTreeAccounts = defaultTestStateTreeAccounts;
exports.deriveAddress = deriveAddress;
exports.encodeBN254toBase58 = encodeBN254toBase58;
exports.getAccountCompressionAuthority = getAccountCompressionAuthority;
exports.getConnection = getConnection;
exports.getIndexOrAdd = getIndexOrAdd;
exports.getParsedEvents = getParsedEvents;
exports.getRegisteredProgramPda = getRegisteredProgramPda;
exports.getTestKeypair = getTestKeypair;
exports.getTestRpc = getTestRpc;
exports.hashToBn254FieldSizeBe = hashToBn254FieldSizeBe;
exports.jsonRpcResult = jsonRpcResult;
exports.jsonRpcResultAndContext = jsonRpcResultAndContext;
exports.lightProgram = lightProgram;
exports.merkletreePubkey = merkletreePubkey;
exports.negateAndCompressProof = negateAndCompressProof;
exports.newAccountWithLamports = newAccountWithLamports;
exports.noopProgram = noopProgram;
exports.nullifierQueuePubkey = nullifierQueuePubkey;
exports.packCompressedAccounts = packCompressedAccounts;
exports.packNewAddressParams = packNewAddressParams;
exports.padOutputStateMerkleTrees = padOutputStateMerkleTrees;
exports.parseAccountData = parseAccountData;
exports.parseEvents = parseEvents;
exports.parsePublicTransactionEventWithIdl = parsePublicTransactionEventWithIdl;
exports.pipe = pipe;
exports.placeholderValidityProof = placeholderValidityProof;
exports.proofFromJsonStruct = proofFromJsonStruct;
exports.proverRequest = proverRequest;
exports.pushUniqueItems = pushUniqueItems;
exports.rpcRequest = rpcRequest;
exports.selectMinCompressedSolAccountsForTransfer =
    selectMinCompressedSolAccountsForTransfer;
exports.sendAndConfirmTx = sendAndConfirmTx;
exports.sleep = sleep;
exports.sumUpLamports = sumUpLamports;
exports.toAccountMetas = toAccountMetas;
exports.toArray = toArray$1;
exports.toCamelCase = toCamelCase;
exports.toHex = toHex;
exports.toUnixTimestamp = toUnixTimestamp;
exports.transfer = transfer;
exports.useWallet = useWallet;
exports.validateSameOwner = validateSameOwner;
exports.validateSufficientBalance = validateSufficientBalance;
//# sourceMappingURL=index.cjs.map
